import React, { useState } from "react";
import "./ProfileForm.scss";
import InputField from "../../UI/InputField/InputField";
import DropdownSearch from "../../UI/DropdownSearch/DropdownSearch";
import FamilyMember, { IFamilyMember } from "../FamilyMember/FamilyMember";
import Tag from "../../UI/Tag/Tag";
import Radio from "../../UI/Radio/Radio";
import {
  fatherSpouseRelationList,
  dateOptionsList,
  monthOptionsList,
  yearOptionsList,
  addressType,
  clientGroup4,
  retailAccCategory,
  employeeAccCategory,
  emailVerificationBody,
  dashboardUrl,
  poaTrueMsg,
  poaFalseMsg,
  PCGAccCategory
} from "../../utils/constants";
import Toggle from "../../UI/Toggle/Toggle";
import Button from "../../UI/Button/Button";
import InfoModal from "../../UI/InfoModal/InfoModal";
import DeviceContext from "../../Services/identifyDevice";
import {
  AGetEnumList,
  // AGetRelationshipData,
  ASaveRelationshipData,
  ASaveKycDetails,
  AGetKycDetails,
  ARedisDigilockerDoc,
  AGetOcrResponseDetails,
  AGetDocumentidByApplicationid,
  AGetArea,
  AGetFullAddress,
  ASavePinCity,
  AGetCityByPincode,
} from "../../Services/dashboard/profileApiService";
import { IListObj, ITokenObj } from "../../types/genericTypes";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
import GlobalStore from "../../store/globalStore";
import {
  convertEnumIntoIObj,
  completeModuleStatus,
  utmDurationInfoObj,
  incompleteStageNavigation,
  splitFullName,
  capitalizeWords,
  ageCalculator,
} from "../../Services/globalService";
import RegOtp from "../../Registration/RegOtp/RegOtp";
import { phoneNo, emailRegex } from "../../utils/regex";
import {
  AGetCities,
  AGetEmailOtp,
  AGetMobileOtp,
  AValidateEmailOtp,
  AValidateMobileOtp,
} from "../../Services/registration/registrationApiService";
import AddressField, {
  IAddressFormat,
  addressErrorObj,
  CkycAddressFormat,
} from "../AddressField/AddressField";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import NriDetailForm, {
  INriDetailField,
  initialNriDetail,
} from "../NriDetailForm/NriDetailForm";
import { getProfileDetailsFromAadhar } from "../../Registration/ShareAdd/ShareAdd";
import { AGetEmployeeByPan } from "../../Services/registration/panDobApiService";
import moment from "moment";
import Calender from "../../UI/Calender/Calender";
import gtmService from "../../Services/gtmService";
import mixpanelService from "../../Services/mixpanelService";
import mixpanelEvents, { getScreenName } from "../../../config/mixpanelEvents";
import useQuery from "../../../customHooks/useQuery";
import cleverTapEvents from "../../../config/cleverTapEvents";
import { ClevertapService } from "../../Services/clevertapService";
import { repairAddressWithConditions } from "../../../components/utils/validation";
import { AppsFlyerService } from "../../Services/appsFlyerService";
import appsFlyerEvents from "../../../config/appsFlyerEvents";
import config from "../../../config/domain";
import nomineeDocsIds from "../../../config/nomineeDocsId";
import DocumentBrowse, {
  DocDetailFormat,
} from "../../UI/DocumentBrowse/DocumentBrowse";
import { AUploadDocument } from "../../Services/dashboard/brokerageServices";
import { pan } from "../../utils/regex";
import { errorMessage } from "../../utils/errorMessage";
import { AGetDocStatus } from "../../Services/dashboard/docVerificationAPIServices";
import Checkbox from "../../UI/Checkbox/Checkbox";
import { nomineeMatch } from "../ClientNomineeGuardianMatch/ClientNomineeGuardianMatch";
import {
  NOMINEE_IDENTIFICATION_LIST,
  buildIdentificationDetail,
  validateNomineesInvalid,
  getMissingNomineeFields,
  getMissingGuardianFields,
  ADDRESS_FIELD_LABELS,
} from "../NomineeHelpers/nomineeHelpers";
import { errorCode, errorMsg } from "../../../ErrorCode/ErrorCode";
import { checkESignSubmitted } from "../../utils/eSignSubmitHandler";
import { AGetStageCompletionStatus } from "../../Services/registration/continueApiService";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
// import useReactPath from "../../../pathhook";
export interface ProfileFormProps { }

export const initialAddressObj: IAddressFormat = {
  addressLine1: "",
  City: "",
  Country: "",
  District: "",
  PinCode: "",
  State: "",
  Area: "",
  CountryCode: 0,
  StateCode: 0,
};

export const ckycAddressObj: CkycAddressFormat = {
  addressLine1: "",
  corrAddress: "",
  sameAsPermanent: true,
  city: "",
  country: "",
  district: "",
  pincode: "",
  corrPincode: "",
  state: "",
  area: "",
  countrycode: 0,
  statecode: 0,
  corrCountry: "",
  perCountry: "",
};
const bankAccountType = [
  // {
  //   display: "BSDA Resident Demat and Trading Account",
  //   value: 1,
  // },
  {
    display: "BSDA Resident Demat and Trading Account",
    value: 2,
  },
];

export const initialDocObj: DocDetailFormat = {
  id: "",
  disable: false,
  uploadPer: 0,
  hideProgress: false,
  fileName: "",
  showFile: true,
  imgUrl: "",
  documentcategory: "",
  documentCategoryId: "",
  documentId: 0,
  mimeType: "",
  base64: "",
  isWatsappFlag: false,
};

export interface RelationshipData {
  [key: string]: Array<IFamilyMember>;
}

const ProfileForm: React.FC<ProfileFormProps> = () => {
  // Fetch query params for clervertap
  const isMinor = GlobalStore.entitySubType == 'Minor'
  const guardianTitle = isMinor ? 'Guardian’s' : ''
  const quryParams = useQuery();
  const UTM_SOURCE = quryParams.get("utm_source")
    ? quryParams.get("utm_source")
    : "";
  const UTM_MEDIUM = quryParams.get("utm_medium")
    ? quryParams.get("utm_medium")
    : "";
  const UTM_CAMPAIGN = quryParams.get("utm_campaign")
    ? quryParams.get("utm_campaign")
    : "";

  // const history = useHistory();
  const navigate = useNavigate()

  const [errors, setErrors] = React.useState<{
    [key: string]: string | undefined;
  }>({});
  const [errCode, setErrCode] = React.useState<number | string>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [startTime, setStartTime] = React.useState<Date>(new Date());
  const [ocrDetails, setOcrDetails] = React.useState({ address: "" });

  const [isSeniorCitizen, setIsSeniorCitizen] = React.useState<boolean>(false);
  const [occupationList, setOccupationList] = React.useState<Array<IListObj>>(
    []
  );
  let userId = "0";
  const tokenObj: string = decryptJwtToken(GlobalStore?.token);
  if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
    let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
    userId = tokenMainObj?.UserId?.toString();
  }
  const [incomeList, setIncomeList] = React.useState<Array<IListObj>>([]);
  const [educationList, setEducationList] = React.useState<Array<IListObj>>([]);
  const [maritalStatusList, setMaritalStatusList] = React.useState<
    Array<IListObj>
  >([]);
  const [genderList, setGenderList] = React.useState<Array<IListObj>>([]);
  const [relationshipList, setRelationshipList] = React.useState<
    Array<IListObj>
  >([]);
  const [familyRelationList, setFamilyRelationList] = React.useState<
    Array<IListObj>
  >([]);
  const [familyRelationListMail, setFamilyRelationListMail] = React.useState<
    Array<IListObj>
  >([]);
  const [originalRelationList, setOriginalRelationList] = React.useState<
    Array<IListObj>
  >([]);
  const [titlePrefixList, setTitlePrefixList] = React.useState<Array<IListObj>>(
    []
  );
  const [countryList, setCountryList] = React.useState<Array<IListObj>>([]);
  const [nriCountryList, setNriCountryList] = React.useState<Array<IListObj>>([]);

  const [relationshipData, setRelationshipData] =
    React.useState<RelationshipData>({});
  const [relationshipDataCount, setRelationshipDataCount] = React.useState<any>(
    {}
  );

  const [showExplain, setShowExplain] = React.useState<boolean>(false);
  const [showNominee, setShowNominee] = React.useState<boolean>(false);
  const [numOfNominee, setNumOfNominee] = React.useState<number>(0);

  const [email, setEmail] = React.useState<string>(GlobalStore.user.email);
  const [phone, setPhone] = React.useState<string>(GlobalStore.user.mobile);
  const [showEmailBtn, setShowEmailBtn] = React.useState<boolean>(true);
  const [showMobileBtn, setShowMobileBtn] = React.useState<boolean>(false);
  const [showEmailOtp, setShowEmailOtp] = React.useState<boolean>(false);
  const [showMobileOtp, setShowMobileOtp] = React.useState<boolean>(false);
  const [disableOtp, setDisableOtp] = React.useState<boolean>(false);
  const [isEmailVerified, setIsEmailVerified] = React.useState<boolean>(true);
  const [isMobileVerified, setIsMobileVerified] = React.useState<boolean>(true);
  const [invalidOtp, setInvalidOtp] = React.useState<boolean>(false);
  const localProductCode = localStorage.getItem("productCode");
  const [isGuardianMinor, setIsGuardiaMinor] = React.useState<boolean>(false);
  const [permanentAddress, setPermanentAddress] =
    React.useState<IAddressFormat>({ ...initialAddressObj });
  const [kycAddress, setKycAddress] = React.useState<IAddressFormat>({
    ...initialAddressObj,
  });
  const [correspondanceAddress, setCorrespondanceAddress] =
    React.useState<IAddressFormat>({ ...initialAddressObj });
  const [nomineeAddress, setNomineeAddress] = React.useState<IAddressFormat>({
    ...initialAddressObj,
  });
  const [guardianAddress, setGuardianAddress] = React.useState<IAddressFormat>({
    ...initialAddressObj,
  });
  const [nomineeDocuments, setNomineeDocuments] = React.useState<any>({
    nomineeOne: {},
    nomineeTwo: {},
    nomineeThree: {},
  });
  const [nomineeDocumentsArray, setNomineeDocumentsArray] = React.useState<any>(
    []
  );
  // check if new docs flag
  let [newUploads, setNewUploads] = React.useState<any>([
    {
      isPhoto: false,
      isSiganture: false,
      guardian: { isPhoto: false, isSignature: false },
    },
    {
      isPhoto: false,
      isSiganture: false,
      guardian: { isPhoto: false, isSignature: false },
    },
    {
      isPhoto: false,
      isSiganture: false,
      guardian: { isPhoto: false, isSignature: false },
    },
  ]);

  const [permErrorObj, setPermErrorObj] = React.useState<{
    [key in keyof IAddressFormat]?: string;
  }>({
    ...addressErrorObj,
  });
  const [corrErrorObj, setCorrErrorObj] = React.useState<{
    [key in keyof IAddressFormat]?: string;
  }>({
    ...addressErrorObj,
  });
  const [nomErrorObj, setNomErrorObj] = React.useState<{
    [key in keyof IAddressFormat]?: string;
  }>({
    ...addressErrorObj,
  });
  const [guardErrorObj, setGuardErrorObj] = React.useState<{
    [key in keyof IAddressFormat]?: string;
  }>({
    ...addressErrorObj,
  });

  const [sameAsPermanent, setSameAsPermanent] = React.useState<boolean>(true);
  const [sameAsNominee, setSameAsNominee] = React.useState<boolean>(false);

  const [isNomineeMinor, setIsNomineeMinor] = React.useState<boolean>(false);

  const [gender, setGender] = React.useState<string>(
    GlobalStore.personaldetails.gender || ""
  );
  const [maritalStatus, setMaritalStatus] = React.useState<string>("S");
  const [fatherOrSpouse, setFatherOrSpouse] = React.useState<string>("01");
  const [fatherOrSpouseName, setFatherOrSpouseName] = React.useState<string>(
    GlobalStore.personaldetails.fsfullName || ""
  );
  const [kycFatherName, setKycFatherName] = React.useState<string>("");
  const [motherName, setMotherName] = React.useState<string>(
    GlobalStore.personaldetails.motherfullName || ""
  );

  const [eduQualification, setEduQulification] = React.useState<string>("");
  const [occupation, setOccupation] = React.useState<string>("");
  const [politicalVal, setPoliticalVal] = React.useState<"0" | "1" | "2">("0");
  const [indianResident, setIndianResident] = React.useState<boolean>(true);
  const [annualIncome, setAnnualIncome] = React.useState<string>("");
  const [netWorth, setNetWorth] = React.useState<string>("");
  const [placeOfBirth, setPlaceOfBirth] = React.useState<string>("");
  const [disability, setDisability] = React.useState<string>("0");
  const [periodicSettlement, setPeriodicSettlement] = React.useState<"1" | "2">(
    "2"
  );

  const [nomDob, setNomDob] = React.useState<Date>();

  const [nomTitle, setNomTitle] = React.useState<string>("");
  const [nomFullName, setNomFullName] = React.useState<string>("");
  const [nomRelation, setNomRelation] = React.useState<string>("");
  const [nomRelationOther, setNomRelationOther] = React.useState<string>("");
  const [validPan, setValidPan] = React.useState<any>([]);

  // New nominee state for multiple nominee functionality
  const [nomiDetails, setNomiDetails] = React.useState<any>([]);

  const [guardTitle, setGuardTitle] = React.useState<string>("");
  const [guardFullName, setGuardFullName] = React.useState<string>("");
  const [guardRelation, setGuardRelation] = React.useState<string>("");
  const [guardRelationOther, setGuardRelationOther] =
    React.useState<string>("");

  const [guardEduQualification, setGuardEduQulification] =
    React.useState<string>("");
  const [guardOccupation, setGuardOccupation] = React.useState<string>("");
  const [guardPoliticalVal, setGuardPoliticalVal] = React.useState<
    "0" | "1" | "2"
  >("0");
  const [guardAnnualIncome, setGuardAnnualIncome] = React.useState<string>("");
  const [guardNetWorth, setGuardNetWorth] = React.useState<string>("");
  const [guardPlaceOfBirth, setGuardPlaceOfBirth] = React.useState<string>("");

  const [nriDetailsObj, setNriDetailsObj] = React.useState<INriDetailField>({
    ...initialNriDetail,
  });
  // const [hideAddressKra, setHideAddressKra] = React.useState<boolean>(false);
  // const [hideAddressKyc, setHideAddressKyc] = React.useState<boolean>(false);
  const [hideAddress, setHideAddress] = React.useState<boolean>(false);

  const [staffCode, setStaffCode] = React.useState<string>("");
  const [aadharName, setAadharName] = React.useState<string>("");
  const [isAadharMasked, setIsAadharMasked] = React.useState<boolean>(true);
  const [nomIdentification, setNomIdentification] = React.useState<number>(0);
  const [nomPhotoId, setNomPhotoId] = React.useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [photoBase64, setPhotoBase64] = React.useState<string>("");
  const [nomAdharNum, setNomAdharNum] = React.useState<string>("");
  const [nomBankAccountNum, setNomBankAccountNum] = React.useState<string>("");
  const [nomDematAccountNum, setNomDematAccountNum] =
    React.useState<string>("");
  const [globalError, setGlobalError] = React.useState<string>("");
  const [addlIdentDetailsValue, setAddlIdentDetailsValue] = useState(true);
  const [regectedAddressDoc, setRegectedAddressDoc] = React.useState(false);

  const [POAType, setPOAType] = React.useState(true);
  const [POATypeMsg, setPOATypeMsg] = React.useState(poaTrueMsg);
  const [defaultAccountType, setDefaultAccountType] = React.useState<string>(
    "BSDA Resident Demat and Trading Account"
  );
  const [defaultSetting, setDefaultSetting] = React.useState<boolean>(false);

  const [isEditMode, setIsEditMode] = React.useState(false);
  const [errorMatchDetails, setErrorMatchDetails] = React.useState<any>("");
  const [accountTypeToggle, setAccountTypeToggle] =
    React.useState<boolean>(false);
  const [acknowledged, setAcknowledged] = React.useState(true);
  const [nationalityList, setNationalityList] = React.useState<Array<IListObj>>([]);
  const [nationalityCode, setNationalityCode] = useState('')
  const [disabilityList, setDisabilityList] = useState<any>([])
  const [stageCompleteStatus, setStageCompleteStatus] = useState<any>()

  // TODO: Photo and Signature option is listed but upload is not fully enabled from backend.
  let tempNom = NOMINEE_IDENTIFICATION_LIST;
  const [nomineeIdentificationList, setNomineeIdentificationList] = useState(tempNom);
  let addressEdited = false;

  let [imgOfAddlIdentDetails, setImgOfAddlIdentDetails] = React.useState<any>([
    {
      nomineeAddDtls: { isPhoto: true, isSignature: true },
      guardianAddDtls: { isPhoto: true, isSignature: true },
    },
    {
      nomineeAddDtls: { isPhoto: true, isSignature: true },
      guardianAddDtls: { isPhoto: true, isSignature: true },
    },
    {
      nomineeAddDtls: { isPhoto: true, isSignature: true },
      guardianAddDtls: { isPhoto: true, isSignature: true },
    },
  ]);

  const nomineeList = [
    {
      display: "One",
      value: 1,
    },
    {
      display: "Two",
      value: 2,
    },
    {
      display: "Three",
      value: 3,
    },
  ];
  const nomineeListLabels = [
    {
      display: "One",
      value: 1,
    },
    {
      display: "Two",
      value: 2,
    },
    {
      display: "Three",
      value: 3,
    },
  ];
  const [cities, setCities] = React.useState([]);
  const [genderError, setGenderError] = React.useState<string>("");
  const [SettlementError, setSettlementError] = React.useState<string>("");
  const [togSettlement, settogSettlement] = React.useState<boolean>(true);
  const [togNomineeDetails, settogNomineeDetails] = React.useState<boolean>(false);
  const [isOTCFlow, setIsOTCFlow] = React.useState<boolean>(GlobalStore.isOTCFlow);
  const [isNriOtc, setIsNriOtc] = React.useState<boolean>(GlobalStore.isNriOtc);
  const [isNriInv, setIsNriInv] = React.useState<boolean>(GlobalStore.isNriInv);
  const [validationErrors, setValidationErrors] = React.useState<string>("");

  React.useEffect(() => {
    if (gender) {
      setGenderError("");
    } else if (!isOTCFlow) {
      setGenderError("please Select Gender");
    }
  }, [gender]);

  React.useEffect(() => {
    setIsOTCFlow(GlobalStore.isOTCFlow)
  }, [GlobalStore.isOTCFlow]);

  React.useEffect(() => {
    setIsNriOtc(GlobalStore.isNriOtc)
    if (GlobalStore.isNriOtc)
      setIndianResident(false)
  }, [GlobalStore.isNriOtc]);

  React.useEffect(() => {
    setIsNriInv(GlobalStore.isNriInv)
    if (GlobalStore.isNriInv)
      setIndianResident(false)
  }, [GlobalStore.isNriInv]);

  const [familyRelationshipCount, setFamilyRelationshipCount] =
    React.useState<any>({
      mobile: {
        self: 0,
        spouse: 0,
        dependentChild: 0,
        dependentParents: 0,
      },
      email: {
        self: 0,
        spouse: 0,
        dependentChild: 0,
        dependentParents: 0,
      },
    });

  React.useEffect(() => {
    if (showNominee && nomiDetails && nomiDetails.length > 0) {
      const errorMsg = nomineeMatch(showNominee, nomiDetails);
      setErrorMatchDetails(errorMsg);
    }
  }, [nomiDetails]);
  React.useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
      setIsLoading(false);
    }, 3000);
  }, [nomineeDocumentsArray]);

  // let path = useReactPath();
  React.useEffect(() => {
    // GlobalStore.pathname = path;
    window.scroll(0, 0);
    const clientPartialDetails_ao = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    AGetStageCompletionStatus((res: any) => {
      if (res?.data) {
        const responseObj = JSON.parse(res.data);
        setStageCompleteStatus(responseObj)
        AGetKycDetails(getKycDetails, GlobalStore.applicationID);
        if (responseObj?.mobileno) {
          setPhone(responseObj?.mobileno)
        }
        if (
          fatherOrSpouseName == null ||
          fatherOrSpouseName == undefined ||
          fatherOrSpouseName == ""
        ) {
          if (
            responseObj?.fatherspousename != null &&
            responseObj?.fatherspousename != undefined &&
            responseObj?.fatherspousename !== ""
          ) {
            setFatherOrSpouseName(
              responseObj?.fatherspousename !== undefined
                ? responseObj?.fatherspousename
                : ""
            );
          }
        }
      }
    }, GlobalStore.applicationID);

    if (clientPartialDetails_ao.isSeniorCitizen) {
      setIsSeniorCitizen(true);
      setShowNominee(true);
    }
    if (window.sessionStorage.getItem("isSeniorCitizen") == "true") {
      setIsSeniorCitizen(true);
      setShowNominee(true);
    }
    if (userId !== "0" && userId !== null && userId !== undefined) {
      !GlobalStore.sameAsPermanent &&
        GlobalStore.corrAddress !== undefined &&
        GlobalStore.corrAddress !== null &&
        GlobalStore.addressLine1 !== GlobalStore.corrAddress &&
        setSameAsPermanent(false);
      if (GlobalStore.addressLine1 && GlobalStore.PinCode) {
        let permAddLocal = { ...permanentAddress };
        permAddLocal.addressLine1 = GlobalStore.addressLine1;
        permAddLocal.PinCode = GlobalStore.PinCode;
        setPermanentAddress(permAddLocal);
      }
      if (
        !GlobalStore.sameAsPermanent &&
        GlobalStore.corrAddress &&
        GlobalStore.corrPincode
      ) {
        let corrsAddLocal = { ...correspondanceAddress };
        corrsAddLocal.addressLine1 = GlobalStore.corrAddress;
        corrsAddLocal.PinCode = GlobalStore.corrPincode;
        !(isNriInv && !isNriOtc) && setCorrespondanceAddress(corrsAddLocal);
      }
    } else {
      if (clientPartialDetails_ao.isManual) {
        setSameAsPermanent(clientPartialDetails_ao.sameAsPermanent);
        let permAddLocal = { ...permanentAddress };
        permAddLocal.addressLine1 = clientPartialDetails_ao.addressLine1;
        permAddLocal.PinCode = clientPartialDetails_ao.PinCode;
        setPermanentAddress(permAddLocal);
        if (clientPartialDetails_ao.sameAsPermanent == false) {
          let corrsAddLocal = { ...correspondanceAddress };
          corrsAddLocal.addressLine1 = clientPartialDetails_ao.corrAddress;
          corrsAddLocal.PinCode = clientPartialDetails_ao.corrPincode;
          !(isNriInv && !isNriOtc) && setCorrespondanceAddress(corrsAddLocal);
        }
      } else {
        !clientPartialDetails_ao.sameAsPermanent &&
          clientPartialDetails_ao.corrAddress !== undefined &&
          clientPartialDetails_ao.corrAddress !== null &&
          clientPartialDetails_ao.addressLine1 !==
          clientPartialDetails_ao.corrAddress &&
          setSameAsPermanent(false);
        if (
          clientPartialDetails_ao.addressLine1 &&
          clientPartialDetails_ao.PinCode
        ) {
          let permAddLocal = { ...permanentAddress };
          permAddLocal.addressLine1 = clientPartialDetails_ao.addressLine1;
          permAddLocal.PinCode = clientPartialDetails_ao.PinCode;
          setPermanentAddress(permAddLocal);
        }
        if (!clientPartialDetails_ao.sameAsPermanent) {
          let corrsAddLocal = { ...correspondanceAddress };
          corrsAddLocal.addressLine1 = clientPartialDetails_ao.corrAddress;
          corrsAddLocal.PinCode = clientPartialDetails_ao.corrPincode;
          !(isNriInv && !isNriOtc) && setCorrespondanceAddress(corrsAddLocal);
        }
      }
    }

    if (
      (GlobalStore?.personaldetails?.gender == "" ||
        GlobalStore?.personaldetails?.gender == null ||
        GlobalStore?.personaldetails?.gender == undefined) &&
      (gender == "" || gender == null || gender == undefined) &&
      clientPartialDetails_ao.gender !== null &&
      clientPartialDetails_ao?.gender !== undefined &&
      clientPartialDetails_ao?.gender !== ""
    ) {
      GlobalStore.personaldetails.gender = clientPartialDetails_ao.gender;
      setGender(clientPartialDetails_ao.gender);
    }
    console.log(
      clientPartialDetails_ao,
      " = clientPartialDetails_ao || phone = ",
      phone
    );
    if (!phone && clientPartialDetails_ao.mobile) {
      setPhone(clientPartialDetails_ao.mobile);
    }
  }, [isNriInv]);

  React.useEffect(() => {
    if (showNominee && numOfNominee > 0) {
      const defaultEmail = GlobalStore?.user?.email;
      const defaultMobile = GlobalStore?.user?.mobile;
      const updatedDetails = [...nomiDetails];
      updatedDetails.forEach((nominee, idx) => {
        // if (!nominee.nomEmail) {
        //   updatedDetails[idx].nomEmail = defaultEmail;
        // }

        // if (!nominee.nomMobile) {
        //   updatedDetails[idx].nomMobile = defaultMobile;
        // }
        // if (!nominee.nomineeAddress.addressLine1) {
        //   updatedDetails[idx].nomineeAddress = { ...permanentAddress };
        // }
      });

      setNomiDetails(updatedDetails);
      setNomineeIdentificationList([
        ...nomineeIdentificationList.filter(e => e.value === 5 || e.value === 2)
      ]);
    }
    if (!showNominee) {
      settogNomineeDetails(false)
    }
  }, [showNominee, numOfNominee]);

  const showSectionOrHide = (targetCategory: number) => {
    let localShow: boolean = true;
    if (
      GlobalStore?.stageStatus?.accountcategory !== null &&
      GlobalStore?.stageStatus?.accountcategory !== undefined &&
      GlobalStore?.stageStatus?.accountcategory === targetCategory
    ) {
      localShow = false;
    }
    return localShow;
  };

  const togSettlementclick = () => {
    if (togSettlement === true) {
      setSettlementError(
        "Connect our nearest Branch Office, this account cannot be processed online."
      );
      settogSettlement(false);
    } else {
      setSettlementError("");
      settogSettlement(true);
    }
  };

  React.useEffect(() => {
    setIsLoading(true);
    AGetEnumList(getEnumList, "");
    isNriInv && AGetEnumList(getNriCountryList, "NRICountry");

    const clientPartialDetails_ao = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );

    GlobalStore.isKYC = clientPartialDetails_ao.isKYC;
    GlobalStore.isKRA = clientPartialDetails_ao.isKRA;
    GlobalStore.isDigiLocker = clientPartialDetails_ao.isDigiLocker;
    !clientPartialDetails_ao.sameAsPermanent &&
      clientPartialDetails_ao.corrAddress !== undefined &&
      clientPartialDetails_ao.corrAddress !== null &&
      clientPartialDetails_ao.addressLine1 !==
      clientPartialDetails_ao.corrAddress &&
      setSameAsPermanent(false);
    if (
      clientPartialDetails_ao.addressLine1 &&
      clientPartialDetails_ao.PinCode
    ) {
      let permAddLocal = { ...permanentAddress };
      permAddLocal.addressLine1 = clientPartialDetails_ao.addressLine1;
      permAddLocal.PinCode = clientPartialDetails_ao.PinCode;
      setPermanentAddress(permAddLocal);
    }
    if (!clientPartialDetails_ao.sameAsPermanent) {
      let corrsAddLocal = { ...correspondanceAddress };
      corrsAddLocal.addressLine1 = clientPartialDetails_ao.corrAddress;
      corrsAddLocal.PinCode = clientPartialDetails_ao.corrPincode;
      !(isNriInv && !isNriOtc) && setCorrespondanceAddress(corrsAddLocal);
    }
    const panFromLocalStorage = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    let panNum = "";
    if (
      GlobalStore.personaldetails.pan != undefined ||
      GlobalStore.personaldetails.pan != ""
    ) {
      panNum = GlobalStore.personaldetails.pan;
    } else if (panFromLocalStorage.pan != "") {
      panNum = panFromLocalStorage.pan != "" ? panFromLocalStorage.pan : "";
    }
    let isValidPan = pan.test(panNum);
    if (isValidPan) {
      AGetEmployeeByPan(checkIsPanEmployee, panNum);
    }
  }, [sameAsPermanent, isNriInv, stageCompleteStatus]);

  React.useEffect(() => {
    if (nomDob !== undefined) {
      nomDob && ageCalculator(nomDob) >= 18
        ? setIsNomineeMinor(false)
        : setIsNomineeMinor(true);
    }
  }, [nomDob]);

  // Clervertap event: Profile screen is loaded
  React.useEffect(() => {
    const data = {
      EventName: cleverTapEvents.registration.profilePage.PAGE_LOAD,
      InitiationPlatform: "",
      UTM_SOURCE,
      UTM_MEDIUM,
      UTM_CAMPAIGN,
      KRA: GlobalStore.isKRA,
      ADHAR_LINKED_WITH_MOBILE: GlobalStore.aadharLinkedChoice,
      DIGILOCKER_PROCESS: GlobalStore.isDigiLocker,
      LEAD_ID: GlobalStore.leadId,
      REF_ID: GlobalStore.applicationID,
    };

    ClevertapService.pushEvent(data);
    AGetCities(getCities);
  }, []);

  // Checking if the address proof is rejected inorder to enable editing of address field for KYC/KRA clients
  const getDocumentStatus = (res: any) => {
    if (!res || res.error) {
      // setErrCode("164- Failed to get the document status for the application.");
      setErrCode(res.error);
    } else {
      if (res.data) {
        const regectedDoc = JSON.parse(res.data).filter(
          (item: any) => item.Status === "Rejected"
        );
        regectedDoc.map((doc: { ContentType: any }) => {
          if (doc.ContentType === "PROOF OF ADDRESS PERMANENT") {
            setRegectedAddressDoc(true);
            setHideAddress(false);
          }
        });
      }
    }
  };

  function getCities(res: any) {
    if (!res || res.error)
      // setErrCode('113 - Failed to fetch the list of cities, please reload.');
      setErrCode(res.error);
    else {
      if (res.data && res.data.city) {
        setCities(res.data.city);
        setErrCode(errCode);
      }
    }
  }
  const shouldDisable = () => {
    let disabled: boolean = false;
    if (
      GlobalStore?.stageStatus?.first_esign_initiated !== null &&
      GlobalStore?.stageStatus?.first_esign_initiated !== undefined &&
      GlobalStore?.stageStatus?.first_esign_initiated
    ) {
      disabled = true;
    }
    return disabled;
  };
  function onPanDocUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string,
    index: number,
    isGuardian: boolean
  ) {
    console.log("call from fun321");
    setIsLoading(true);

    nomPhotoId.imgUrl = "";
    setNomPhotoId(nomPhotoId);
    setPhotoBase64(val!.split(",")[1]);
    const modifiedBy = window.sessionStorage.getItem('empCode')
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      filename: fileName,
      panNo: GlobalStore?.personaldetails.pan,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    AUploadDocument(
      (res: any) =>
        getUploadRes(res, id, val, fileName, index, isGuardian, type),
      uploadObj,
      (event: ProgressEvent) => onUploadProgress(event, id, fileName, type)
    );
  }

  // React.useEffect(() => {
  //   console.log("imgOfAddlIdentDetails value ", imgOfAddlIdentDetails);
  // },[imgOfAddlIdentDetails]);

  function getUploadRes(
    res: any,
    id: string,
    val: any,
    fileName: string,
    index: number,
    isGuardian: boolean,
    type: string
  ) {
    if (!res || res.error) {
      setIsLoading(false);
      // setErrCode(137);
      setErrCode(res.error);
    } else {
      if (res.data && res.data.Result) {
        var nomineeDocObj = nomineeDocuments;
        let imgOfAddlIdentDtls = JSON.parse(
          JSON.stringify(imgOfAddlIdentDetails)
        );
        let newUpload = newUploads;
        if (id === "nomPhotoId" || id === "guardianPhotoId") {
          if (id === "nomPhotoId") {
            newUpload[index].isPhoto = true;
          }

          if (id === "guardianPhotoId") {
            newUpload[index].guardian.isPhoto = true;
          }

          setIsLoading(false);
          const array = JSON.parse(JSON.stringify(nomiDetails));
          if (isGuardian) {
            imgOfAddlIdentDtls[index]["guardianAddDtls"]["isPhoto"] = true;
            setImgOfAddlIdentDetails(imgOfAddlIdentDtls);
            if (index == 0) {
              nomineeDocObj.nomineeOne.guardianDetails.photo.fileName =
                res.data?.Guid;
              nomineeDocObj.nomineeOne.guardianDetails.photo.mimeType = type
                ? type
                : ".";
            }

            if (index == 1) {
              nomineeDocObj.nomineeTwo.guardianDetails.photo.fileName =
                res.data?.Guid;
              nomineeDocObj.nomineeTwo.guardianDetails.photo.mimeType = type
                ? type
                : ".";
            }

            if (index == 2) {
              nomineeDocObj.nomineeThree.guardianDetails.photo.fileName =
                res.data?.Guid;
              nomineeDocObj.nomineeThree.guardianDetails.photo.mimeType = type
                ? type
                : ".";
            }

            array[index]["guardianDetails"]["identificationDetail"]["value"] =
              res.data?.Guid;
          } else {
            imgOfAddlIdentDtls[index]["nomineeAddDtls"]["isPhoto"] = true;
            setImgOfAddlIdentDetails(imgOfAddlIdentDtls);
            if (index == 0) {
              nomineeDocObj.nomineeOne.photo.fileName = res.data?.Guid;
              nomineeDocObj.nomineeOne.photo.mimeType = type ? type : ".";
            }

            if (index == 1) {
              nomineeDocObj.nomineeTwo.photo.fileName = res.data?.Guid;
              nomineeDocObj.nomineeTwo.photo.mimeType = type ? type : ".";
            }

            if (index == 2) {
              nomineeDocObj.nomineeThree.photo.fileName = res.data?.Guid;
              nomineeDocObj.nomineeThree.photo.mimeType = type ? type : ".";
            }
            array[index]["identificationDetail"]["value"] = res.data?.Guid;
            array[index]["error"]["identificationDetailValue"] = undefined;
            setAddlIdentDetailsValue(true);
          }
          setNomiDetails(array);
          // AextractPan((res: any) => storeOcrData(res, panOCR), panOCR);
          // if (photoBase64 !== undefined) {
          //     setErrCode('');
          // }
        }

        if (id === "nomSignature" || id === "guardianSignature") {
          setIsLoading(false);
          if (id === "nomSignature") {
            newUpload[index].isSignature = true;
          }

          if (id === "guardianSignature") {
            newUpload[index].guardian.isSignature = true;
          }
          // var nomineeDocObj = nomineeDocuments;

          const array = JSON.parse(JSON.stringify(nomiDetails));
          if (isGuardian) {
            imgOfAddlIdentDtls[index]["guardianAddDtls"]["isSignature"] = true;
            setImgOfAddlIdentDetails(imgOfAddlIdentDtls);
            if (index == 0) {
              nomineeDocObj.nomineeOne.guardianDetails.signature.fileName =
                res.data?.Guid;
              nomineeDocObj.nomineeOne.guardianDetails.signature.mimeType = type
                ? type
                : ".";
            }

            if (index == 1) {
              nomineeDocObj.nomineeTwo.guardianDetails.signature.fileName =
                res.data?.Guid;
              nomineeDocObj.nomineeTwo.guardianDetails.signature.mimeType = type
                ? type
                : ".";
            }

            if (index == 2) {
              nomineeDocObj.nomineeThree.guardianDetails.signature.fileName =
                res.data?.Guid;
              nomineeDocObj.nomineeThree.guardianDetails.signature.mimeType =
                type ? type : ".";
            }

            array[index]["guardianDetails"]["identificationDetail"]["value"] =
              res.data?.Guid;
          } else {
            imgOfAddlIdentDtls[index]["nomineeAddDtls"]["isSignature"] = true;
            setImgOfAddlIdentDetails(imgOfAddlIdentDtls);
            if (index == 0) {
              nomineeDocObj.nomineeOne.signature.fileName = res.data?.Guid;
              nomineeDocObj.nomineeOne.signature.mimeType = type ? type : ".";
            }

            if (index == 1) {
              nomineeDocObj.nomineeTwo.signature.fileName = res.data?.Guid;
              nomineeDocObj.nomineeTwo.signature.mimeType = type ? type : ".";
            }

            if (index == 2) {
              nomineeDocObj.nomineeThree.signature.fileName = res.data?.Guid;
              nomineeDocObj.nomineeThree.signature.mimeType = type ? type : ".";
            }
            array[index]["identificationDetail"]["value"] = res.data?.Guid;
            array[index]["error"]["identificationDetailValue"] = undefined;
            setAddlIdentDetailsValue(true);
          }
          setNomiDetails(array);

          console.log("Nomineedetails", array);
          console.log("setNomPhotoId", nomPhotoId);

          // AextractPan((res: any) => storeOcrData(res, panOCR), panOCR);
          // if (photoBase64 !== undefined) {
          //     setErrCode('');
          // }
        }
        setNomineeDocuments(nomineeDocObj);
        setNewUploads(newUpload);
        console.log("NomineeDocs", nomineeDocuments);
      }
    }
  }
  const guardianMinororMajor = (date: any) => {
    const today = new Date();
    const selectedDate = new Date(date);
    let age = today.getFullYear() - selectedDate.getFullYear();
    const monthDifference = today.getMonth() - selectedDate.getMonth();

    // Adjust age if the birth month hasn't occurred yet this year
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < selectedDate.getDate())
    ) {
      age--;
    }
    if (age >= 18) {
      return true;
    } else return false;
  };
  const onUploadProgress = (
    event: ProgressEvent,
    id: string,
    fileName: string,
    type: string
  ) => {
    const { loaded, total } = event;
    let percentage = Math.floor((loaded * 100) / total);
    let panCopy = { ...nomPhotoId };
    if (percentage < 100) {
      if (id === "panCard") {
        panCopy.id = id;
        panCopy.disable = false;
        panCopy.uploadPer = percentage;
        panCopy.hideProgress = true;
        panCopy.showFile = false;
        setNomPhotoId(panCopy);
      }
    }
  };

  function getDocumentidPOA(res: any) {
    setIsLoading(true);
    if (!res || res.error) {
      setErrCode(res.error);
      setIsLoading(false);
    } else {
      let responseObj = JSON.parse(res.data);
      if (
        responseObj &&
        responseObj.DocumentCategory &&
        responseObj.DocumentId
      ) {
        const reqObj = {
          applicationid: GlobalStore.applicationID,
          documentcategory: responseObj.DocumentCategory,
          documentid: responseObj.DocumentId,
        };
        AGetOcrResponseDetails(getOcrDetails, reqObj);
      } else {
        setIsLoading(false);
      }
    }
  }

  function getOcrDetails(res: any) {
    setIsLoading(true);
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (res.data) {
        // const responseObj = JSON.parse(JSON.parse(res.data));
        const responseObj = JSON.parse(res.data);
        if (
          responseObj &&
          responseObj.ocrdata &&
          responseObj.ocrdata.result &&
          responseObj.ocrdata.result.extraction_output &&
          responseObj.ocrdata.result.extraction_output.address
        ) {
          let obj = responseObj.ocrdata.result.extraction_output;
          const clientPartialDetails_ao = JSON.parse(
            window.localStorage.getItem("clientPartialDetails_ao") || "{}"
          );
          const permAdd = { ...permanentAddress };
          permAdd.addressLine1 = obj.address;
          const resPin = obj.pincode || getPincode(obj.address);
          if (resPin && resPin !== "" && resPin.length === 6)
            permAdd.PinCode = resPin.toString();
          setOcrDetails(obj);
          if (!clientPartialDetails_ao.isManual) {
            setPermanentAddress(permAdd);
            console.log(permanentAddress, "permanentAddress works 1");
          }
        }
      }
    }
    setIsLoading(false);
  }

  function getPincode(str: string) {
    const pincode = str.slice(-6);
    return isNaN(parseInt(pincode)) ? "" : pincode;
  }

  function getEnumList(res: any) {
    setIsLoading(true);
    if (!res || res.error) {
      // setErrCode('164 - Failed to fetch the category lists, please reload.');
      // setErrCode(errorMessage.getEnumList);
      setErrCode(res.error);
    } else {
      if (res.data && res.data.enumlist && res.data.enumlist.length > 0) {
        let [
          occupationList,
          incomeList,
          educationList,
          maritalStatusList,
          genderList,
          relationshipList,
          titlePrefixList,
          familyRelationList,
          countryList,
          nationalityList,
          disability
        ] = convertEnumIntoIObj(res.data.enumlist, [
          "OccupationCode",
          "Networth",
          "Education",
          "MaritalStatusCode",
          "GenderCode",
          "NomineeRelationship",
          "Prefix",
          "ContactRelationTypeCode",
          "Country",
          "NationalityCode",
          "Disability"
        ]);
        incomeList = fixIncomeList(incomeList);
        setOccupationList(occupationList);
        setIncomeList(incomeList);
        setEducationList(educationList);
        setMaritalStatusList(maritalStatusList);
        setGenderList(genderList);
        setRelationshipList(relationshipList);
        setTitlePrefixList(titlePrefixList);
        setFamilyRelationList(familyRelationList);
        setFamilyRelationListMail(familyRelationList);
        setOriginalRelationList(familyRelationList);
        // let indiaRemovedCountryList = countryList?.filter((e) => e.display !== "India")
        setCountryList(countryList);
        setDisabilityList(disability);
        setNationalityList(nationalityList)
      }
    }
    setIsLoading(false);
  }

  function getNriCountryList(res: any) {
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (res.data && res.data.enumlist && res.data.enumlist.length > 0) {
        let [nriCountryList] = convertEnumIntoIObj(res.data.enumlist, [
          "NRICountry"
        ]);
        setNriCountryList(nriCountryList);
      }
    }
  }

  function fixIncomeList(list: IListObj[]) {
    return list.map((e) => ({ ...e, display: e.display.replace("Btw ", "") }));
  }

  function getRedisData(res: any) {
    setIsLoading(true);
    if (!res || res.error) {
      // setErrCode();
      setErrCode(res.error);
    } else {
      if (res.data && res.data.coresAddress) {
        let responseObj = res.data;
        GlobalStore.isDigiLocker = true;
        getProfileDetailsFromAadhar(responseObj);
        const permAdd = { ...permanentAddress };
        permAdd.addressLine1 = responseObj.coresAddress;
        setAadharName(responseObj.aadharName);
        responseObj.aadharNo !== "000000000000" && setIsAadharMasked(false);
        permAdd.PinCode = responseObj.coresPincode.toString();
        setGender(responseObj.gender === "M" ? "M" : "F");
        setGenderError("");
        setPermanentAddress(permAdd);
        console.log(permanentAddress, "permanentAddress works 2");
      } else {
        AGetDocumentidByApplicationid(
          getDocumentidPOA,
          GlobalStore.applicationID
        );
      }
    }
    setIsLoading(false);
  }

  // function getRelationshipData(res: any) {
  //   setIsLoading(true);
  //   if (!res || res.error) {
  //     // setErrCode('132 - Failed to fetch relationship data');
  //     //   setErrCode(errorMessage.getRelationshipData);
  //     setErrCode(res.error);
  //   } else {
  //     if (res.data) {
  //       console.log("count log", res.data);
  //       let responseObj = res.data;
  //       setRelationshipDataCount({
  //         AvailableRelationshipTagEmail:
  //           responseObj.AvailableRelationshipTagEmail,
  //         AvailableRelationshipTagMobile:
  //           responseObj.AvailableRelationshipTagMobile,
  //       });
  //       setRelationshipData(responseObj);
  //     } else {
  //       // setErrCode('132 - Failed to fetch relationship data');
  //       setErrCode(res.error);
  //     }
  //   }
  //   setIsLoading(false);
  // }

  function checkIsPanEmployee(res: any) {
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (res.data) {
        // const responseDataObj = JSON.parse(JSON.parse(res.data));
        const responseDataObj = res.data;
        if (responseDataObj.result.Flag === "Y")
          setStaffCode(responseDataObj.result.EmployeeCode);
      }
    }
  }

  function getbase64(dataString: string, obj: DocDetailFormat) {
    return (
      "data:" +
      (obj.mimeType === "application/pdf" ? "application/pdf" : "image/jpeg") +
      ";base64," +
      dataString
    );
  }

  async function getKycDetails(res: any) {
    try {
      setIsLoading(true);
      if (!res || res.error) {
        setIsLoading(false);
        setErrCode(res.error);
      } else {
        if (res.data) {
          let srNo = 0;
          let responseObj = JSON.parse(res.data);
          let fathersName = "";
          //   let responseObj = JSON.parse(JSON.stringify(res.data));
          if (responseObj.ObjEcoClientPersoanlDetails) {
            settogNomineeDetails(responseObj?.IsCheckedNameOfNominees)
            const clientPartialDetails_ao = JSON.parse(
              window.localStorage.getItem("clientPartialDetails_ao") || "{}"
            );

            clientPartialDetails_ao.addressLine1 =
              responseObj.ObjEcoClientPersoanlDetails.objPermanentAddressDetails.permanentaddressline1;
            clientPartialDetails_ao.sameAsPermanent =
              responseObj.ObjEcoClientPersoanlDetails.corrsaddraspermanent;
            clientPartialDetails_ao.corrAddress =
              responseObj.ObjEcoClientPersoanlDetails.objCorrespondenceAddressDetails.correspondenceaddressline1;
            window.localStorage.setItem(
              "clientPartialDetails_ao",
              JSON.stringify(clientPartialDetails_ao)
            );

            setDisability(responseObj.ObjEcoClientPersoanlDetails?.disability?.toString() || "");

            GlobalStore.isKRA && setHideAddress(true);
            GlobalStore.isKYC && setHideAddress(true);
            let resultObj =
              responseObj.ObjEcoClientPersoanlDetails
                .objPermanentAddressDetails;
            if (resultObj) {
              const permAddObj = { ...permanentAddress };
              permAddObj.addressLine1 =
                resultObj.permanentaddressline1 +
                resultObj.permanentaddressline2 +
                (resultObj.permanentaddressline3 || "") +
                (resultObj.permanentaddressline4 || "");
              permAddObj.Area = resultObj.permanentarea || resultObj.permanentcity;
              permAddObj.City = resultObj.permanentcity;
              permAddObj.PinCode = resultObj.permanentpincode;
              permAddObj.District = resultObj.permanentdistrict;
              permAddObj.State = resultObj.permanentstate;
              permAddObj.StateCode = resultObj.permanentstatecode;
              permAddObj.Country = resultObj.permanentcountry;
              permAddObj.CountryCode = resultObj.permanentcountrycode;
              setPermanentAddress(permAddObj);
              console.log(permanentAddress, "permanentAddress works 3");
              // for AO-1395 KYC/KRA address proof reject
            }
            resultObj =
              responseObj.ObjEcoClientPersoanlDetails
                .objCorrespondenceAddressDetails;
            if (resultObj) {
              const corrAddObj = { ...correspondanceAddress };
              corrAddObj.addressLine1 =
                resultObj.correspondenceaddressline1 +
                resultObj.correspondenceaddressline2 +
                (resultObj.correspondenceaddressline3 || "") +
                (resultObj.correspondenceaddressline4 || "");
              corrAddObj.Area = resultObj.correspondancearea;
              corrAddObj.City = resultObj.correspondancecity;
              corrAddObj.PinCode = resultObj.correspondancepincode;
              corrAddObj.District = resultObj.correspondancedistrict;
              corrAddObj.State = resultObj.correspondancestate;
              corrAddObj.StateCode = resultObj.correspondancestatecode;
              corrAddObj.Country = resultObj.correspondancecountry;
              corrAddObj.CountryCode = resultObj.correspondancecountrycode;
              setCorrespondanceAddress(corrAddObj);
              console.log(
                correspondanceAddress,
                "correspondanceAddress works 1"
              );
            }

            setSameAsPermanent(
              responseObj?.ObjEcoClientPersoanlDetails?.corrsaddraspermanent
            );
          }
          if (
            responseObj.ObjEcoProfileDetails &&
            responseObj.ObjEcoClientPersoanlDetails
          ) {
            if (
              responseObj.ListMultipleNomineeDetails &&
              responseObj.ListMultipleNomineeDetails.length > 0
            ) {
              setShowNominee(true);
              setIsEditMode(false);
              setNumOfNominee(responseObj.ListMultipleNomineeDetails.length);
              const array: any = [];
              for (
                let i = 0;
                i < responseObj.ListMultipleNomineeDetails.length;
                i++
              ) {
                const element = responseObj.ListMultipleNomineeDetails[i];
                if (
                  element?.additional_details ==
                  "Photo and Signature of the Nominee/guardian"
                ) {
                  setIsEditMode(true);
                  const photo: any = {
                    id: "nomPhotoId",
                    disable: false,
                    uploadPer: 100,
                    fileName: element?.additional_details_value,
                    imgUrl:
                      "data:image/jpg;base64," +
                      JSON.parse(
                        JSON.stringify(element?.additional_details_value)
                      ).base64document,
                    showFile: false,
                    hideProgress: false,
                  };
                  setNomPhotoId(photo);
                }

                let addressLine1 =
                  element.objpermanentaddressdetails.permanentaddressline1;
                let addressLine2 =
                  element.objpermanentaddressdetails.permanentaddressline2;
                let addressLine3 =
                  element?.objpermanentaddressdetails.permanentaddressline3;
                let addressLine4 =
                  element?.objpermanentaddressdetails.permanentaddressline4;
                addressLine1 =
                  addressLine1 != "null" || addressLine1 != null
                    ? addressLine1
                    : "";
                addressLine2 =
                  addressLine2 != "null" || addressLine2 != null
                    ? addressLine2
                    : "";
                addressLine3 =
                  addressLine3 != "null" || addressLine3 != null
                    ? addressLine3
                    : "";
                addressLine4 =
                  addressLine4 != "null" || addressLine4 != null
                    ? addressLine4
                    : "";

                let completeAddress = `${addressLine1}${addressLine2}${addressLine3}${addressLine4}`;
                let nFirstName =
                  element.firstname != null || element.firstname != "null"
                    ? element.firstname
                    : "";
                let nMiddleName =
                  element.middlename != null || element.middlename != "null"
                    ? element.middlename
                    : "";
                let nLastname =
                  element.lastname != null || element.lastname != "null"
                    ? element.lastname
                    : "";
                let nomFullName = `${nFirstName} ${nMiddleName} ${nLastname}`;

                const singleNominee: any = {
                  error: {},
                  nomTitle: element.title,
                  nomFullName: nomFullName,
                  nomRelation: element.relationship,
                  nomineeAddress: {
                    addressLine1: completeAddress,
                    City: element.objpermanentaddressdetails.permanentcity,
                    Country:
                      element.objpermanentaddressdetails.permanentcountry,
                    District:
                      element.objpermanentaddressdetails.permanentdistrict,
                    PinCode:
                      element.objpermanentaddressdetails.permanentpincode,
                    State: element.objpermanentaddressdetails.permanentstate,
                    Area: element.objpermanentaddressdetails.permanentarea,
                    CountryCode:
                      element.objpermanentaddressdetails.permanentcountrycode,
                    StateCode:
                      element.objpermanentaddressdetails.permanentstatecode,
                  },
                  nomPerSharing: element.percentage,
                  nomDob: element.dob ? new Date(element.dob) : null,
                  isNomineeMinor: element.isminor,
                  identificationDetail: {
                    name: element.additional_details,
                    value: element.additional_details_value,
                  },
                  nomEmail: element.emailid,
                  nomMobile: element.mobile,
                };

                // need to check if isMonir is there than need to check in guardian details from ListMultipleGuardianDetails and set into guardianDetails with singleNominee Obj
                if (element.isminor) {
                  const guardianDetails =
                    responseObj.ListMultipleGuardianDetails.find(
                      (singleGuardianDetail: any) =>
                        singleGuardianDetail.srno === srNo
                    );

                  if (guardianDetails && Object.keys(guardianDetails).length) {
                    console.log("guardianDetails", guardianDetails);
                    let addressLine1 =
                      guardianDetails?.objpermanentaddressdetails
                        .permanentaddressline1;
                    let addressLine2 =
                      guardianDetails?.objpermanentaddressdetails
                        .permanentaddressline2;
                    let addressLine3 =
                      guardianDetails?.objpermanentaddressdetails
                        .permanentaddressline3;
                    let addressLine4 =
                      guardianDetails?.objpermanentaddressdetails
                        .permanentaddressline4;
                    addressLine1 =
                      addressLine1 !== "NULL" ||
                        addressLine1 !== "null" ||
                        addressLine1 !== null
                        ? addressLine1
                        : "";
                    addressLine2 =
                      addressLine2 !== "NULL" ||
                        addressLine2 !== "null" ||
                        addressLine2 !== null
                        ? addressLine2
                        : "";
                    addressLine3 =
                      addressLine3 !== "NULL" ||
                        addressLine3 !== "null" ||
                        addressLine3 !== null
                        ? addressLine3
                        : "";
                    addressLine4 =
                      addressLine4 !== "NULL" ||
                        addressLine4 !== "null" ||
                        addressLine4 !== null
                        ? addressLine4
                        : "";
                    let completeAddress = `${addressLine1}${addressLine2}${addressLine3}${addressLine4}`;

                    let nFirstName =
                      guardianDetails?.firstname != null ||
                        guardianDetails?.firstname != "null"
                        ? guardianDetails?.firstname
                        : "";
                    let nMiddleName =
                      guardianDetails?.middlename != null ||
                        guardianDetails?.middlename != "null"
                        ? guardianDetails?.middlename
                        : "";
                    let nLastname =
                      guardianDetails?.lastname != null ||
                        guardianDetails?.lastname != "null"
                        ? guardianDetails?.lastname
                        : "";
                    let nomFullName = `${nFirstName} ${nMiddleName} ${nLastname}`;

                    singleNominee["guardianDetails"] = {
                      guardPoliticalVal: "0",
                      guardianAddress: {
                        addressLine1: completeAddress,
                        City: guardianDetails?.objpermanentaddressdetails
                          .permanentcity,
                        Country:
                          guardianDetails?.objpermanentaddressdetails
                            .permanentcountry,
                        District:
                          guardianDetails?.objpermanentaddressdetails
                            .permanentdistrict,
                        PinCode:
                          guardianDetails?.objpermanentaddressdetails
                            .permanentpincode,
                        State:
                          guardianDetails?.objpermanentaddressdetails
                            .permanentstate,
                        Area: guardianDetails?.objpermanentaddressdetails
                          .permanentarea,
                        CountryCode:
                          guardianDetails?.objpermanentaddressdetails
                            .permanentcountrycode,
                        StateCode:
                          guardianDetails?.objpermanentaddressdetails
                            .permanentstatecode,
                      },
                      sameAsNominee: false,
                      dob: guardianDetails?.dob,
                      guardTitle: guardianDetails?.title,
                      guardFullName: nomFullName,
                      guardRelation: guardianDetails?.relationship,
                      identificationDetail: {
                        name: guardianDetails?.additional_details,
                        value: guardianDetails?.additional_details_value,
                      },
                      guardEduQualification: guardianDetails?.education,
                      guardOccupation: guardianDetails?.occupation,
                      guardAnnualIncome: guardianDetails?.annualincomerange,
                      guardNetWorth: guardianDetails?.networthamountac_open,
                      guardPlaceOfBirth: guardianDetails?.placeofbirth,
                    };
                  }
                }
                srNo += 1;
                array.push(singleNominee);
              }
              console.log("array ----->", array);
              setNomiDetails(array);
            }
            // console.log('responseObj.ListMultipleNomineeDetails', responseObj.ListMultipleNomineeDetails);

            // setNomiDetails(responseObj.ListMultipleNomineeDetails);
            // Changes made to populate local storage when client is coming from Know the status flow
            GlobalStore.leadId = responseObj.LeadId;
            GlobalStore.KRA_email = responseObj.ObjEcoClientPersoanlDetails
              .KraEmailId
              ? responseObj.ObjEcoClientPersoanlDetails.KraEmailId
              : "";
            GlobalStore.KRA_mobile = responseObj.ObjEcoClientPersoanlDetails
              .KraMobileNo
              ? responseObj.ObjEcoClientPersoanlDetails.KraMobileNo
              : "";
            GlobalStore.KRA_mode = responseObj.ObjEcoClientPersoanlDetails
              .KraMode
              ? responseObj.ObjEcoClientPersoanlDetails.KraMode
              : 0;

            const clientPartialDetails_ao = JSON.parse(
              window.localStorage.getItem("clientPartialDetails_ao") || "{}"
            );
            clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
            clientPartialDetails_ao.leadID = GlobalStore.leadId;
            clientPartialDetails_ao.clientPrimaryDetailId =
              responseObj.ClientPrimaryDetailID;
            clientPartialDetails_ao.emailID = responseObj
              .ObjEcoClientPersoanlDetails.Email
              ? responseObj.ObjEcoClientPersoanlDetails.Email
              : clientPartialDetails_ao.emailID;
            clientPartialDetails_ao.birthDate =
              responseObj.ObjEcoClientPersoanlDetails.Birthdate;
            clientPartialDetails_ao.ckycNo =
              responseObj.ObjEcoClientPersoanlDetails.ckycnumber;
            clientPartialDetails_ao.fsfullName = `${responseObj.ObjEcoClientPersoanlDetails.FatherOrSpouseFirstname
              ? responseObj.ObjEcoClientPersoanlDetails
                .FatherOrSpouseFirstname
              : ""
              } ${responseObj.ObjEcoClientPersoanlDetails.FatherOrSpouseMiddleName
                ? responseObj.ObjEcoClientPersoanlDetails
                  .FatherOrSpouseMiddleName
                : ""
              } ${responseObj.ObjEcoClientPersoanlDetails.FatherOrSpouseLastName
                ? responseObj.ObjEcoClientPersoanlDetails.FatherOrSpouseLastName
                : ""
              }`;
            clientPartialDetails_ao.motherfullName = `${responseObj.ObjEcoClientPersoanlDetails.MotherFirstname
              ? responseObj.ObjEcoClientPersoanlDetails.MotherFirstname
              : ""
              } ${responseObj.ObjEcoClientPersoanlDetails.MotherMiddleName
                ? responseObj.ObjEcoClientPersoanlDetails.MotherMiddleName
                : ""
              } ${responseObj.ObjEcoClientPersoanlDetails.MotherLastName
                ? responseObj.ObjEcoClientPersoanlDetails.MotherLastName
                : ""
              }`;
            clientPartialDetails_ao.addressLine1 =
              responseObj.ObjEcoClientPersoanlDetails.objPermanentAddressDetails.permanentaddressline1;
            clientPartialDetails_ao.sameAsPermanent =
              responseObj.ObjEcoClientPersoanlDetails.corrsaddraspermanent;
            clientPartialDetails_ao.corrAddress =
              responseObj.ObjEcoClientPersoanlDetails.objCorrespondenceAddressDetails.correspondenceaddressline1;
            clientPartialDetails_ao.isKYC =
              responseObj.ObjEcoClientPersoanlDetails.iskyc;
            clientPartialDetails_ao.isKRA =
              responseObj.ObjEcoClientPersoanlDetails.isKRA;
            window.localStorage.setItem(
              "clientPartialDetails_ao",
              JSON.stringify(clientPartialDetails_ao)
            );

            GlobalStore.isKRA && setHideAddress(true);
            GlobalStore.isKYC && setHideAddress(true);
            let resultObj =
              responseObj.ObjEcoClientPersoanlDetails
                .objPermanentAddressDetails;
            if (resultObj) {
              const permAddObj = { ...permanentAddress };
              permAddObj.addressLine1 =
                resultObj.permanentaddressline1 +
                resultObj.permanentaddressline2 +
                (resultObj.permanentaddressline3 || "") +
                (resultObj.permanentaddressline4 || "");
              permAddObj.Area = resultObj.permanentarea;
              permAddObj.City = resultObj.permanentcity;
              permAddObj.PinCode = resultObj.permanentpincode;
              permAddObj.District = resultObj.permanentdistrict;
              permAddObj.State = resultObj.permanentstate;
              permAddObj.StateCode = resultObj.permanentstatecode;
              permAddObj.Country = resultObj.permanentcountry;
              permAddObj.CountryCode = resultObj.permanentcountrycode;
              setPermanentAddress(permAddObj);
              console.log(permanentAddress, "permanentAddress works 4");

              // for AO-1395 KYC/KRA address proof reject
              if (GlobalStore.isKYC || GlobalStore.isKRA) {
                AGetDocStatus(getDocumentStatus, GlobalStore.applicationID);
                setKycAddress(permAddObj);
                setKycFatherName(clientPartialDetails_ao.fsfullName);
              }
            }

            resultObj =
              responseObj.ObjEcoClientPersoanlDetails
                .objCorrespondenceAddressDetails;
            if (resultObj) {
              const corrAddObj = { ...correspondanceAddress };
              corrAddObj.addressLine1 =
                resultObj.correspondenceaddressline1 +
                resultObj.correspondenceaddressline2 +
                (resultObj.correspondenceaddressline3 || "") +
                (resultObj.correspondenceaddressline4 || "");
              corrAddObj.Area = resultObj.correspondancearea;
              corrAddObj.City = resultObj.correspondancecity;
              corrAddObj.PinCode = resultObj.correspondancepincode;
              corrAddObj.District = resultObj.correspondancedistrict;
              corrAddObj.State = resultObj.correspondancestate;
              corrAddObj.StateCode = resultObj.correspondancestatecode;
              corrAddObj.Country = resultObj.correspondancecountry;
              corrAddObj.CountryCode = resultObj.correspondancecountrycode;
              setCorrespondanceAddress(corrAddObj);
              console.log(
                correspondanceAddress,
                "correspondanceAddress works 2"
              );
            }
            resultObj = responseObj.ObjEcoClientPersoanlDetails;
            if (resultObj) {
              setFatherOrSpouse(resultObj.FlagFS || "01");
              fathersName = "";
              fathersName +=
                (resultObj.FatherOrSpouseFirstname || "") +
                " " +
                (resultObj.FatherOrSpouseMiddleName || "") +
                " " +
                (resultObj.FatherOrSpouseLastName || "");
              setFatherOrSpouseName(fathersName);
              setMotherName(
                (resultObj.MotherFirstname || "") +
                " " +
                (resultObj.MotherMiddleName || "") +
                " " +
                (resultObj.MotherLastName || "")
              );
              setMaritalStatus(resultObj.MaritalStatus);
              setGender(resultObj.Gender);
              setGenderError("");
              setSameAsPermanent(resultObj.corrsaddraspermanent);
              setEmail(clientPartialDetails_ao.emailID);
              GlobalStore.user.email = clientPartialDetails_ao.emailID;
              setIsEmailVerified(true);
              setShowEmailBtn(false);
              if (clientPartialDetails_ao.mobile) {
                setPhone(clientPartialDetails_ao.mobile);
              }
              GlobalStore.user.mobile = clientPartialDetails_ao.mobile;
            }
            resultObj = responseObj.ObjEcoProfileDetails;
            if (resultObj) {
              setEduQulification(resultObj.education || "");
              setOccupation(resultObj.occupation || "");
              setPoliticalVal(resultObj.pep || "0");
              setAnnualIncome(resultObj.annualincomerange || "");
              setPlaceOfBirth(resultObj.placeofbirth || "");
              setNetWorth(resultObj.networthwhenacopen);
              setPeriodicSettlement(resultObj.periodicsettlement.toString());
              setIndianResident(!resultObj.taxresidentofothercountry);
              setNationalityCode(resultObj.nationality || "");
              //setting PO flag after getting
              if (resultObj.ddpi_type == 1) setPOAType(true);
              else setPOAType(false);
              if (resultObj.applicationtype == 2)
                setDefaultAccountType(
                  "BSDA Resident Demat and Trading Account"
                );
              else
                setDefaultAccountType(
                  "BSDA Resident Demat and Trading Account"
                );
              if (
                resultObj.taxresidentofothercountry &&
                resultObj.taxresidenceofindialist.length > 0
              ) {
                const nriObj: typeof nriDetailsObj = {
                  country: resultObj.taxresidenceofindialist[0].country,
                  idType:
                    resultObj.taxresidenceofindialist[0].identification_type,
                  idTypeValue:
                    resultObj.taxresidenceofindialist[0].identification_number,
                  idTypeOther:
                    resultObj.taxresidenceofindialist[0]
                      .identification_type_other,
                };
                setNriDetailsObj(nriObj);
              }
            }

            resultObj =
              responseObj.ObjEcoNomineeDetails?.objPermanentAddressDetails;
            if (resultObj) {
              const nomAddObj = { ...nomineeAddress };
              nomAddObj.addressLine1 =
                resultObj.permanentaddressline1 +
                resultObj.permanentaddressline2 +
                (resultObj.permanentaddressline3 || "") +
                (resultObj.permanentaddressline4 || "");
              nomAddObj.Area = resultObj.permanentarea;
              nomAddObj.City = resultObj.permanentcity;
              nomAddObj.PinCode = resultObj.permanentpincode;
              nomAddObj.District = resultObj.permanentdistrict;
              nomAddObj.StateCode = resultObj.permanentstatecode;
              nomAddObj.Country = resultObj.permanentcountry;
              nomAddObj.CountryCode = resultObj.permanentcountrycode;
              setNomineeAddress(nomAddObj);
              setShowNominee(true);
            }
            resultObj = responseObj.ObjEcoNomineeDetails;
            if (resultObj) {
              setNomTitle(resultObj.Title);
              setNomFullName(
                resultObj.FirstName +
                " " +
                (resultObj.MiddleName || "") +
                " " +
                (resultObj.LastName || "")
              );
              setNomRelation(resultObj.relationship || "");
              setIsNomineeMinor(resultObj.isminor);
              setNomDob(resultObj.DOB);
            }
            resultObj =
              responseObj.ObjEcoGuardianDetails?.objPermanentAddressDetails;
            if (resultObj) {
              const gaurdAddObj = { ...guardianAddress };
              gaurdAddObj.addressLine1 =
                resultObj.permanentaddressline1 +
                resultObj.permanentaddressline2 +
                (resultObj.permanentaddressline3 || "") +
                (resultObj.permanentaddressline4 || "");
              gaurdAddObj.Area = resultObj.permanentarea;
              gaurdAddObj.City = resultObj.permanentcity;
              gaurdAddObj.PinCode = resultObj.permanentpincode;
              gaurdAddObj.District = resultObj.permanentdistrict;
              gaurdAddObj.State = resultObj.permanentstate;
              gaurdAddObj.StateCode = resultObj.permanentstatecode;
              gaurdAddObj.Country = resultObj.permanentcountry;
              gaurdAddObj.CountryCode = resultObj.permanentcountrycode;
              setGuardianAddress(gaurdAddObj);
              setIsNomineeMinor(true);
            }
            resultObj = responseObj.ObjEcoGuardianDetails;
            if (resultObj) {
              setGuardTitle(resultObj.Title);
              setGuardFullName(
                resultObj.FirstName +
                " " +
                (resultObj.MiddleName || "") +
                " " +
                (resultObj.LastName || "")
              );
              setGuardRelation(resultObj.relationship || "");
              setGuardEduQulification(resultObj.education || "");
              setGuardOccupation(resultObj.occupation || "");
              setGuardPoliticalVal(resultObj.pep || "0");
              setGuardAnnualIncome(resultObj.annualincomerange || "");
              setGuardNetWorth(resultObj.networthamountac_open || "");
              setGuardPlaceOfBirth(resultObj.placeofbirth || "");
            }
            setIsLoading(false);
          } else {
            const clientPartialDetails_ao = JSON.parse(
              window.localStorage.getItem("clientPartialDetails_ao") || "{}"
            );
            let pinCode: string = "";

            if (clientPartialDetails_ao.PinCode) {
              pinCode = clientPartialDetails_ao.PinCode;
              // AGetCityByPincode(
              //   getFullAddress,
              //   clientPartialDetails_ao.PinCode
              // );
            } else if (
              GlobalStore.isKRA &&
              GlobalStore.kraInfoObject.addressLine1 &&
              GlobalStore.kraInfoObject.pincode
            )
              pinCode = GlobalStore.kraInfoObject.pincode;
            // AGetCityByPincode(
            //   getFullAddress,
            //   GlobalStore.kraInfoObject.pincode
            // );
            else if (
              GlobalStore.isKYC &&
              GlobalStore.ckycNo !== "" &&
              GlobalStore.ckycInfoObject.addressLine1 &&
              GlobalStore.ckycInfoObject.pincode
            )
              pinCode = GlobalStore.ckycInfoObject.pincode;
            // AGetCityByPincode(
            //   getFullAddress,
            //   GlobalStore.ckycInfoObject.pincode
            // );
            else if (
              GlobalStore.isDigiLocker &&
              GlobalStore.personaldetails.addressLine1 &&
              GlobalStore.personaldetails.pincode
            )
              pinCode = GlobalStore.personaldetails.pincode;
            // AGetCityByPincode(
            //   getFullAddress,
            //   GlobalStore.personaldetails.pincode
            // );
            if (
              !isNriInv &&
              clientPartialDetails_ao.sameAsPermanent !== null &&
              clientPartialDetails_ao.sameAsPermanent !== undefined &&
              clientPartialDetails_ao.sameAsPermanent &&
              clientPartialDetails_ao.corrPincode
            ) {
              AGetCityByPincode(
                (res: any) =>
                  getCorrAddress(res, clientPartialDetails_ao.corrAddress),
                clientPartialDetails_ao.corrPincode
              );
            }
            if (pinCode !== null && pinCode !== undefined && pinCode !== "") {
              AGetCityByPincode(getFullAddress, pinCode);
            } else {
              const redisReqObj = {
                applicationId: GlobalStore.applicationID,
                clientPrimaryDetailsId: GlobalStore.clientPrimaryDetailId,
              };
              //  ARedisDigilockerDoc(getRedisData, redisReqObj);
            }
          }

          let mobNumber = GlobalStore.user.mobile;
          let emailID = GlobalStore.user.email;
          const clientPartialDetails_ao = JSON.parse(
            window.localStorage.getItem("clientPartialDetails_ao") || "{}"
          );

          !clientPartialDetails_ao.sameAsPermanent &&
            clientPartialDetails_ao.corrAddress !== undefined &&
            clientPartialDetails_ao.corrAddress !== null &&
            clientPartialDetails_ao.addressLine1 !==
            clientPartialDetails_ao.corrAddress &&
            setSameAsPermanent(false);
          if (
            clientPartialDetails_ao.addressLine1 &&
            clientPartialDetails_ao.PinCode
          ) {
            let permAddLocal = { ...permanentAddress };
            permAddLocal.addressLine1 = clientPartialDetails_ao.addressLine1;
            permAddLocal.PinCode = clientPartialDetails_ao.PinCode;

            AGetCityByPincode((res: any) => {
              if (
                !clientPartialDetails_ao.sameAsPermanent &&
                clientPartialDetails_ao.corrAddress !== undefined &&
                clientPartialDetails_ao.corrAddress !== null
              ) {
                if (
                  clientPartialDetails_ao.addressLine1 !==
                  clientPartialDetails_ao.corrAddress
                ) {
                  getFullAddress(res, false);
                } else {
                  getFullAddress(res, true);
                }
              }
            }, clientPartialDetails_ao.PinCode);
            //   setPermanentAddress(permAddLocal);
          }
          if (
            clientPartialDetails_ao.sameAsPermanent !== null &&
            clientPartialDetails_ao.sameAsPermanen !== undefined &&
            !clientPartialDetails_ao.sameAsPermanent
          ) {
            let corrsAddLocal = { ...correspondanceAddress };
            corrsAddLocal.addressLine1 = clientPartialDetails_ao.corrAddress;
            corrsAddLocal.PinCode = clientPartialDetails_ao.corrPincode;
            // AGetCityByPincode(
            //   (res: any) =>
            //     getCorrAddress(res, clientPartialDetails_ao.corrAddress),
            //   GlobalStore.ckycInfoObject.pincode
            // );
            !(isNriInv && !isNriOtc) && setCorrespondanceAddress(corrsAddLocal);
          }

          if (!mobNumber) {
            mobNumber = clientPartialDetails_ao.mobile;
          }
          if (!emailID) {
            emailID = clientPartialDetails_ao.emailID;
          }
          if (emailID == "" && emailID == undefined && emailID == null) {
            emailID = clientPartialDetails_ao.emailID;
          }
          if (
            fathersName == "" ||
            fathersName == null ||
            fathersName == undefined
          ) {
            if (
              GlobalStore.personaldetails.fsfullName == "" ||
              GlobalStore.personaldetails.fsfullName == null ||
              GlobalStore.personaldetails.fsfullName == undefined
            ) {
              setFatherOrSpouseName(
                clientPartialDetails_ao.fsfullName !== undefined
                  ? clientPartialDetails_ao.fsfullName
                  : ""
              );
            } else {
              setFatherOrSpouseName(GlobalStore.personaldetails.fsfullName);
            }
          }
          // AGetRelationshipData(
          //   getRelationshipData,
          //   GlobalStore.applicationID,
          //   emailID,
          //   mobNumber.toString()
          // );

          // check if nominee is present is yes get Uploaded documents and prefill

          // AGetUploadedDocument(getUploadedDoc, GlobalStore.applicationID);
        }
      }
    } catch (error) {
      console.log("error in catch", error);
    }
  }

  // function getAreaList(res: any) {
  //   if (!res || res.error) {
  //     // setErrCode('130 - Failed to fetch the area list for the pincode');
  //     //   setErrCode(errorMessage.getAreaList);
  //     setErrCode(res.error);
  //   } else {
  //     if (res.data && res.data.areas) {
  //       let arr: Array<IListObj> = [];
  //       res.data.areas.forEach((item: string) => {
  //         let obj: IListObj = {
  //           value: item,
  //           display: item,
  //         };
  //         arr.push(obj);
  //       });
  //       const clientPartialDetails_ao = JSON.parse(
  //         window.localStorage.getItem("clientPartialDetails_ao") || "{}"
  //       );
  //       if (clientPartialDetails_ao.PinCode) {
  //         AGetFullAddress(
  //           getFullAddress,
  //           res.data.areas[0],
  //           clientPartialDetails_ao.PinCode
  //         );
  //       } else if (GlobalStore.ckycInfoObject.pincode) {
  //         AGetFullAddress(
  //           getFullAddress,
  //           res.data.areas[0],
  //           GlobalStore.ckycInfoObject.pincode
  //         );
  //       } else if (GlobalStore.kraInfoObject.pincode) {
  //         AGetFullAddress(
  //           getFullAddress,
  //           res.data.areas[0],
  //           GlobalStore.kraInfoObject.pincode
  //         );
  //       } else if (GlobalStore.personaldetails.pincode) {
  //         AGetFullAddress(
  //           getFullAddress,
  //           res.data.areas[0],
  //           GlobalStore.personaldetails.pincode
  //         );
  //       }
  //     } else {
  //       // setErrCode('130 - Failed to fetch the area list for the pincode');
  //       setErrCode(res.error);
  //     }
  //   }
  // }

  function getFullAddress(res: any, sameAsPerman?: boolean) {
    if (!res || res.error) {
      // setErrCode('131 - Failed to fetch details corresponding to pincode and area');
      //   setErrCode(errorMessage.getFullAddress);
      // NRE/NRO: pincode master miss must not block profile submit
      if (!isNriInv && !isNriOtc) {
        setErrCode(res.error);
      }
      setIsLoading(false);
    } else {
      if (res.data && res.data.length > 0) {
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        let obj: any = {};
        obj.PinCode = res.data[0].PinCode;
        obj.District = res.data[0].District == "" ? res.data[0].City : res.data[0].District;
        obj.Country = res.data[0].Country;
        obj.City = res.data[0].City;
        obj.State = res.data[0].State;
        obj.Area = res.data[0].City;
        obj.StateCode = res.data[0].StateCode;
        obj.CountryCode = res.data[0].CountryCode;
        obj.addressLine1 = clientPartialDetails_ao.addressLine1
          ? clientPartialDetails_ao.addressLine1
          : GlobalStore.ckycInfoObject.addressLine1
            ? GlobalStore.ckycInfoObject.addressLine1
            : GlobalStore.kraInfoObject.addressLine1
              ? GlobalStore.kraInfoObject.addressLine1
              : GlobalStore.personaldetails.addressLine1;
        // setHideAddressKra(true);
        setPermanentAddress(obj);
        const areaObj = {
          pincode: res.data[0].PinCode,
          city: res.data[0].City,
          state: res.data[0].State,
        };
        //  ASavePinCity((res: any) => savePinCityRes(res), areaObj);

        if (
          sameAsPerman !== null && sameAsPerman !== undefined
            ? sameAsPerman
            : sameAsPermanent
        ) {
          !(isNriInv && !isNriOtc) && setCorrespondanceAddress(obj);
          console.log(correspondanceAddress, "correspondanceAddress works 3");

          setIsLoading(false);
        } else {
          if (!isNriInv && clientPartialDetails_ao.corrPincode) {
            AGetCityByPincode(
              (res: any) =>
                getCorrAddress(res, clientPartialDetails_ao.corrAddress),
              GlobalStore.ckycInfoObject.pincode || clientPartialDetails_ao.Pincode || clientPartialDetails_ao.corrPincode
            );

            // AGetArea(
            //   (res: any) =>
            //     getCorrespondingAreaList(
            //       res,
            //       clientPartialDetails_ao.corrPincode,
            //       clientPartialDetails_ao.corrAddress
            //     ),
            //   clientPartialDetails_ao.corrPincode
            // );
          } else setIsLoading(false);
        }
      } else {
        // setErrCode('131 - Failed to fetch details corresponding to pincode and area');
        if (!isNriInv && !isNriOtc) {
          setErrCode(res.error);
        }
        setIsLoading(false);
      }
    }
  }
  function updateNomineeDetails() {
    // setNomineeDocuments([]);
    // setAddlIdentDetailsValue(true);
    const array = JSON.parse(JSON.stringify(nomiDetails));
    console.log("ARRAY", array);

    if (array.length > 0) {
      array.forEach((element: any, index: number) => {
        //  element.identificationDetail.name = '';
        // handleAddNomineeValue('identificationDetail', index, { display: '', value: 0});
      });
    }
  }

  function savePinCityRes(res: any) {
    console.log(res, "response works");
    if (!res || res.error) {
      // setErrCode('130 - Failed to fetch the area list for the pincode');
      //   setErrCode(errorMessage.getCorrespondingAreaList);
      setErrCode(res.error);
    } else {
      if (res.data && res.data.length > 0) {
      }
    }
  }
  // function getCorrespondingAreaList(
  //   res: any,
  //   pincode: string,
  //   address: string
  // ) {
  //   if (!res || res.error) {
  //     // setErrCode('130 - Failed to fetch the area list for the pincode');
  //     //   setErrCode(errorMessage.getCorrespondingAreaList);
  //     setErrCode(res.error);
  //   } else {
  //     if (res.data && res.data.areas) {
  //       let arr: Array<IListObj> = [];
  //       res.data.areas.forEach((item: string) => {
  //         let obj: IListObj = {
  //           value: item,
  //           display: item,
  //         };
  //         arr.push(obj);
  //       });
  //       AGetFullAddress(
  //         (res: any) => getCorrAddress(res, address),
  //         res.data.areas[0],
  //         pincode
  //       );
  //     }
  //   }
  // }

  function getCorrAddress(res: any, address: string) {
    if (!res || res.error) {
      // setErrCode('131 - Failed to fetch details corresponding to pincode and area');
      if (!isNriInv && !isNriOtc) {
        setErrCode(res.error);
      }
      setIsLoading(false);
    } else {
      if (res.data && res.data.length > 0) {
        let obj: any = {};
        obj.PinCode = res.data[0].PinCode;
        obj.District = res.data[0].District;
        obj.Country = res.data[0].Country;
        obj.City = res.data[0].City;
        obj.State = res.data[0].State;
        // obj.pincode = res.data[0].PinCode;
        // obj.area = res.data[0].City;
        // obj.district = res.data[0].District;
        // obj.country = res.data[0].Country;
        // obj.city = res.data[0].City;
        // obj.state = res.data[0].State;
        obj.StateCode = res.data[0].StateCode;
        obj.CountryCode = res.data[0].CountryCode;
        obj.addressLine1 = address;
        !(isNriInv && !isNriOtc) && setCorrespondanceAddress(obj);
        console.log(correspondanceAddress, "correspondanceAddress works 4");

        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    }
  }

  function sendOtp(otpType: "email" | "mobile") {
    setIsLoading(true);
    setShowEmailOtp(false);
    setInvalidOtp(false);
    if (otpType === "email") {
      let emlObj = {
        mailBody: emailVerificationBody.mailBody,
        mailFrom: emailVerificationBody.mailFrom,
        mailSource: emailVerificationBody.mailSource,
        mailSubject: emailVerificationBody.mailSubject,
        mailTo: email,
      };
      AGetEmailOtp((res: any) => otpSent(res, "email"), emlObj);
      // AGetMobileOtp(emailOtpSent, '9770308828');
    } else {
      AGetMobileOtp((res: any) => otpSent(res, "mobile"), phone);
    }
  }

  function otpSent(res: any, otpType: "email" | "mobile") {
    if (res.data && res.status) {
      if (res.data && otpType === "email") {
        setShowEmailBtn(false);
        setShowEmailOtp(true);
      }
      if (res.data.Success && otpType === "mobile") {
        setShowMobileBtn(false);
        setShowMobileOtp(true);
      }
      setErrCode(errCode);
    } else {
      // setErrCode('114 - Failed to send OTP, please retry.');
      setErrCode(res.error);
    }
    setIsLoading(false);
  }

  function validateOtp(otpType: "email" | "mobile", val: string) {
    if (invalidOtp) {
      setInvalidOtp(false);
    }
    if (val.length === 4) {
      setIsLoading(true);
      setDisableOtp(true);
      if (otpType === "email")
        AValidateEmailOtp(
          (res: any) => checkValidateOtp(res, "email"),
          email,
          val
        );
      else
        AValidateMobileOtp(
          (res: any) => checkValidateOtp(res, "mobile"),
          phone.toString(),
          val
        );
    }
  }

  function checkValidateOtp(res: any, otpType: "email" | "mobile") {
    setDisableOtp(false);
    if (!res || res.error) {
      // setErrCode('115 - Failed to validate OTP, please retry.');
      setErrCode(res.error);
      setIsLoading(false);
    } else {
      if (res.data == true || res.data == "true" || res.data == "Same OTP") {
        if (otpType === "email") {
          GlobalStore.user.email = email;
          setIsEmailVerified(true);
          setShowEmailOtp(false);
        }
        if (otpType === "mobile") {
          GlobalStore.user.mobile = phone;
          setIsMobileVerified(true);
          setShowMobileOtp(false);
        }

        let mobNumber = GlobalStore.user.mobile;
        let emailID = GlobalStore.user.email;
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );

        if (
          GlobalStore?.personaldetails?.fsfullName == null ||
          GlobalStore?.personaldetails?.fsfullName == undefined ||
          GlobalStore?.personaldetails?.fsfullName == ""
        ) {
          setFatherOrSpouseName(clientPartialDetails_ao.fsfullName);
          GlobalStore.personaldetails.fsfullName =
            clientPartialDetails_ao.fsfullName;
        } else {
          setFatherOrSpouseName(GlobalStore.personaldetails.fsfullName);
        }
        if (!mobNumber) {
          mobNumber = clientPartialDetails_ao.mobile;
        }
        if (!emailID) {
          emailID = clientPartialDetails_ao.emailID;
        }
        // AGetRelationshipData(
        //   getRelationshipData,
        //   GlobalStore.applicationID,
        //   emailID,
        //   mobNumber.toString()
        // );
      } else {
        setInvalidOtp(true);
      }
      setErrCode(errCode);
    }
    setIsLoading(false);
  }

  function handleSameAsAbove(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.name === "sameAscorrespondance") {
      if (
        !GlobalStore.isDigiLocker &&
        !GlobalStore.isKRA &&
        !GlobalStore.isKYC
      ) {
        sameAsPermanent && setCorrespondanceAddress({ ...initialAddressObj });
        !sameAsPermanent && setCorrespondanceAddress({ ...permanentAddress });
        if (!sameAsPermanent) {
          setCorrErrorObj({});
        }
        setSameAsPermanent(!sameAsPermanent);
      }
    } else {
      !sameAsNominee && setGuardianAddress({ ...nomineeAddress });
      setSameAsNominee(!sameAsNominee);
    }
  }

  function handleSameAsAboveForGaurdian(
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) {
    const nomineeAdd = JSON.parse(JSON.stringify(nomiDetails));
    nomineeAdd[index]["guardianDetails"]["sameAsNominee"] =
      !nomineeAdd[index]["guardianDetails"]["sameAsNominee"];
    setNomiDetails(nomineeAdd);
    if (event.target.name === "sameAsguardian") {
      if (
        nomineeAdd[index]["guardianDetails"]["sameAsNominee"] &&
        nomineeAdd[index]?.nomineeAddress
      ) {
        nomineeAdd[index]["guardianDetails"]["guardianAddress"] =
          nomineeAdd[index]?.nomineeAddress;
        setNomiDetails(nomineeAdd);
      } else {
        nomineeAdd[index]["guardianDetails"]["guardianAddress"] = {
          ...initialAddressObj,
        };
        setNomiDetails(nomineeAdd);
      }
    } else {
      nomineeAdd[index]["guardianDetails"]["guardianAddress"] = {
        ...initialAddressObj,
      };
      setNomiDetails(nomineeAdd);
    }
  }

  function onRelationChange(type: string, index: number, val: string) {
    let value: string = parseInt(val).toString();

    switch (type) {
      case "email":
        let emailArr = relationshipData.emailMatchedList;
        emailArr[index].relationshipName = value;
        setRelationshipData({
          ...relationshipData,
          emailMatchedList: emailArr,
        });
        break;
      case "mobile":
        let mobileArr = relationshipData.mobileMatchedList;
        mobileArr[index].relationshipName = value;
        setRelationshipData({
          ...relationshipData,
          mobileMatchedList: mobileArr,
        });
        break;
      case "both":
        let bothArr = relationshipData.bothMatchedList;
        bothArr[index].relationshipName = value;
        setRelationshipData({ ...relationshipData, bothMatchedList: bothArr });
        break;
    }
  }

  React.useEffect(() => {
    console.log("familyRelationshipCount RE log = ", familyRelationshipCount);
    console.log("familyRelationshipList RL log = ", familyRelationListMail);
    console.log("familyRelationshipData Data log = ", relationshipDataCount);

    // Rohit code changes starts

    let mobileDropDownList = familyRelationListMail;
    let emailDropDownList = familyRelationListMail;
    let removeFromMobileList: string[] = [];
    let removeFromEmailList: string[] = [];

    // check if data count is greater then 0 for each type and update the list -- mobile // familyRelationshipCount
    if (relationshipDataCount?.AvailableRelationshipTagMobile?.Self == 0) {
      removeFromMobileList.push("1");
    }

    if (
      relationshipDataCount?.AvailableRelationshipTagMobile?.DependentParent ==
      0
    ) {
      removeFromMobileList.push("4");
    }

    if (
      relationshipDataCount?.AvailableRelationshipTagMobile?.DependentChild == 0
    ) {
      removeFromMobileList.push("3");
    }

    if (relationshipDataCount?.AvailableRelationshipTagMobile?.Spouse == 0) {
      removeFromMobileList.push("2");
    }

    // check if data count is greater then 0 for each type and update the list -- email // familyRelationListMail

    if (relationshipDataCount?.AvailableRelationshipTagEmail?.Self == 0) {
      removeFromEmailList.push("1");
    }

    if (
      relationshipDataCount?.AvailableRelationshipTagEmail?.DependentParent == 0
    ) {
      removeFromEmailList.push("4");
    }

    if (
      relationshipDataCount?.AvailableRelationshipTagEmail?.DependentChild == 0
    ) {
      removeFromEmailList.push("3");
    }

    if (relationshipDataCount?.AvailableRelationshipTagEmail?.Spouse == 0) {
      removeFromEmailList.push("2");
    }

    // FIlter out values what all is not required
    const mobileList = mobileDropDownList.filter(
      (i: any) => !removeFromMobileList.includes(i.value)
    );

    const emailList = emailDropDownList.filter(
      (i: any) => !removeFromEmailList.includes(i.value)
    );

    console.log("EMAIL", removeFromEmailList, emailList);
    console.log("Mobile", removeFromMobileList, mobileList);

    // Rohit Code changes ends

    // let familyRelationListCopy = familyRelationList;
    // let familyRelationListMailCopy = familyRelationListMail;
    // if (
    //   familyRelationshipCount.mobile.self ==
    //   relationshipDataCount?.AvailableRelationshipTagMobile?.Self
    // ) {
    //   //something
    //   familyRelationListCopy = familyRelationList.filter(
    //     (item) => item.value != "1"
    //   );
    // }
    // if (
    //   familyRelationshipCount.mobile.spouse ==
    //   relationshipDataCount?.AvailableRelationshipTagMobile?.Spouse
    // ) {
    //   //something
    //   familyRelationListCopy = familyRelationList.filter(
    //     (item) => item.value != "2"
    //   );
    // }
    // if (
    //   familyRelationshipCount.mobile.dependentChild ==
    //   relationshipDataCount?.AvailableRelationshipTagMobile?.DependentChild
    // ) {
    //   //something
    //   familyRelationListCopy = familyRelationList.filter(
    //     (item) => item.value != "3"
    //   );
    // }
    // if (
    //   familyRelationshipCount.mobile.dependentParents ==
    //   relationshipDataCount?.AvailableRelationshipTagMobile?.DependentParent
    // ) {
    //   //something
    //   familyRelationListCopy = familyRelationList.filter(
    //     (item) => item.value != "4"
    //   );
    // }
    // if (
    //   familyRelationshipCount.email.self ==
    //   relationshipDataCount?.AvailableRelationshipTagEmail?.Self
    // ) {
    //   //something
    //   familyRelationListMailCopy = familyRelationListMail.filter(
    //     (item) => item.value != "1"
    //   );
    // }
    // if (
    //   familyRelationshipCount.email.spouse ==
    //   relationshipDataCount?.AvailableRelationshipTagEmail?.Spouse
    // ) {
    //   //something
    //   familyRelationListMailCopy = familyRelationListMail.filter(
    //     (item) => item.value != "2"
    //   );
    // }
    // if (
    //   familyRelationshipCount.email.dependentChild ==
    //   relationshipDataCount?.AvailableRelationshipTagEmail?.DependentChild
    // ) {
    //   //something
    //   familyRelationListMailCopy = familyRelationListMail.filter(
    //     (item) => item.value != "3"
    //   );
    // }
    // if (
    //   familyRelationshipCount.email.dependentParents ==
    //   relationshipDataCount?.AvailableRelationshipTagEmail?.DependentParent
    // ) {
    //   //something
    //   familyRelationListMailCopy = familyRelationListMail.filter(
    //     (item) => item.value != "4"
    //   );
    // }
    setFamilyRelationList(mobileList);
    setFamilyRelationListMail(emailList);
  }, [familyRelationshipCount, relationshipDataCount]);

  function relationshipListFilter(type: string, index: number, val: any) {
    let value = val?.value;
    // let familyRelationshipCountData = familyRelationshipCount;
    // use of accountcode to bind the relatioship data
    console.log("Relationship", val);
    if (type === "mobile") {
      if (value == "1") {
        console.log("limit 1");
        let updatedCount = {
          ...familyRelationshipCount.mobile,
          self: familyRelationshipCount.mobile.self + 1,
        };
        setFamilyRelationshipCount({
          ...familyRelationshipCount,
          mobile: updatedCount,
        });
      } else if (value == "2") {
        console.log("limit 1");
        let updatedCount = {
          ...familyRelationshipCount.mobile,
          spouse: familyRelationshipCount.mobile.spouse + 1,
        };
        setFamilyRelationshipCount({
          ...familyRelationshipCount,
          mobile: updatedCount,
        });
      } else if (value == "3") {
        console.log("limit 2");
        let updatedCount = {
          ...familyRelationshipCount.mobile,
          dependentChild: familyRelationshipCount.mobile.dependentChild + 1,
        };
        setFamilyRelationshipCount({
          ...familyRelationshipCount,
          mobile: updatedCount,
        });
      } else if (value == "4") {
        console.log("limit 2");
        let updatedCount = {
          ...familyRelationshipCount.mobile,
          dependentParents: familyRelationshipCount.mobile.dependentParents + 1,
        };
        setFamilyRelationshipCount({
          ...familyRelationshipCount,
          mobile: updatedCount,
        });
      }
    }
    if (type === "email") {
      if (value == "1") {
        console.log("limit 1");
        let updatedCount = {
          ...familyRelationshipCount.email,
          self: familyRelationshipCount.email.self + 1,
        };
        setFamilyRelationshipCount({
          ...familyRelationshipCount,
          email: updatedCount,
        });
      } else if (value == "2") {
        console.log("limit 1");
        let updatedCount = {
          ...familyRelationshipCount.email,
          spouse: familyRelationshipCount.email.spouse + 1,
        };
        setFamilyRelationshipCount({
          ...familyRelationshipCount,
          email: updatedCount,
        });
      } else if (value == "3") {
        console.log("limit 2");
        let updatedCount = {
          ...familyRelationshipCount.email,
          dependentChild: familyRelationshipCount.email.dependentChild + 1,
        };
        setFamilyRelationshipCount({
          ...familyRelationshipCount,
          email: updatedCount,
        });
      } else if (value == "4") {
        console.log("limit 2");
        let updatedCount = {
          ...familyRelationshipCount.email,
          dependentParents: familyRelationshipCount.email.dependentParents + 1,
        };
        setFamilyRelationshipCount({
          ...familyRelationshipCount,
          email: updatedCount,
        });
      }
    }
  }

  function onRelationBlur(type: string, index: number, val: any) {
    console.log("----- log", val);
    switch (type) {
      case "email":
        let emailArr = relationshipData.emailMatchedList;
        emailArr[index].error = !val ? errorMsg(errorCode.FE20) : "";
        setRelationshipData({
          ...relationshipData,
          emailMatchedList: emailArr,
        });
        relationshipListFilter(type, index, val);
        break;
      case "mobile":
        let mobileArr = relationshipData.mobileMatchedList;
        mobileArr[index].error = !val ? errorMsg(errorCode.FE20) : "";
        setRelationshipData({
          ...relationshipData,
          mobileMatchedList: mobileArr,
        });
        relationshipListFilter(type, index, val);
        break;
      case "both":
        let bothArr = relationshipData.bothMatchedList;
        bothArr[index].relationshipName = !val ? errorMsg(errorCode.FE20) : "";
        setRelationshipData({ ...relationshipData, bothMatchedList: bothArr });
        break;
    }
  }
  function onEmailPhoneChange(key: "email" | "phone", value: string) {
    if (key === "email") {
      if (GlobalStore.user.email === value && isEmailVerified) {
        setShowEmailBtn(false);
        setIsEmailVerified(true);
      } else {
        setShowEmailBtn(true);
        setShowEmailOtp(false);
      }
      setEmail(value);
    }
    if (key === "phone") {
      if (GlobalStore.user.mobile === value) {
        setShowMobileBtn(false);
        setIsMobileVerified(true);
      } else {
        setShowMobileBtn(true);
        setShowMobileOtp(false);
      }
      setPhone(value);
    }
    setErrors({ ...errors, [key]: "" });
  }

  function dropDownBlur(key: string, value: any) {
    typeof value !== "object"
      ? setErrors({ ...errors, [key]: errorMsg(errorCode.FE20) })
      : setErrors({ ...errors, [key]: undefined });
  }

  function onBlurNomDob(event: React.FocusEvent<HTMLInputElement>) {
    !nomDob && setErrors({ ...errors, nomDob: errorMsg(errorCode.FE27) });
  }

  function saveRelationshipData() {
    if (
      relationshipData.emailMatchedList &&
      relationshipData.emailMatchedList.length > 0
    ) {
      relationshipData.emailMatchedList.map((member: object) => {
        if (!member.hasOwnProperty("relationshipName")) {
          // setErrCode('Please Select Relationship in Family Declaration');
          setErrCode(errorMessage.saveRelationshipData);
          return null;
        }
      });
    }
    if (
      relationshipData.mobileMatchedList &&
      relationshipData.mobileMatchedList.length > 0
    ) {
      relationshipData.mobileMatchedList.map((member: object) => {
        if (!member.hasOwnProperty("relationshipName")) {
          // setErrCode('Please Select Relationship in Family Declaration');
          setErrCode(errorMessage.saveRelationshipData);
          return null;
        }
      });
    }
    let saveRelationshipObj = {
      applicationid: GlobalStore.applicationID,
      clientprimarydetailid: parseInt(GlobalStore.clientPrimaryDetailId),
      emailMatchedList: relationshipData.emailMatchedList,
      empcode: 0,
      mobileMatchedList: relationshipData.mobileMatchedList,
    };
    setIsLoading(true);
    ASaveRelationshipData(saveFamilyRelation, saveRelationshipObj);
  }

  function saveFamilyRelation(res: any) {
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (res.data) {
        console.log("in saveFamilyRelation", res);
      }
    }
  }

  function validateNominees(): boolean {
    return validateNomineesInvalid(showNominee, numOfNominee, nomiDetails);
  }

  function validateSubmit(): boolean {
    return getValidationErrors() !== null;
  }

  function getValidationErrors(): string | null {
    console.log("permanentAddress----", permanentAddress, correspondanceAddress);
    
    // NRE/NRO permanent address: ignore numeric codes (0 is valid unset) and Area
    // (Area dropdown is not populated for NRI; City is used instead on save).
    const isPermanentAddressIncomplete = isNriInv
      ? !correspondanceAddress.addressLine1 ||
      !correspondanceAddress.PinCode ||
      !correspondanceAddress.City ||
      !correspondanceAddress.State ||
      !correspondanceAddress.Country
      : Object.values(permanentAddress).some((v) => !v);

    // Build descriptive nominee address error message
    const nomAddrErrNames = Object.entries(nomErrorObj)
      .filter(([, v]) => v)
      .map(([k]) => ADDRESS_FIELD_LABELS[k] || k);
    const nomAddressErrorMsg = nomAddrErrNames.length
      ? `Nominee address has errors. Fields: ${nomAddrErrNames.join(", ")}`
      : "Nominee address has errors";

    // Build descriptive guardian address error message
    const guardAddrErrNames = Object.entries(guardErrorObj)
      .filter(([, v]) => v)
      .map(([k]) => ADDRESS_FIELD_LABELS[k] || k);
    const guardAddrMissingNames = Array.from(
      new Set(
        nomiDetails
          .filter((n: any) => n?.isNomineeMinor)
          .flatMap((n: any) =>
            Object.entries(n?.guardianDetails?.guardianAddress || {})
              .filter(([key, value]) => key !== "Area" && !value)
              .map(([key]) => ADDRESS_FIELD_LABELS[key] || key)
          )
      )
    );
    const allGuardAddrIssues = Array.from(new Set([...guardAddrErrNames, ...guardAddrMissingNames]));
    const guardAddressErrorMsg = allGuardAddrIssues.length
      ? `Guardian details are incomplete. Missing: ${allGuardAddrIssues.join(", ")}`
      : "Guardian details are incomplete";

    // Build descriptive nominee/guardian field message for validateNominees()
    const validateNomineesMsg = (() => {
      const parts: string[] = [];
      nomiDetails.forEach((element: any, idx: number) => {
        const label = nomiDetails.length > 1 ? `Nominee ${idx + 1}` : "Nominee";
        const nomMissing = getMissingNomineeFields(element);
        if (nomMissing.length > 0) {
          parts.push(`${label} details incomplete. Missing: ${nomMissing.join(", ")}`);
        }
        const guardMissing = getMissingGuardianFields(element);
        if (guardMissing.length > 0) {
          parts.push(`${label} guardian details incomplete. Missing: ${guardMissing.join(", ")}`);
        }
      });
      if (parts.length === 0) {
        return isSeniorCitizen ? "Nominee details are required for senior citizen" : "Nominee details are required";
      }
      return parts.join(" | ");
    })();

    const checks: [boolean, string][] = [
      [Object.values(permErrorObj).some(e => e), "Permanent address has errors"],
      [!isOTCFlow && Object.values(nomErrorObj).some(e => e), nomAddressErrorMsg],
      [!isOTCFlow && nomiDetails.some((n: any) => {
        const addr = n?.nomineeAddress;
        const anyFilled = !!(addr?.addressLine1 || addr?.PinCode || addr?.City);
        const allRequired = !!(addr?.addressLine1 && addr?.PinCode);
        return anyFilled && !allRequired;
      }), "Nominee address is incomplete. Please fill in all address fields or leave them all blank"],
      [Object.values(corrErrorObj).some(e => e), "Correspondence address has errors"],
      [nomiDetails.some((n: any) => n?.isNomineeMinor) &&
        (Object.values(guardErrorObj).some(e => e) ||
          nomiDetails.some(
            (n: any) =>
              n?.isNomineeMinor &&
              Object.entries(n?.guardianDetails?.guardianAddress || {})
                .filter(([key]) => key !== "Area")
                .some(([, value]) => !value)
          )),
        guardAddressErrorMsg],

      [(!isOTCFlow || !isNriInv) && isPermanentAddressIncomplete,  isNriInv ? "Foreign address fields are missing" :"Permanent address fields are missing"],
      [!isNriInv && Object.values(correspondanceAddress).some(v => !v), "Correspondence address fields are missing"],

      [relationshipData.mobileMatchedList?.some(v => v.error || !v?.relationshipName) ?? false,
        "Mobile relationship details are invalid"],
      [relationshipData.emailMatchedList?.some(v => v.error || !v?.relationshipName) ?? false,
        "Email relationship details are invalid"],
      [relationshipData?.bothMatchedList?.some(v => v.error || !v?.relationshipName) ?? false,
        "Mobile & Email relationship details are invalid"],

      [!isOTCFlow && validateNominees(), validateNomineesMsg],

      [!isEmailVerified, "Email is not verified"],
      [!isMobileVerified, "Mobile number is not verified"],

      [!email, "Email is required"],
      [!phone, "Phone number is required"],
      [!isOTCFlow && !fatherOrSpouseName.trim(), "Father/Spouse name is required"],
      [!isOTCFlow && !motherName.trim(), "Mother name is required"],
      [!isOTCFlow && !eduQualification, "Educational qualification is required"],
      [!isOTCFlow && !occupation, "Occupation is required"],

      [!indianResident &&
        (nriDetailsObj.country === "" ||
          (nriDetailsObj.idType === "Others" && nriDetailsObj.idTypeOther === "") ||
          nriDetailsObj.idTypeValue === ""), "NRI details are incomplete"],

      [!isOTCFlow && !netWorth, "Net worth is required"],
      [!isOTCFlow && parseInt(netWorth) < 1000, "Net worth must be more than 1000"],

      [!isOTCFlow && !annualIncome, "Annual income is required"],
      [!isOTCFlow && !placeOfBirth, "Place of birth is required"],
      [!nationalityCode && isNriOtc, "Country is required"],

      [Object.values(errors).some(e => e), "There are general form errors"],
    ];

    const failedCheck = checks.find(([condition]) => condition);
    return failedCheck ? failedCheck[1] : null;
  }

  function onBlurPan(error: any, index: number, name: string) {
    const array = JSON.parse(JSON.stringify(validPan));
    handleAddNomineeError(
      index,
      name,
      error.required || !error.pattern ? errorMsg(errorCode.FE07) : ""
    );
    if (error.pattern) {
      array[index] = true;
      setValidPan(array);
    } else {
      array[index] = false;
      setValidPan(array);
    }
  }

  const additionalDetailsOfGuardian = async (
    data: any,
    index: number,
    key: string
  ) => {
    let result = data[index]?.guardianDetails?.identificationDetail?.[key];
    if (!result) {
      let ckycBackup = JSON.parse(
        window.localStorage.getItem("ckycBackup") || "{}"
      );
      result = ckycBackup[index]?.guardianDetails?.identificationDetail?.[key];
    }
    return result;
  };

  const additionalDetailsOfNominee = async (
    data: any,
    index: number,
    key: string
  ) => {
    let result = data?.identificationDetail?.[key];
    if (!result) {
      let ckycBackup = JSON.parse(
        window.localStorage.getItem("ckycBackup") || "{}"
      );
      result = ckycBackup[index]?.identificationDetail?.[key];
    }
    return result;
  };

  const removeSpclCracters = (value: string) => {
    if (value) {
      return value; //.replace(/[^a-zA-Z0-9 ]/g, " ");
    } else {
      return "";
    }
  };

  console.log(
    "holderFirstname",
    GlobalStore.personaldetails.panDetails,

    {
      holderFirstname: GlobalStore?.stageStatus?.panfirstname ?? "",
      holderMiddleName: GlobalStore?.stageStatus?.panmiddletname ?? "",
      holderLastName: GlobalStore?.stageStatus?.panlastname ?? "",
    }
  );

  async function handleSubmit(e: any) {
    e.preventDefault(); // ✅ correct spelling
    const tempValidation = getValidationErrors()
    setValidationErrors(tempValidation || "")

    if (errCode || globalError || errorMatchDetails || tempValidation)
      return

    if (!acknowledged) {
      setErrCode(
        "This will require additional due diligence, hence this account cannot be opened through Digital Mode. Please visit our nearest Branch OR contact support"
      );
      return;
    }
    setIsLoading(true);

    if (!indianResident && (GlobalStore.entitySubType == "Joint" || GlobalStore.entitySubType == "Minor")) {
      setIsLoading(false)
      setGlobalError("We’re sorry, but you can’t proceed further with the account opening process. Our services are currently available only to Indian citizens who pay taxes exclusively in India. Please choose one of the options below to continue.")
      return
    }
    // for AO-1395 KYC/KRA address proof reject
    if (regectedAddressDoc) {
      if (
        JSON.stringify(permanentAddress) !== JSON.stringify(kycAddress) ||
        kycFatherName !== fatherOrSpouseName
      ) {
        GlobalStore.isKRA = false;
        GlobalStore.isKYC = false;
        addressEdited = true;
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
      }
    }

    let sumOfPer = 0;
    for (let i = 0; i < nomiDetails.length; i++) {
      sumOfPer += Number(nomiDetails[i]?.nomPerSharing);
    }
    if (!showNominee || isOTCFlow || sumOfPer === 100) {
      const clientPartialDetails_ao = JSON.parse(
        window.localStorage.getItem("clientPartialDetails_ao") || "{}"
      );
      clientPartialDetails_ao.newLeadStorage = GlobalStore.leadId;
      window.localStorage.setItem(
        "clientPartialDetails_ao",
        JSON.stringify(clientPartialDetails_ao)
      );

      setIsLoading(true);
      if (
        relationshipData?.emailMatchedList?.length > 0 ||
        relationshipData?.mobileMatchedList?.length > 0
      ) {
        saveRelationshipData();
      }
      const objUTM_Info = utmDurationInfoObj(startTime, "profiledur");
      const fatherOrSpouseNames = splitFullName(fatherOrSpouseName);
      const motherNames = splitFullName(motherName);
      const holderNameArr = splitFullName(getFullPANNAMe());

      const correspondanceAddressLine = repairAddressWithConditions(
        correspondanceAddress.addressLine1,
        correspondanceAddress.City
      );
      const permanentAddressLine = repairAddressWithConditions(
        permanentAddress.addressLine1,
        permanentAddress.City
      );
      let holderFirstname = GlobalStore?.stageStatus?.panfirstname,
        holderMiddleName = GlobalStore?.stageStatus?.panmiddletname,
        holderLastName = GlobalStore?.stageStatus?.panlastname;
      if (holderFirstname == "" || holderFirstname == undefined) {
        holderFirstname = clientPartialDetails_ao?.panDetails?.Firstname;
      }
      if (holderMiddleName == "" || holderMiddleName == undefined) {
        holderMiddleName = clientPartialDetails_ao?.panDetails?.Middlename;
      }
      if (holderLastName == "" || holderLastName == undefined) {
        holderLastName = clientPartialDetails_ao?.panDetails?.Lastname;
      }
      const modifiedBy = window.sessionStorage.getItem('empCode')
      const kycObj: any = {
        applicationID: GlobalStore.applicationID,
        clientPrimaryDetailID: GlobalStore.clientPrimaryDetailId,
        isGuardian: false,
        isNominee: showNominee,
        IsCheckedNameOfNominees: togNomineeDetails,
        leadId: GlobalStore.leadId,
        IsOtc: GlobalStore.isOTCFlow,
        // objEcoClientPersoanlDetails: {
        persoanlDetails: {
          KraEmail: GlobalStore.KRA_email ? GlobalStore.KRA_email : "",
          KraMobile: GlobalStore.KRA_mobile ? GlobalStore.KRA_mobile : "",
          Kra_mode: GlobalStore.KRA_mode ? Number(GlobalStore.KRA_mode) : 0,
          aadhaar: "",
          aadhaarName: "",
          additionalEmail: clientPartialDetails_ao.emailID
            ? clientPartialDetails_ao.emailID
            : email,
          additionalMobile: clientPartialDetails_ao.mobile
            ? clientPartialDetails_ao.mobile
            : phone,
          //  birthdate: GlobalStore.birthDate,
          // ckycnumber: GlobalStore.ckycNo,
          ckycNumber: GlobalStore.ckycNo,
          corrsaddraspermanent: sameAsPermanent,
          createdby: parseInt(userId),
          fatherOrSpouseFirstname: fatherOrSpouseNames[0],
          fatherOrSpouseMiddleName: fatherOrSpouseNames[1],
          fatherOrSpouseLastName: fatherOrSpouseNames[2],
          fatherOrSpouseTitle: "Mr",
          flagFS: fatherOrSpouse,
          fsfullName: fatherOrSpouseName,
          gender: gender,
          holderFirstname: holderFirstname ?? "",
          holderMiddleName: holderMiddleName ?? "",
          holderLastName: holderLastName ?? "",
          holderTitle: gender === "F" ? "Ms" : "Mr",
          isKRA: GlobalStore.isKRA,
          isRelationship: false,
          // isdigilocker: GlobalStore.isDigiLocker,
          isDigilocker: GlobalStore.isDigiLocker,
          // iskyc: GlobalStore.isKYC,
          isKyc: GlobalStore.isKYC,
          maidenFirstname: "",
          maidenLastName: "",
          maidenMiddleName: "",
          maritalStatus: maritalStatus,
          maidenTitle: "",
          motherFirstname: motherNames[0],
          motherMiddleName: motherNames[1],
          motherLastName: motherNames[2],
          motherTitle: "Mrs",
          digiKraKycDetailsmodifieddate: addressEdited ? Date.now() : "",
          selfielink: GlobalStore.selfieUrl,
          // objCorrespondenceAddressDetails: {
          correspondenceAddressDetails: {
            // correspondanceAddresstype: addressType, //hardCode
            correspondenceAddressType: addressType, //hardCode
            correspondenceCity: correspondanceAddress.City,
            correspondenceCountry: correspondanceAddress.Country,
            correspondenceDistrict: correspondanceAddress.District,
            correspondencePincode: correspondanceAddress.PinCode,
            correspondenceState: correspondanceAddress.State,
            // correspondancearea: correspondanceAddress.Area,
            correspondenceArea: correspondanceAddress.Area,
            // correspondancecountrycode: correspondanceAddress.CountryCode,
            correspondenceCountryCode: Number(
              correspondanceAddress.CountryCode
            ),
            // correspondancestatecode: correspondanceAddress.StateCode,
            correspondenceStatecode: Number(correspondanceAddress.StateCode),
            correspondenceAddressLine1:
              removeSpclCracters(correspondanceAddressLine.addLine1) || "",
            correspondenceAddressLine2:
              removeSpclCracters(correspondanceAddressLine.addLine2) || "",
            correspondenceAddressLine3:
              removeSpclCracters(correspondanceAddressLine.addLine3) || "",
            correspondenceAddressLine4:
              removeSpclCracters(correspondanceAddressLine.addLine4) || "",
            autoQc: GlobalStore.isKYC
              ? true
              : GlobalStore.personaldetails.aadharName &&
                GlobalStore.personaldetails.aadharName
                  .toLowerCase()
                  .includes(GlobalStore.personaldetails.PANName.toLowerCase())
                ? true
                : false,
            // autoqc: sameAsPermanent &&
            //     (
            //         (
            //             GlobalStore.isDigiLocker && isAadharMasked &&
            //             (aadharName.toLowerCase() === GlobalStore.personaldetails.PANName.toLowerCase())
            //         ) ||
            //         (ocrDetails && (ocrDetails.address === permanentAddress.addressLine1))
            //     )
            //pin code condition need to add ? //hardcode
          },
          // objPermanentAddressDetails: {
          permanentAddressDetails: {
            permanentAddressLine1: removeSpclCracters(
              GlobalStore.isOTCFlow
                ? correspondanceAddressLine.addLine1
                : permanentAddressLine.addLine1
            ) || "",
            permanentAddressLine2: removeSpclCracters(
              GlobalStore.isOTCFlow
                ? correspondanceAddressLine.addLine2
                : permanentAddressLine.addLine2
            ) || "",
            permanentAddressLine3: removeSpclCracters(
              GlobalStore.isOTCFlow
                ? correspondanceAddressLine.addLine3
                : permanentAddressLine.addLine3
            ) || "",
            permanentAddressLine4: removeSpclCracters(
              GlobalStore.isOTCFlow
                ? correspondanceAddressLine.addLine4
                : permanentAddressLine.addLine4
            ) || "",
            permanentAddresstype: addressType, //hardCode
            permanentCity: GlobalStore.isOTCFlow ? correspondanceAddress.City : permanentAddress.City,
            permanentCountry: GlobalStore.isOTCFlow ? correspondanceAddress.Country : permanentAddress.Country,
            permanentDistrict: GlobalStore.isOTCFlow ? correspondanceAddress.District : permanentAddress.District,
            permanentPincode: GlobalStore.isOTCFlow ? correspondanceAddress.PinCode : permanentAddress.PinCode,
            permanentState: GlobalStore.isOTCFlow ? correspondanceAddress.State : permanentAddress.State,
            permanentarea: GlobalStore.isOTCFlow ? correspondanceAddress.Area : permanentAddress.Area || permanentAddress.City,
            permanentcountrycode: GlobalStore.isOTCFlow ? Number(correspondanceAddress.CountryCode) : Number(permanentAddress.CountryCode),
            permanentstatecode: GlobalStore.isOTCFlow ? Number(correspondanceAddress.StateCode) : Number(permanentAddress.StateCode),
            autoQc: GlobalStore.isKYC
              ? true
              : GlobalStore.personaldetails.aadharName &&
                GlobalStore.personaldetails.aadharName
                  .toLowerCase()
                  .includes(GlobalStore.personaldetails.PANName.toLowerCase())
                ? true
                : false,
            // autoqc: (
            //     GlobalStore.isDigiLocker && isAadharMasked &&
            //     (aadharName.toLowerCase() === GlobalStore.personaldetails.PANName.toLowerCase())
            // ) || (ocrDetails && (ocrDetails.address === permanentAddress.addressLine1))
          },
          others: "",
          relationshipName: "",
          relationshipnamefordiy: "",
          disability: Number(disability),
        },
        // listMultiplenomineeDetails: [],
        listNomineeDetails: [],
        // objEcoProfileDetails: {
        profileDetails: {
          accountCategory: staffCode
            ? employeeAccCategory
            : GlobalStore.stageStatus.isPCGSubLob
              ? PCGAccCategory
              : retailAccCategory,
          annualIncomeRange: annualIncome,
          clientGroup4: clientGroup4, //hardCode
          education: eduQualification,
          netWorthwhenAcOpen: parseInt(netWorth),
          occupation: occupation,
          ddpi_type: POAType ? 1 : 0,
          applicationType:
            defaultAccountType === "Ordinary Resident Demat and Trading Account"
              ? "1"
              : "2",
          pep: politicalVal,
          periodicSettlement: parseInt(periodicSettlement),
          placeofbirth: placeOfBirth,
          staffCode: staffCode,
          taxResidentOfOtherCountry: !indianResident,
          listTaxrRsidentofIndia: !indianResident
            ? [
              {
                identificationNumber: nriDetailsObj.idTypeValue,
                identificationType: nriDetailsObj.idType,
                identificationType_Other: nriDetailsObj.idTypeOther || "TIN",
                oCountry: nriDetailsObj.country,
              },
            ]
            : null,
          nationality: nationalityCode
        },
        createdBy: parseInt(userId),
        ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0,
        //   utmInfoDetails: objUTM_Info,
      };

      const listMultipleGuardianDetails = [];
      let srNo = 0;
      for (let i = 0; i < nomiDetails.length; i++) {
        if (nomiDetails[i].isNomineeMinor && nomiDetails[i].guardianDetails) {
          const guardianNames = splitFullName(
            nomiDetails[i]?.guardianDetails?.guardFullName || ""
          );
          const guardianAddressLine = repairAddressWithConditions(
            nomiDetails[i]?.guardianDetails?.guardianAddress.addressLine1,
            nomiDetails[i]?.guardianDetails?.guardianAddress.city
          );

          listMultipleGuardianDetails.push({
            annualIncomeRange:
              nomiDetails[i]?.guardianDetails?.guardAnnualIncome,
            dob: moment(nomiDetails[i]?.guardianDetails?.dob).format(
              "YYYY-MM-DD"
            ),
            education: nomiDetails[i]?.guardianDetails?.guardEduQualification,
            holderId: 5,
            isSamePermenantAddress: true,
            isMinor: false,
            firstName: guardianNames[0],
            middleName: guardianNames[1],
            lastName: guardianNames[2],
            netWorthwhenAcOpen: parseInt(
              nomiDetails[i]?.guardianDetails?.guardNetWorth
            ),
            correspondenceAddressDetails: {
              correspondenceAddressType: addressType,
              correspondenceCity:
                nomiDetails[i]?.guardianDetails?.guardianAddress.City,
              correspondenceCountry:
                nomiDetails[i]?.guardianDetails?.guardianAddress.Country,
              correspondenceDistrict:
                nomiDetails[i]?.guardianDetails?.guardianAddress.District,
              correspondencePincode:
                nomiDetails[i]?.guardianDetails?.guardianAddress.PinCode,
              correspondenceState:
                nomiDetails[i]?.guardianDetails?.guardianAddress.State,
              correspondenceArea:
                nomiDetails[i]?.guardianDetails?.guardianAddress.Area,
              correspondenceCountryCode:
                nomiDetails[i]?.guardianDetails?.guardianAddress.CountryCode,
              correspondenceStatecode:
                nomiDetails[i]?.guardianDetails?.guardianAddress.StateCode,
              correspondenceAddressLine1: removeSpclCracters(
                guardianAddressLine.addLine1
              ),
              correspondenceAddressLine2: removeSpclCracters(
                guardianAddressLine.addLine2
              ),
              correspondenceAddressLine3: removeSpclCracters(
                guardianAddressLine.addLine3
              ),
              correspondenceAddressLine4: removeSpclCracters(
                guardianAddressLine.addLine4
              ),
              autoQc: false,
            },
            permanentAddressDetails: {
              permanentAddressLine1: removeSpclCracters(
                guardianAddressLine.addLine1
              ),
              permanentAddressLine2: removeSpclCracters(
                guardianAddressLine.addLine2
              ),
              permanentAddressLine3: removeSpclCracters(
                guardianAddressLine.addLine3
              ),
              permanentAddressLine4: removeSpclCracters(
                guardianAddressLine.addLine4
              ),
              permanentAddresstype: addressType,
              permanentCity:
                nomiDetails[i]?.guardianDetails?.guardianAddress.City,
              permanentCountry:
                nomiDetails[i]?.guardianDetails?.guardianAddress.Country,
              permanentDistrict:
                nomiDetails[i]?.guardianDetails?.guardianAddress.District,
              permanentPincode:
                nomiDetails[i]?.guardianDetails?.guardianAddress.PinCode,
              permanentState:
                nomiDetails[i]?.guardianDetails?.guardianAddress.State,
              permanentarea:
                nomiDetails[i]?.guardianDetails?.guardianAddress.Area,
              permanentcountrycode:
                nomiDetails[i]?.guardianDetails?.guardianAddress.CountryCode,
              permanentstatecode:
                nomiDetails[i]?.guardianDetails?.guardianAddress.StateCode,
              autoQc: false,
            },
            occupation: nomiDetails[i]?.guardianDetails?.guardOccupation,
            pep: nomiDetails[i]?.guardianDetails?.guardPoliticalVal,
            placeofbirth: nomiDetails[i]?.guardianDetails?.guardPlaceOfBirth,
            relationship: nomiDetails[i]?.guardianDetails?.guardRelation,
            title: nomiDetails[i]?.guardianDetails?.guardTitle,
            additionalDetails: await additionalDetailsOfGuardian(
              nomiDetails,
              i,
              "name"
            ),
            additionalDetailsValue:
              // "guardian" + (i + 1),
              await additionalDetailsOfGuardian(nomiDetails, i, "value"),
            gurdianMap: `4_${i}`,
            // srNo: srNo,
            srNo: i,
          });
          srNo += 1;
        }
      }
      kycObj["listGuardianDetails"] = listMultipleGuardianDetails;

      if (listMultipleGuardianDetails && listMultipleGuardianDetails.length)
        kycObj["isGuardian"] = true;

      const listMultiplenomineeDetails = [];
      if (showNominee && numOfNominee > 0) {
        // Reset so nominee srNo is independent of the guardian loop above
        // (which reuses/increments the same srNo counter).
        srNo = 0;
        for (let j = 0; j < nomiDetails.length; j++) {

          const singleNomineeDetails = nomiDetails[j];
          const nomineeNames = splitFullName(singleNomineeDetails?.nomFullName);
          const nomineeAddressLine = repairAddressWithConditions(
            singleNomineeDetails.nomineeAddress.addressLine1,
            singleNomineeDetails.nomineeAddress.city
          );

          listMultiplenomineeDetails.push({
            dob: moment(singleNomineeDetails.nomDob).format("YYYY-MM-DD"),
            holderId: 4,
            isMinor: singleNomineeDetails.isNomineeMinor,
            firstName: nomineeNames[0],
            middleName: nomineeNames[1],
            lastName: nomineeNames[2],
            netWorthwhenAcOpen: 1000,
            correspondenceAddressDetails: {
              correspondenceAddressType: addressType,
              correspondenceCity: singleNomineeDetails.nomineeAddress.City,
              correspondenceCountry:
                singleNomineeDetails.nomineeAddress.Country,
              correspondenceDistrict:
                singleNomineeDetails.nomineeAddress.District,
              correspondencePincode:
                singleNomineeDetails.nomineeAddress.PinCode || null,
              correspondenceState: singleNomineeDetails.nomineeAddress.State,
              correspondenceArea: singleNomineeDetails.nomineeAddress.Area,
              correspondenceCountryCode:
                singleNomineeDetails.nomineeAddress.CountryCode,
              correspondenceStatecode:
                singleNomineeDetails.nomineeAddress.StateCode,
              correspondenceAddressLine1: removeSpclCracters(
                nomineeAddressLine.addLine1
              ),
              correspondenceAddressLine2: removeSpclCracters(
                nomineeAddressLine.addLine2
              ),
              correspondenceAddressLine3: removeSpclCracters(
                nomineeAddressLine.addLine3
              ),
              correspondenceAddressLine4: removeSpclCracters(
                nomineeAddressLine.addLine4
              ),
              autoQc: false,
            },
            permanentAddressDetails: {
              permanentAddressLine1: removeSpclCracters(
                nomineeAddressLine.addLine1
              ),
              permanentAddressLine2: removeSpclCracters(
                nomineeAddressLine.addLine2
              ),
              permanentAddressLine3: removeSpclCracters(
                nomineeAddressLine.addLine3
              ),
              permanentAddressLine4: removeSpclCracters(
                nomineeAddressLine.addLine4
              ),
              permanentAddresstype: addressType,
              permanentCity: singleNomineeDetails.nomineeAddress.City,
              permanentCountry: singleNomineeDetails.nomineeAddress.Country,
              permanentDistrict: singleNomineeDetails.nomineeAddress.District,
              permanentPincode: singleNomineeDetails.nomineeAddress.PinCode || null,
              permanentState: singleNomineeDetails.nomineeAddress.State,
              permanentarea: singleNomineeDetails.nomineeAddress.Area,
              permanentcountrycode:
                singleNomineeDetails.nomineeAddress.CountryCode,
              permanentstatecode: singleNomineeDetails.nomineeAddress.StateCode,
              autoQc: false,
            },
            relationship: singleNomineeDetails.nomRelation,
            title: singleNomineeDetails.nomTitle,
            additionalDetails: await additionalDetailsOfNominee(
              singleNomineeDetails,
              j,
              "name"
            ),
            // singleNomineeDetails?.identificationDetail?.name,
            additionalDetailsValue:
              // "Nominee" + (j + 1),
              await additionalDetailsOfNominee(
                singleNomineeDetails,
                j,
                "value"
              ),
            // singleNomineeDetails?.identificationDetail?.value,
            srNo: srNo,
            sharePercentage:
              singleNomineeDetails?.nomPerSharing !== undefined &&
                singleNomineeDetails?.nomPerSharing !== null &&
                String(singleNomineeDetails?.nomPerSharing).trim() !== ""
                ? Number(singleNomineeDetails?.nomPerSharing)
                : null,
            emailID: singleNomineeDetails.nomEmail,
            mobile: singleNomineeDetails.nomMobile,
          });
          srNo += 1;
        }
      }
      kycObj["listNomineeDetails"] = listMultiplenomineeDetails;

      //temp fix for address flag issue as not able to reproduce the issue
      var correspondenceAddressCheck =
        kycObj["persoanlDetails"]["correspondenceAddressDetails"];
      var permanentAddressCheck =
        kycObj["persoanlDetails"]["permanentAddressDetails"];

      if (isNriInv) {
        kycObj["persoanlDetails"]["corrsaddraspermanent"] = false;
        kycObj["persoanlDetails"]["correspondenceAddressDetails"]["correspondenceCity"] = correspondanceAddress.City
        kycObj["persoanlDetails"]["correspondenceAddressDetails"]["correspondenceDistrict"] = correspondanceAddress.State
        kycObj["persoanlDetails"]["correspondenceAddressDetails"]["correspondencePincode"] = correspondanceAddress.PinCode
        kycObj["persoanlDetails"]["correspondenceAddressDetails"]["correspondenceState"] = correspondanceAddress.State
        kycObj["persoanlDetails"]["correspondenceAddressDetails"]["correspondenceArea"] = correspondanceAddress.City
        kycObj["persoanlDetails"]["correspondenceAddressDetails"]["correspondenceStatecode"] = 0
      } else if (
        (correspondenceAddressCheck.correspondenceAddressLine1 ==
          permanentAddressCheck.permanentAddressLine1 &&
          correspondenceAddressCheck.correspondenceAddressLine2 ==
          permanentAddressCheck.permanentAddressLine2 &&
          correspondenceAddressCheck.correspondenceAddressLine3 ==
          permanentAddressCheck.permanentAddressLine3 &&
          correspondenceAddressCheck.correspondenceAddressLine4 ==
          permanentAddressCheck.permanentAddressLine4 &&
          correspondenceAddressCheck.correspondenceCity ==
          permanentAddressCheck.permanentCity &&
          correspondenceAddressCheck.correspondenceCountry ==
          permanentAddressCheck.permanentCountry &&
          correspondenceAddressCheck.correspondenceDistrict ==
          permanentAddressCheck.permanentDistrict &&
          correspondenceAddressCheck.correspondencePincode ==
          permanentAddressCheck.permanentPincode &&
          correspondenceAddressCheck.correspondenceState ==
          permanentAddressCheck.permanentState &&
          correspondenceAddressCheck.correspondenceArea ==
          permanentAddressCheck.permanentarea) ||
        GlobalStore.isDigiLocker
      ) {
        kycObj["persoanlDetails"]["corrsaddraspermanent"] = true;
      } else {
        if (sameAsPermanent || GlobalStore.isOTCFlow) {
          kycObj["persoanlDetails"]["corrsaddraspermanent"] = true;
        } else kycObj["persoanlDetails"]["corrsaddraspermanent"] = false;
      }
      if (GlobalStore?.stageStatus?.accountcategory === 2) {
        delete kycObj.periodicSettlement;
        delete kycObj.ddpi_type;
        delete kycObj.applicationType;
      }

      if (GlobalStore.isOTCFlow && !GlobalStore.isKRA) {
        kycObj["persoanlDetails"]["fatherOrSpouseTitle"] = ""
        kycObj["persoanlDetails"]["maritalStatus"] = ""
        kycObj["persoanlDetails"]["motherTitle"] = ""
        kycObj["profileDetails"]["periodicSettlement"] = 0
      }

      ASaveKycDetails(saveKycDetails, kycObj);
    } else {
      setGlobalError("Nominee % sharing should be 100");
      setIsLoading(false);
      return;
    }
  }

  console.log("nomineeList", nomineeList);

  function saveKycDetails(res: any) {
    setIsLoading(true);
    console.log("function called");
    if (!res || res.error) {
      // setErrCode('1120 - Failed to save the KYC details');
      // setErrCode(errorMessage.saveKycDetails);
      setErrCode(res.error);
      setIsLoading(false);
    } else {
      if (res.data) {
        // Check if any nominee and additional identification is Photo & Signature
        // if found hit save document details API // Added by rohit
        let toCheckString = ["Photo and Signature of the Nominee/guardian"];
        let toCheckPhoto = nomiDetails.filter((ele: any) =>
          toCheckString.includes(ele?.identificationDetail?.name)
        );

        // if (showNominee && numOfNominee > 0 && toCheckPhoto.length > 0) {
        //   saveNomineeDocuments();
        // } else {
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.emailID = email;
        clientPartialDetails_ao.mobile = phone;
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        completeModuleStatus(dashboardUrl.profile);
        completeModuleStatus(dashboardUrl.personalIfo);
        gtmService({ action: "PROFILE_DETAILS", label: "Step_Complete" });

        // Submit the clevertap event for profile submit
        const data = {
          EventName:
            cleverTapEvents.registration.profilePage.CLICK_ON_SUBMIT_PROFILE,
          InitiationPlatform: "",
          UTM_SOURCE,
          UTM_MEDIUM,
          UTM_CAMPAIGN,
          KRA: GlobalStore.isKRA,
          ADHAR_LINKED_WITH_MOBILE: GlobalStore.aadharLinkedChoice,
          DIGILOCKER_PROCESS: GlobalStore.isDigiLocker,
          LEAD_ID: GlobalStore.leadId,
          REF_ID: GlobalStore.applicationID,
        };

        ClevertapService.pushEvent(data);
        // Clevertap code end

        // Apps flyer event for click on proceed on profile details page
        AppsFlyerService.pushEvent(
          appsFlyerEvents.registration.profilePage.CLICK_ON_SUBMIT_PROFILE
        );

        // history.push(incompleteStageNavigation());
        navigate(incompleteStageNavigation())
        // }
      } else {
        // setErrCode('1121 - Failed to save the KYC details');
        setErrCode(res.error);
        setIsLoading(false);
      }
    }
  }

  // async function saveNomineeDocuments() {
  //   var nomineeDocs = nomineeDocuments;
  //   const saveDetails = [];
  //   if (nomineeDocs.nomineeOne) {
  //     if (nomineeDocs.nomineeOne.photo && newUploads[0].isPhoto === true) {
  //       let nomineeOnePhoto = {
  //         documentCategoryId:
  //           nomineeDocsIds.nomineeOne.photo.documentCategoryId?.toString(),
  //         documentId: nomineeDocsIds.nomineeOne.photo.documentId?.toString(),
  //         documentexpirydate: "",
  //         fileName: nomineeDocs.nomineeOne.photo.fileName,
  //         isfilecropped: true,
  //         mimeType: nomineeDocs.nomineeOne.photo.mimeType,
  //         panno: GlobalStore.personaldetails.pan,
  //         personaldetailsid: "0",
  //         autoqc: false,
  //         // "autoqc": autoQc
  //       };
  //       saveDetails.push(nomineeOnePhoto);
  //     }
  //     if (
  //       nomineeDocs.nomineeOne.signature &&
  //       newUploads[0].isSignature === true
  //     ) {
  //       let nomineeOneSignature = {
  //         documentCategoryId:
  //           nomineeDocsIds.nomineeOne.signature.documentCategoryId?.toString(),
  //         documentId:
  //           nomineeDocsIds.nomineeOne.signature.documentId?.toString(),
  //         documentexpirydate: "",
  //         fileName: nomineeDocs.nomineeOne.signature.fileName,
  //         isfilecropped: true,
  //         mimeType: nomineeDocs.nomineeOne.signature.mimeType,
  //         panno: GlobalStore.personaldetails.pan,
  //         personaldetailsid: "0",
  //         autoqc: false,
  //         // "autoqc": autoQc
  //       };
  //       saveDetails.push(nomineeOneSignature);
  //     }
  //     if (nomineeDocs.nomineeOne.guardianDetails) {
  //       if (
  //         nomineeDocs.nomineeOne.guardianDetails.photo &&
  //         newUploads[0].guardian.isPhoto === true
  //       ) {
  //         let nomineeOneGuardianPhoto = {
  //           documentCategoryId:
  //             nomineeDocsIds.nomineeOne.guardianDetails.photo.documentCategoryId?.toString(),
  //           documentId:
  //             nomineeDocsIds.nomineeOne.guardianDetails.photo.documentId?.toString(),
  //           documentexpirydate: "",
  //           fileName: nomineeDocs.nomineeOne.guardianDetails.photo.fileName,
  //           isfilecropped: true,
  //           mimeType: nomineeDocs.nomineeOne.guardianDetails.photo.mimeType,
  //           panno: GlobalStore.personaldetails.pan,
  //           personaldetailsid: "0",
  //           autoqc: false,
  //           // "autoqc": autoQc
  //         };
  //         saveDetails.push(nomineeOneGuardianPhoto);
  //       }
  //       if (
  //         nomineeDocs.nomineeOne.guardianDetails.signature &&
  //         newUploads[0].guardian.isSignature === true
  //       ) {
  //         let nomineeOneGuardianSignature = {
  //           documentCategoryId:
  //             nomineeDocsIds.nomineeOne.guardianDetails.signature.documentCategoryId?.toString(),
  //           documentId:
  //             nomineeDocsIds.nomineeOne.guardianDetails.signature.documentId?.toString(),
  //           documentexpirydate: "",
  //           fileName: nomineeDocs.nomineeOne.guardianDetails.signature.fileName,
  //           isfilecropped: true,
  //           mimeType: nomineeDocs.nomineeOne.guardianDetails.signature.mimeType,
  //           panno: GlobalStore.personaldetails.pan,
  //           personaldetailsid: "0",
  //           autoqc: false,
  //           // "autoqc": autoQc
  //         };
  //         saveDetails.push(nomineeOneGuardianSignature);
  //       }
  //     }
  //   }

  //   if (nomineeDocs.nomineeTwo) {
  //     if (nomineeDocs.nomineeTwo.photo && newUploads[1].isPhoto === true) {
  //       let nomineeTwoPhoto = {
  //         documentCategoryId:
  //           nomineeDocsIds.nomineeTwo.photo.documentCategoryId?.toString(),
  //         documentId: nomineeDocsIds.nomineeTwo.photo.documentId?.toString(),
  //         documentexpirydate: "",
  //         fileName: nomineeDocs.nomineeTwo.photo.fileName,
  //         isfilecropped: true,
  //         mimeType: nomineeDocs.nomineeTwo.photo.mimeType,
  //         panno: GlobalStore.personaldetails.pan,
  //         personaldetailsid: "0",
  //         autoqc: false,
  //         // "autoqc": autoQc
  //       };
  //       saveDetails.push(nomineeTwoPhoto);
  //     }
  //     if (
  //       nomineeDocs.nomineeTwo.signature &&
  //       newUploads[1].isSignature === true
  //     ) {
  //       let nomineeTwoSignature = {
  //         documentCategoryId:
  //           nomineeDocsIds.nomineeTwo.signature.documentCategoryId?.toString(),
  //         documentId:
  //           nomineeDocsIds.nomineeTwo.signature.documentId?.toString(),
  //         documentexpirydate: "",
  //         fileName: nomineeDocs.nomineeTwo.signature.fileName,
  //         isfilecropped: true,
  //         mimeType: nomineeDocs.nomineeTwo.signature.mimeType,
  //         panno: GlobalStore.personaldetails.pan,
  //         personaldetailsid: "0",
  //         autoqc: false,
  //         // "autoqc": autoQc
  //       };
  //       saveDetails.push(nomineeTwoSignature);
  //     }
  //     if (nomineeDocs.nomineeTwo.guardianDetails) {
  //       if (
  //         nomineeDocs.nomineeTwo.guardianDetails &&
  //         newUploads[1].guardian.isPhoto === true
  //       ) {
  //         let nomineeTwoGuardianPhoto = {
  //           documentCategoryId:
  //             nomineeDocsIds.nomineeTwo.guardianDetails.photo.documentCategoryId?.toString(),
  //           documentId:
  //             nomineeDocsIds.nomineeTwo.guardianDetails.photo.documentId?.toString(),
  //           documentexpirydate: "",
  //           fileName: nomineeDocs.nomineeTwo.guardianDetails.photo.fileName,
  //           isfilecropped: true,
  //           mimeType: nomineeDocs.nomineeTwo.guardianDetails.photo.mimeType,
  //           panno: GlobalStore.personaldetails.pan,
  //           personaldetailsid: "0",
  //           autoqc: false,
  //           // "autoqc": autoQc
  //         };
  //         saveDetails.push(nomineeTwoGuardianPhoto);
  //       }
  //       if (
  //         nomineeDocs.nomineeTwo.guardianDetails.signature &&
  //         newUploads[1].guardian.isSignature === true
  //       ) {
  //         let nomineeTwoGuardianSignature = {
  //           documentCategoryId:
  //             nomineeDocsIds.nomineeTwo.guardianDetails.signature.documentCategoryId?.toString(),
  //           documentId:
  //             nomineeDocsIds.nomineeTwo.guardianDetails.signature.documentId?.toString(),
  //           documentexpirydate: "",
  //           fileName: nomineeDocs.nomineeTwo.guardianDetails.signature.fileName,
  //           isfilecropped: true,
  //           mimeType: nomineeDocs.nomineeTwo.guardianDetails.signature.mimeType,
  //           panno: GlobalStore.personaldetails.pan,
  //           personaldetailsid: "0",
  //           autoqc: false,
  //           // "autoqc": autoQc
  //         };
  //         saveDetails.push(nomineeTwoGuardianSignature);
  //       }
  //     }
  //   }

  //   if (nomineeDocs.nomineeThree) {
  //     if (nomineeDocs.nomineeThree.photo && newUploads[2].isPhoto === true) {
  //       let nomineeThreePhoto = {
  //         documentCategoryId:
  //           nomineeDocsIds.nomineeThree.photo.documentCategoryId?.toString(),
  //         documentId: nomineeDocsIds.nomineeThree.photo.documentId?.toString(),
  //         documentexpirydate: "",
  //         fileName: nomineeDocs.nomineeThree.photo.fileName,
  //         isfilecropped: true,
  //         mimeType: nomineeDocs.nomineeThree.photo.mimeType,
  //         panno: GlobalStore.personaldetails.pan,
  //         personaldetailsid: "0",
  //         autoqc: false,
  //         // "autoqc": autoQc
  //       };
  //       saveDetails.push(nomineeThreePhoto);
  //     }
  //     if (
  //       nomineeDocs.nomineeThree.signature &&
  //       newUploads[2].isSignature === true
  //     ) {
  //       let nomineeThreeSignature = {
  //         documentCategoryId:
  //           nomineeDocsIds.nomineeThree.signature.documentCategoryId?.toString(),
  //         documentId:
  //           nomineeDocsIds.nomineeThree.signature.documentId?.toString(),
  //         documentexpirydate: "",
  //         fileName: nomineeDocs.nomineeThree.signature.fileName,
  //         isfilecropped: true,
  //         mimeType: nomineeDocs.nomineeThree.signature.mimeType,
  //         panno: GlobalStore.personaldetails.pan,
  //         personaldetailsid: "0",
  //         autoqc: false,
  //         // "autoqc": autoQc
  //       };
  //       saveDetails.push(nomineeThreeSignature);
  //     }
  //     if (nomineeDocs.nomineeThree.guardianDetails) {
  //       if (
  //         nomineeDocs.nomineeThree.guardianDetails.photo &&
  //         newUploads[2].guardian.isPhoto === true
  //       ) {
  //         let nomineeThreeGuardianPhoto = {
  //           documentCategoryId:
  //             nomineeDocsIds.nomineeThree.guardianDetails.photo.documentCategoryId?.toString(),
  //           documentId:
  //             nomineeDocsIds.nomineeThree.guardianDetails.photo.documentId?.toString(),
  //           documentexpirydate: "",
  //           fileName: nomineeDocs.nomineeThree.guardianDetails.photo.fileName,
  //           isfilecropped: true,
  //           mimeType: nomineeDocs.nomineeThree.guardianDetails.photo.mimeType,
  //           panno: GlobalStore.personaldetails.pan,
  //           personaldetailsid: "0",
  //           autoqc: false,
  //           // "autoqc": autoQc
  //         };
  //         saveDetails.push(nomineeThreeGuardianPhoto);
  //       }
  //       if (
  //         nomineeDocs.nomineeThree.guardianDetails.signature &&
  //         newUploads[2].guardian.isSignature === true
  //       ) {
  //         let nomineeThreeGuardianSignature = {
  //           documentCategoryId:
  //             nomineeDocsIds.nomineeThree.guardianDetails.signature.documentCategoryId?.toString(),
  //           documentId:
  //             nomineeDocsIds.nomineeThree.guardianDetails.signature.documentId?.toString(),
  //           documentexpirydate: "",
  //           fileName:
  //             nomineeDocs.nomineeThree.guardianDetails.signature.fileName,
  //           isfilecropped: true,
  //           mimeType:
  //             nomineeDocs.nomineeThree.guardianDetails.signature.mimeType,
  //           panno: GlobalStore.personaldetails.pan,
  //           personaldetailsid: "0",
  //           autoqc: false,
  //           // "autoqc": autoQc
  //         };
  //         saveDetails.push(nomineeThreeGuardianSignature);
  //       }
  //     }
  //   }

  //   console.log("saveDetails", saveDetails);
  //   //setIsLoading(false);
  //   const objUTM_Info = utmDurationInfoObj(startTime, "documentsdur");
  //   const saveObj = {
  //     applicationId: GlobalStore.applicationID,
  //     clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
  //     documentInfo: saveDetails,
  //     leadId: GlobalStore.leadId,
  //     objUTM_Info: objUTM_Info,
  //   };

  //   ASaveDocumentDetails(getSaveStatus, saveObj);

  //   //return true;
  // }

  const getSaveStatus = (res: any) => {
    if (!res || res.error) {
      //setErrCode(1641)
      setIsLoading(false);
      return false;
    } else {
      if (res.data) {
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.emailID = email;
        clientPartialDetails_ao.mobile = phone;
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        completeModuleStatus(dashboardUrl.profile);
        completeModuleStatus(dashboardUrl.personalIfo);
        gtmService({ action: "PROFILE_DETAILS", label: "Step_Complete" });

        // Submit the clevertap event for profile submit
        const data = {
          EventName:
            cleverTapEvents.registration.profilePage.CLICK_ON_SUBMIT_PROFILE,
          InitiationPlatform: "",
          UTM_SOURCE,
          UTM_MEDIUM,
          UTM_CAMPAIGN,
          KRA: GlobalStore.isKRA,
          ADHAR_LINKED_WITH_MOBILE: GlobalStore.aadharLinkedChoice,
          DIGILOCKER_PROCESS: GlobalStore.isDigiLocker,
          LEAD_ID: GlobalStore.leadId,
          REF_ID: GlobalStore.applicationID,
        };

        ClevertapService.pushEvent(data);
        // Clevertap code end

        // Apps flyer event for click on proceed on profile details page
        AppsFlyerService.pushEvent(
          appsFlyerEvents.registration.profilePage.CLICK_ON_SUBMIT_PROFILE
        );

        // history.push(incompleteStageNavigation());
        navigate(incompleteStageNavigation())
      }
    }
  };

  function onChange(key: string, value: string) {
    setPlaceOfBirth(value);
  }

  function handleCityBlur(value: any) {
    if (typeof value === "object") {
      setErrors({ ...errors, placeOfBirth: "" });
    } else {
      setErrors({
        ...errors,
        placeOfBirth: errorMsg(errorCode.FE39),
      });
    }
  }

  //  console.log('buttonDisabled?: ', validateSubmit());
  // console.log('value for nominee', nomiDetails);
  const handleRemoveDoc = (
    index: number,
    identityId: string,
    removeDocObj: any
  ) => {
    console.log("HandleRemoveDoc", index, identityId, removeDocObj);
  };

  const handleAddNomineeValue = (name: string, index: number, value: any) => {
    console.log("value omn change fun ==>", value, name);

    try {
      const array = JSON.parse(JSON.stringify(nomiDetails));
      if (name === "identificationDetail") {
        array[index][name] = buildIdentificationDetail(
          value,
          "Nominee" + (index + 1)
        );

        var objNomineeDocs = nomineeDocuments;

        if (value?.value == 1) {
          let imgOfAddlIdentDtls = JSON.parse(
            JSON.stringify(imgOfAddlIdentDetails)
          );
          imgOfAddlIdentDtls[index]["nomineeAddDtls"] = {
            isPhoto: false,
            isSignature: false,
          };
          setImgOfAddlIdentDetails(imgOfAddlIdentDtls);
          if (index == 0) {
            objNomineeDocs.nomineeOne.photo = { ...initialDocObj };
            objNomineeDocs.nomineeOne.signature = { ...initialDocObj };
            setNomineeDocuments(objNomineeDocs);
          }

          if (index == 1) {
            objNomineeDocs.nomineeTwo.photo = { ...initialDocObj };
            objNomineeDocs.nomineeTwo.signature = { ...initialDocObj };
            setNomineeDocuments(objNomineeDocs);
          }

          if (index == 2) {
            objNomineeDocs.nomineeThree.photo = { ...initialDocObj };
            objNomineeDocs.nomineeThree.signature = { ...initialDocObj };
            setNomineeDocuments(objNomineeDocs);
          }
        } else {
          let imgOfAddlIdentDtls = JSON.parse(
            JSON.stringify(imgOfAddlIdentDetails)
          );
          imgOfAddlIdentDtls[index]["nomineeAddDtls"] = {
            isPhoto: true,
            isSignature: true,
          };
          setImgOfAddlIdentDetails(imgOfAddlIdentDtls);
          if (index == 0) {
            delete objNomineeDocs.nomineeOne.photo;
            delete objNomineeDocs.nomineeOne.signature;
            setNomineeDocuments(objNomineeDocs);
          }
          if (index == 1) {
            delete objNomineeDocs.nomineeTwo.photo;
            delete objNomineeDocs.nomineeTwo.signature;
            setNomineeDocuments(objNomineeDocs);
          }
          if (index == 2) {
            delete objNomineeDocs.nomineeThree.photo;
            delete objNomineeDocs.nomineeThree.signature;
            setNomineeDocuments(objNomineeDocs);
          }
        }
        setAddlIdentDetailsValue(false);
      } else if (name === "identificationDetailValue") {
        if (!array[index]["identificationDetail"]) {
          array[index]["identificationDetail"] = {};
        }
        array[index]["identificationDetail"]["value"] = value;
        setAddlIdentDetailsValue(true);
      } else {
        array[index][name] = value;
      }

      if (value) {
        if (array[index]["error"] && array[index]["error"][name]) {
          console.log("error from on change", array[index]["error"]);

          array[index]["error"][name] = undefined;
        }
      }

      if (name === "nomDob" && ageCalculator(value) < 18) {
        array[index]["isNomineeMinor"] = true;
        array[index]["guardianDetails"] = {};
        array[index]["guardianDetails"]["guardPoliticalVal"] = "0";
        array[index]["guardianDetails"]["guardianAddress"] = {
          ...initialAddressObj,
        };
        array[index]["guardianDetails"]["sameAsNominee"] = false;
      } else if (name === "nomDob" && ageCalculator(value) >= 18) {
        array[index]["error"]["guardAnnualIncome"] = "";
        array[index]["error"]["guardFullName"] = "";
        array[index]["error"]["guardOccupation"] = "";
        array[index]["error"]["guardPlaceOfBirth"] = "";
        array[index]["error"]["guardRelation"] = "";
        array[index]["error"]["guardTitle"] = "";

        array[index]["isNomineeMinor"] = false;
      }

      if (name === "nomPerSharing") {
        if (numOfNominee !== 1) {
          for (let i = 0; i < numOfNominee; i++) {
            if (i !== index) {
              const remainigPer = (100 - Number(value)) / (numOfNominee - 1);
              array[i]["nomPerSharing"] = remainigPer;
            }
          }
        }
      }

      setNomiDetails(array);

      window.localStorage.removeItem("ckycBackup");
      localStorage.setItem("ckycBackup", JSON.stringify(array));
    } catch (error) {
      console.log("error from on chane", error);
    }
  };

  const handleAddNomineeError = (index: number, name: string, value: any) => {
    const array = JSON.parse(JSON.stringify(nomiDetails));
    if (!array[index]["error"]) {
      array[index]["error"] = {};
    }
    if (name === "dob") {
      array[index]["error"]["guardianDetails"] = {
        ...(array[index]["error"]["guardianDetails"] || {}),
        dob: value,
      };
    } else if (name === "nomDob" && array[index][name]) {
      array[index]["error"][name] = null;
    } else {
      array[index]["error"][name] = value;
    }
    setNomiDetails(array);
  };

  const handleAddNomineeGuardianValue = (
    name: string,
    index: number,
    value: any
  ) => {
    const array = JSON.parse(JSON.stringify(nomiDetails));
    if (!array[index]["guardianDetails"]) {
      array[index]["guardianDetails"] = {
        guardPoliticalVal: "0",
        guardianAddress: { ...initialAddressObj },
        sameAsNominee: false,
      };
    }
    if (name === "identificationDetail") {
      array[index]["guardianDetails"][name] = buildIdentificationDetail(
        value,
        "Guardian" + (index + 1)
      );
      setAddlIdentDetailsValue(false);
      if (value?.value == 1) {
        let imgOfAddlIdentDtls = JSON.parse(
          JSON.stringify(imgOfAddlIdentDetails)
        );
        imgOfAddlIdentDtls[index]["guardianAddDtls"] = {
          isPhoto: false,
          isSignature: false,
        };
        setImgOfAddlIdentDetails(imgOfAddlIdentDtls);
        var objNomineeDocs = nomineeDocuments;
        if (index == 0) {
          objNomineeDocs.nomineeOne.guardianDetails = {};
          objNomineeDocs.nomineeOne.guardianDetails.photo = {
            ...initialDocObj,
          };
          objNomineeDocs.nomineeOne.guardianDetails.signature = {
            ...initialDocObj,
          };
          setNomineeDocuments(objNomineeDocs);
        }
        if (index == 1) {
          objNomineeDocs.nomineeTwo.guardianDetails = {};
          objNomineeDocs.nomineeTwo.guardianDetails.photo = {
            ...initialDocObj,
          };
          objNomineeDocs.nomineeTwo.guardianDetails.signature = {
            ...initialDocObj,
          };
          setNomineeDocuments(objNomineeDocs);
        }
        if (index == 2) {
          objNomineeDocs.nomineeThree.guardianDetails = {};
          objNomineeDocs.nomineeThree.guardianDetails.photo = {
            ...initialDocObj,
          };
          objNomineeDocs.nomineeThree.guardianDetails.signature = {
            ...initialDocObj,
          };
          setNomineeDocuments(objNomineeDocs);
        }
      } else {
        let imgOfAddlIdentDtls = JSON.parse(
          JSON.stringify(imgOfAddlIdentDetails)
        );
        imgOfAddlIdentDtls[index]["guardianAddDtls"] = {
          isPhoto: true,
          isSignature: true,
        };
        setImgOfAddlIdentDetails(imgOfAddlIdentDtls);
        var objNomineeDocs = nomineeDocuments;
        if (index == 0 && objNomineeDocs.nomineeOne.guardianDetails) {
          delete objNomineeDocs.nomineeOne.guardianDetails;
          setNomineeDocuments(objNomineeDocs);
        }
        if (index == 1 && objNomineeDocs.nomineeTwo.guardianDetails) {
          delete objNomineeDocs.nomineeTwo.guardianDetails;
          setNomineeDocuments(objNomineeDocs);
        }
        if (index == 2 && objNomineeDocs.nomineeThree.guardianDetails) {
          delete objNomineeDocs.nomineeThree.guardianDetails;
          setNomineeDocuments(objNomineeDocs);
        }
      }
    } else if (name === "guardIdentificationDetailValue") {
      if (!array[index]["guardianDetails"]) {
        array[index]["guardianDetails"] = {};
      }
      if (!array[index]["guardianDetails"]["identificationDetail"]) {
        array[index]["guardianDetails"]["identificationDetail"] = {};
      }
      array[index]["guardianDetails"]["identificationDetail"]["value"] = value;
      setAddlIdentDetailsValue(true);
    } else {
      if (!array[index]["guardianDetails"]) {
        array[index]["guardianDetails"] = {};
      }
      array[index]["guardianDetails"][name] = value;
    }

    if (value) {
      if (name === "dob") {
        if (array[index]["error"]?.guardianDetails) {
          array[index]["error"]["guardianDetails"] = {
            ...array[index]["error"]["guardianDetails"],
            dob: undefined,
          };
        }
      } else if (array[index]["error"]?.[name]) {
        array[index]["error"][name] = undefined;
      }
    }
    setNomiDetails(array);

    window.localStorage.removeItem("ckycBackup");
    localStorage.setItem("ckycBackup", JSON.stringify(array));
  };
  function handleAccountTypeBlur(key: string, value: any) {
    typeof value !== "object"
      ? setErrors({ ...errors, [key]: "Please select from dropdown" })
      : setErrors({ ...errors, [key]: undefined });
  }

  const setGenderDisabled = () => {
    if (isMinor) return false
    const clientPartialDetails_ao = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    if (
      GlobalStore?.isKRA &&
      !!GlobalStore?.personaldetails?.gender &&
      GlobalStore?.personaldetails?.gender !== ""
    ) {
      return true;
    } else if (
      clientPartialDetails_ao?.isKRA == true &&
      clientPartialDetails_ao.gender !== null &&
      clientPartialDetails_ao.gender !== undefined &&
      clientPartialDetails_ao.gender !== ""
    ) {
      return true;
    }
    return false;
  };
  function ChangePoliticalVal(Value: any) {
    setPoliticalVal(Value);
    setErrCode("");
    errorMsg("");
  }
  const getFullPANNAMe = () => {
    let panFullName = "";
    if (
      GlobalStore?.stageStatus?.panfirstname !== undefined &&
      GlobalStore?.stageStatus?.panfirstname?.length > 0
    ) {
      panFullName = GlobalStore?.stageStatus?.panfirstname + " ";
      if (
        GlobalStore?.stageStatus?.panmiddletname !== undefined &&
        GlobalStore?.stageStatus?.panmiddletname?.length > 0
      ) {
        panFullName += GlobalStore?.stageStatus?.panmiddletname
          .split(" ")
          .join(" ");
      }
      if (
        GlobalStore?.stageStatus?.panlastname !== undefined &&
        GlobalStore?.stageStatus?.panlastname?.length > 0
      ) {
        panFullName = GlobalStore?.stageStatus?.panlastname
          ? panFullName + " " + GlobalStore?.stageStatus?.panlastname
          : panFullName;
      }
    }
    if (panFullName == null || panFullName == undefined || panFullName == "") {
      panFullName = GlobalStore.personaldetails.PANName;
    }
    window.sessionStorage.setItem('clientName', panFullName)
    return panFullName;
  };

  console.log("ffffffffffffffffffffffffffffffffffffffff", permanentAddress);


  return (
    <div className={"profileForm " + (isLoading ? " op05" : "")}>
      <h2 className="prflFormHeading">Primary Details</h2>

      <div className="mgt40">
        <label className="fieldLbl" htmlFor="panName">Name {isMinor ? "(Minor's)" : "(as per PAN)"}</label>
        <InputField id="panName"
          defaultValue={getFullPANNAMe()}
          disabled={true}
          type="text"
          helpText="This field cannot be edited"
        />
      </div>
      <form>
        <fieldset disabled={isLoading}>
          {/* {!hideAddress && ( */}
          <>
            {/* Permanent Address Start */}
            <AddressField
              addressObj={permanentAddress}
              isDisable={
                (GlobalStore.isKYC ||
                  GlobalStore.isKRA ||
                  GlobalStore.isDigiLocker) &&
                !regectedAddressDoc
              }
              sectionLabel={`${guardianTitle} ${GlobalStore.isOTCFlow ? isNriOtc ? "" : "Correspondents Address" : "Permanent Addr."}`}
              addressType="permanent"
              setErrCode={setErrCode}
              onAddressChange={(obj: IAddressFormat) => {
                console.log(
                  correspondanceAddress, obj,
                  "correspondanceAddress works 5"
                );
                setPermanentAddress(obj);
                sameAsPermanent && setCorrespondanceAddress((isNriInv && !isNriOtc) && !stageCompleteStatus?.isprofiledetailscompleted ? initialAddressObj : obj);
              }}
              onAddressBlur={setPermErrorObj}
              handleSameAsAbove={() => {
                console.log("great works");
              }}
              // Area master list is not loaded for NRI; hide to avoid empty dropdown
              showArea={isNriInv}
            />
            {/* Permanent Address End */}

            {/* Correspondence Address Start */}
            {(!GlobalStore.isDigiLocker && !GlobalStore.isOTCFlow) && (
              <AddressField
                addressObj={correspondanceAddress}
                isDisable={isNriInv ? false : GlobalStore.isKYC || GlobalStore.isKRA || GlobalStore.isDigiLocker}
                sectionLabel={isNriInv ? "Foreign Addr." : "Correspondence Addr."}
                addressType="correspondance"
                setErrCode={setErrCode}
                // onAddressChange={setCorrespondanceAddress}
                onAddressBlur={setCorrErrorObj}
                showSameAsAbove={isNriInv ? false : true}
                sameAsAbove={isNriInv ? false : sameAsPermanent}
                handleSameAsAbove={handleSameAsAbove}
                showCountry={isNriInv}
                countryList={isNriInv ? nriCountryList : countryList}
                showCity={true}
                showPincode={true}
                getNriAccountLabel={isNriInv}
                enableCity={true}
                onAddressChange={(obj: IAddressFormat) => {
                  setCorrespondanceAddress(obj);
                }}
              />
            )}
            {/* Correspondence Address End */}
          </>
          {/* )} */}
          {isNriOtc &&
            <>
              <div className="mgt40">
                <label className="fieldLbl" htmlFor="nationalityCode">
                  Country
                </label>
                <DropdownSearch id="nationalityCode"
                  name="nationalityCode"
                  defaultValue={
                    nationalityList?.find(
                      (item) => item.value === nationalityCode
                    )?.display
                  }
                  onOptionSelect={(val) =>
                    setNationalityCode(val["value"] as string)
                  }
                  searchLength={0}
                  options={nationalityList}
                  onBlur={(val) => dropDownBlur("nationalityCode", val)}
                  searchKey="display"
                  placeholder="Select Country"
                  noDataMsg="Country with similar name not found"
                  errorText={errors.nationalityCode}
                  isDownArrow={true}
                />
              </div>
              <div className="mgt40">
                <fieldset>
                  <legend className="fieldLbl">{`I am an Indian citizen & pay taxes in India, I do not pay taxes in USA or any other country.`}</legend>
                  <div className="mgt14">
                    <div className="inlineDiv">
                      <Radio
                        checked={indianResident}
                        onChange={() => {
                          const {
                            country,
                            idTypeOther,
                            idTypeValue,
                            ...newErrors
                          } = errors;
                          setErrors(newErrors);
                          setIndianResident(true);
                        }}
                        name="taxResident"
                        label="Yes"
                      />
                    </div>
                    <div className="inlineDiv noRadio">
                      <Radio
                        checked={!indianResident}
                        onChange={() => setIndianResident(false)}
                        name="taxResident"
                        label="No"
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
              {/* } */}
              {!indianResident && (
                <NriDetailForm
                  countryList={countryList}
                  nriDetailsObj={nriDetailsObj}
                  onChangeNriDetails={setNriDetailsObj}
                  errors={errors}
                  setErrors={setErrors}
                />
              )}
            </>
          }

          {/* Mobile Phone Start*/}
          {!isOTCFlow &&
            <div className="inputVerification mgt40">
              <div className="">
                <label className="fieldLbl" htmlFor="phone">Mobile No.</label>
                <InputField id="phone"
                  autoComplete="tel"
                  defaultValue={phone}
                  pattern={phoneNo}
                  disabled={true}
                  // onChange={(value) => onEmailPhoneChange('phone', value)}
                  onBlur={(error) =>
                    setErrors({
                      ...errors,
                      phone: error.pattern ? "" : errorMsg(errorCode.FE08),
                    })
                  }
                  placeholder="Eg. 9876543210"
                  errorText={errors.phone}
                  integer
                  type="tel"
                  suffix={
                    GlobalStore.user.mobile === phone &&
                      phone !== "" &&
                      isMobileVerified &&
                      !showMobileOtp &&
                      !showMobileBtn ? (
                      <i className="edel-icon-tick" aria-hidden="true" />
                    ) : (
                      <></>
                    )
                  }
                  maxLength={10}
                />
              </div>
              {showMobileBtn && (
                <div className="emlVrfy">
                  <Button
                    type="submit"
                    btnName="Verify Mobile No."
                    isLoading={isLoading}
                    disabled={
                      Object.values([errors.phone]).some((error) => error) ||
                      phone === ""
                    }
                    onClick={() => sendOtp("mobile")}
                  />
                </div>
              )}
            </div>
          }
          {showMobileOtp && !showMobileBtn && (
            <div className="mgt40">
              <RegOtp
                label="Enter Mobile OTP"
                otpTimer={15}
                eleId="mob_"
                onChange={(val) => validateOtp("mobile", val)}
                resendClicked={() => sendOtp("mobile")}
                disableOtp={disableOtp}
                invalidOtp={invalidOtp}
              />
            </div>
          )}
          {/* Mobile Phone End*/}

          {isEmailVerified && (
            <>
              {/* Family Declaration start */}
              {relationshipData.emailMatchedList &&
                relationshipData.mobileMatchedList &&
                (relationshipData.emailMatchedList.length > 0 ||
                  relationshipData.mobileMatchedList.length > 0) && (
                  <>
                    <div className="mgt80">
                      <h2 className="prflFormHeading">
                        Family Declaration
                      </h2>
                    </div>

                    <div className="mgt20">
                      <p className="fmlyDecInfo">
                        Your mobile number and/or email ID matches with already
                        existing account. Mention your Relation with each
                        account or change your Email ID or Mobile Number
                      </p>
                    </div>
                    {relationshipData.emailMatchedList &&
                      relationshipData.emailMatchedList.map(
                        (item: IFamilyMember, index: number) => (
                          <>
                            <span className="AAA"></span>
                            <FamilyMember
                              key={index}
                              index={index}
                              type="email"
                              member={item}
                              relationList={familyRelationListMail}
                              originalRelationList={originalRelationList}
                              onChange={(value) =>
                                onRelationChange("email", index, value)
                              }
                              onBlur={(value) =>
                                onRelationBlur("email", index, value)
                              }
                              error={item?.error}
                            />
                          </>
                        )
                      )}
                    {relationshipData.mobileMatchedList &&
                      relationshipData.mobileMatchedList.map(
                        (item: IFamilyMember, index: number) => (
                          <FamilyMember
                            key={index}
                            index={index}
                            type="mobile"
                            member={item}
                            relationList={familyRelationList}
                            originalRelationList={originalRelationList}
                            onChange={(value) =>
                              onRelationChange("mobile", index, value)
                            }
                            onBlur={(value) =>
                              onRelationBlur("mobile", index, value)
                            }
                            error={item?.error}
                          />
                        )
                      )}
                    {relationshipData.bothMatchedList &&
                      relationshipData.bothMatchedList.map(
                        (item: IFamilyMember, index: number) => (
                          <FamilyMember
                            key={index}
                            index={index}
                            type="both"
                            member={item}
                            relationList={familyRelationList}
                            originalRelationList={originalRelationList}
                            onChange={(value) =>
                              onRelationChange("both", index, value)
                            }
                            onBlur={(value) =>
                              onRelationBlur("both", index, value)
                            }
                            error={item?.error}
                          />
                        )
                      )}
                  </>
                )}
              {isOTCFlow &&
                <fieldset disabled={setGenderDisabled()}>
                  <legend className="sr-only">Gender selection</legend>
                  <div className="mgt40">
                    <span className="fieldLbl" id="otc-gender-label">Gender</span>
                    <Tag
                      id="otc-gender"
                      ariaLabel="Gender"
                      ariaLabelledBy="otc-gender-label"
                      ariaDescribedBy={genderError ? "gender-error" : undefined}
                      ariaInvalid={!!genderError}
                      defaultValue={!isMinor ? gender : ''}
                      tagList={genderList}
                      onSelect={(val) => {
                        setGender(val as string);
                        setGenderError("");
                      }}
                      className="liMgt12"
                      disabled={setGenderDisabled()}
                      disabledClassName={
                        setGenderDisabled() ? " not-allowed" : ""
                      }
                    />
                  </div>
                </fieldset>
              }
              {/* Family Declaration end */}
              {/* Secondary Details Start */}
              {!isOTCFlow &&
                <>
                  <div className="mgt80">
                    <h2 className="prflFormHeading">{isMinor && "Minor's"} Secondary Details</h2>
                  </div>
                  <fieldset disabled={setGenderDisabled()}>
                    <legend className="sr-only">Additional options</legend>
                    <div className="mgt40">
                      <span className="fieldLbl" id="gender-label">Gender</span>
                      <Tag
                        id="gender"
                        ariaLabel="Gender"
                        ariaLabelledBy="gender-label"
                        ariaDescribedBy={genderError ? "gender-error" : undefined}
                        ariaInvalid={!!genderError}
                        defaultValue={gender}
                        tagList={genderList}
                        onSelect={(val) => {
                          setGender(val as string);
                          setGenderError("");
                        }}
                        className="liMgt12"
                        disabled={setGenderDisabled()}
                        disabledClassName={
                          setGenderDisabled() ? " not-allowed" : ""
                        }
                      />
                    </div>
                  </fieldset>

                  {!isMinor &&
                    <>
                      <div className="mgt40">
                        <span className="fieldLbl" id="marital-status-label">Marital Status</span>
                        <Tag
                          id="marital-status"
                          ariaLabel="Marital Status"
                          ariaLabelledBy="marital-status-label"
                          defaultValue={maritalStatus}
                          tagList={maritalStatusList}
                          onSelect={(val) => setMaritalStatus(val as string)}
                          className="liMgt12"
                        />
                      </div>
                      <div className="mgt40">
                        <span className="fieldLbl" id="father-or-spouse-label">
                          Father’s/Spouse’s Name (Select as per PAN)
                        </span>
                        <Tag
                          id="father-or-spouse"
                          ariaLabel="Father or Spouse selection"
                          ariaLabelledBy="father-or-spouse-label"
                          defaultValue={fatherOrSpouse}
                          tagList={fatherSpouseRelationList}
                          onSelect={(val) => setFatherOrSpouse(val as string)}
                          className="liMgt12"
                          bool={{
                            lhs: maritalStatus === "S" || gender !== "F",
                            rhs: fatherSpouseRelationList[1].value,
                            className: " not-allowed",
                          }}
                        />
                      </div>
                    </>
                  }
                  <div className="mgt40">
                    <label className="fieldLbl" htmlFor="fatherOrSpouseName">
                      {fatherOrSpouse === "01" ? "Father" : "Spouse"}’s Name
                    </label>
                    <InputField id="fatherOrSpouseName"
                      required
                      alphabate
                      defaultValue={fatherOrSpouseName}
                      disabled={
                        !isMinor && !regectedAddressDoc &&
                          GlobalStore.personaldetails.fsfullName &&
                          GlobalStore.personaldetails.fsfullName.trim()
                          ? true
                          : false
                      }
                      onBlur={(error) =>
                        setErrors({
                          ...errors,
                          // fatherOrSpouse: error.required ? `Please Enter Valid Name` : '',
                          fatherOrSpouse: error.required
                            ? errorMsg(errorCode.FE33)
                            : "",
                        })
                      }
                      onChange={(val) =>
                        setFatherOrSpouseName(capitalizeWords(val))
                      }
                      errorText={errors.fatherOrSpouse}
                      placeholder="Eg. Ankit Agrawal"
                      type="text"
                      helpText="Enter name as per PAN"
                    />
                  </div>
                  <div className="mgt40">
                    <label className="fieldLbl" htmlFor="motherName">Mother’s Name</label>
                    <InputField id="motherName"
                      required
                      alphabate
                      defaultValue={motherName}
                      disabled={
                        !isMinor && GlobalStore.isKYC &&
                          GlobalStore.personaldetails.motherfullName &&
                          GlobalStore.personaldetails.motherfullName.trim()
                          ? true
                          : false
                      }
                      onBlur={(error) =>
                        setErrors({
                          ...errors,
                          // motherName: error.required ? 'Please Enter Mother’s Name' : '',
                          motherName: error.required
                            ? errorMsg(errorCode.FE34)
                            : "",
                        })
                      }
                      onChange={(val) => setMotherName(capitalizeWords(val))}
                      errorText={errors.motherName}
                      placeholder="Eg. Ankita Agrawal"
                      type="text"
                    />
                  </div>
                  {/* Secondary Details End */}
                  {/* Professional Details Start */}
                  <div className="mgt80">
                    <h2 className="prflFormHeading">{guardianTitle} Professional Details</h2>
                  </div>
                  <div className="mgt40">
                    <label className="fieldLbl" htmlFor="eduQualification">
                      {isMinor ? guardianTitle : 'Your'} Educational Qualification
                    </label>
                    <DropdownSearch id="eduQualification"
                      name="eduQualification"
                      defaultValue={
                        educationList.find(
                          (item) => item.value === eduQualification
                        )?.display
                      }
                      onOptionSelect={(val) =>
                        setEduQulification(val["value"] as string)
                      }
                      searchLength={0}
                      options={educationList}
                      onBlur={(val) => dropDownBlur("eduQualification", val)}
                      searchKey="display"
                      placeholder="Select Your Education Qualification"
                      noDataMsg="Qualification with similar name not found"
                      errorText={errors.eduQualification}
                      isDownArrow={true}
                    />
                  </div>
                  <div className="mgt40">
                    <label className="fieldLbl" htmlFor="occupation">{isMinor ? guardianTitle : 'Your'} Occupation</label>
                    <DropdownSearch id="occupation"
                      name="occupation"
                      defaultValue={
                        occupationList.find((item) => item.value === occupation)
                          ?.display
                      }
                      onOptionSelect={(val) =>
                        setOccupation(val["value"] as string)
                      }
                      searchLength={0}
                      options={occupationList}
                      onBlur={(val) => dropDownBlur("occupation", val)}
                      searchKey="display"
                      placeholder="Select Your Occupation"
                      noDataMsg="Occupation with similar name not found"
                      errorText={errors.occupation}
                      isDownArrow={true}
                    />
                  </div>
                  <fieldset>
                    <div className="mgt40">
                      <legend className="fieldLbl">Politically Exposed Person</legend>
                      <div className="fieldLblRight">
                        <div className="explain">
                          <button
                            type="button"
                            className="explainLbl"
                            aria-expanded={showExplain}
                            aria-label="Explain Politically Exposed Person"
                            onClick={() => {
                              try {
                                const screen_name = getScreenName(window.location.pathname);
                                if (screen_name) {
                                  mixpanelService({
                                    event: mixpanelEvents.CTA_CLICKED,
                                    screen_name,
                                    text: "Explain",
                                    cta_type: "sticky",
                                    cta_class: "secondary",
                                    cta_service: "AOJ",
                                  });
                                }
                              } catch (e) {
                                console.error("mixpanel cta_clicked failed", e);
                              }
                              setShowExplain(!showExplain);
                            }}
                            onMouseOver={() => setShowExplain(true)}
                            onMouseLeave={() => setShowExplain(false)}
                            onFocus={() => setShowExplain(true)}
                            onBlur={() => setShowExplain(false)}
                          >
                            Explain
                          </button>
                          {showExplain && (
                            <InfoModal
                              width={DeviceContext().isMobile ? "328px" : "354px"}
                            >
                              <div className="explainInfo">
                                <p>
                                  A Politically Exposed Person (PEP) is a person who
                                  can potentially be influenced by political parties
                                  directly or indirectly.
                                </p>
                              </div>
                            </InfoModal>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mgt20">
                      <Radio
                        checked={politicalVal === "1"}
                        onChange={() => ChangePoliticalVal("1")}
                        name="politicalParty"
                        label="I am a Politically Exposed Person"
                      //disabled={true}
                      />
                      <Radio
                        className="mgt14"
                        checked={politicalVal === "2"}
                        onChange={() => ChangePoliticalVal("2")}
                        name="politicalParty"
                        label="I am Related to Politically Exposed Person"
                      //disabled={true}
                      />
                      <Radio
                        className="mgt14"
                        checked={politicalVal === "0"}
                        onChange={() => ChangePoliticalVal("0")}
                        name="politicalParty"
                        label="None"
                      />
                    </div>
                  </fieldset>
                  {/* {!isMinor && */}
                  <div className="mgt40">
                    <fieldset>
                      <legend className="fieldLbl">{`I am an Indian citizen & pay taxes in India, I do not pay taxes in USA or any other country.`}</legend>
                      <div className="mgt14">
                        <div className="inlineDiv">
                          <Radio
                            checked={indianResident}
                            onChange={() => {
                              const {
                                country,
                                idTypeOther,
                                idTypeValue,
                                ...newErrors
                              } = errors;
                              setErrors(newErrors);
                              setIndianResident(true);
                            }}
                            name="taxResident"
                            label="Yes"
                          />
                        </div>
                        <div className="inlineDiv noRadio">
                          <Radio
                            checked={!indianResident}
                            onChange={() => setIndianResident(false)}
                            name="taxResident"
                            label="No"
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  {/* } */}
                  {!indianResident && (
                    <NriDetailForm
                      countryList={countryList}
                      nriDetailsObj={nriDetailsObj}
                      onChangeNriDetails={setNriDetailsObj}
                      errors={errors}
                      setErrors={setErrors}
                    />
                  )}
                  <div className="mgt40">
                    <label className="fieldLbl" htmlFor="annualIncome">Annual Income</label>
                    <DropdownSearch id="annualIncome"
                      name="annualIncome"
                      defaultValue={
                        incomeList.find((item) => item.value === annualIncome)
                          ?.display
                      }
                      onOptionSelect={(val) =>
                        setAnnualIncome(val["value"] as string)
                      }
                      searchLength={0}
                      options={incomeList}
                      searchKey="display"
                      placeholder="Select Your Annual Income Bracket"
                      noDataMsg="Annual Income with similar name not found"
                      errorText={errors.annualIncome}
                      onBlur={(val) => dropDownBlur("annualIncome", val)}
                      isDownArrow={true}
                    />
                  </div>
                  <div className="mgt40">
                    <label className="fieldLbl" htmlFor="netWorth">Net Worth</label>
                    <InputField id="netWorth"
                      integer
                      required
                      maxLength={9}
                      min={1001}
                      defaultValue={netWorth}
                      onBlur={(error) =>
                        setErrors({
                          ...errors,
                          netWorth:
                            error.required || error.min
                              ? // ? 'Please Enter Amount More Than Rs 1000'
                              errorMsg(errorCode.FE22)
                              : "",
                        })
                      }
                      errorText={errors.netWorth}
                      onChange={(val) => setNetWorth(val)}
                      placeholder="Eg. 30,00,000"
                    // helpText='Maximum 100 Cr.'
                    />
                  </div>
                  <div className="mgt40">
                    <label className="fieldLbl" htmlFor="city">Place of birth</label>
                    <DropdownSearch id="city"
                      name="city"
                      onOptionSelect={(value) =>
                        onChange("city", value["CityName"] as string)
                      }
                      searchLength={3}
                      options={cities}
                      onBlur={handleCityBlur}
                      searchKey="CityName"
                      placeholder="Eg. Mumbai"
                      noDataMsg="City with similar name not found"
                      errorText={errors.placeOfBirth}
                      isDownArrow={false}
                      autoSelectOff={true}
                      defaultValue={placeOfBirth}
                    />
                  </div>
                  {showSectionOrHide(2) &&
                    <div className="mgt40">
                      <label className="fieldLbl" htmlFor="disability">Person with Disability (PwD)</label>
                      <DropdownSearch id="disability"
                        name="disability"
                        defaultValue={
                          disabilityList.find((item: any) => item.value === disability)
                            ?.display
                        }
                        onOptionSelect={(value) =>
                          setDisability(value["value"] as string)
                        }
                        searchLength={0}
                        options={disabilityList}
                        onBlur={(val) => dropDownBlur("disability", val)}
                        searchKey="display"
                        placeholder="Select an option"
                        noDataMsg="Option not found"
                        errorText={errors.disability}
                        isDownArrow={true}
                      />
                    </div>
                  }
                  {showSectionOrHide(2) ? (
                    <>
                      <div className="mgt40 flexDiv">
                        <div className="nomLbl">
                          <label className="fieldLbl" htmlFor="togSettlement">
                            How frequently would you like us to settle unused funds
                            back to your bank account?
                          </label>
                        </div>
                        <div className="nomToggle">
                          <Toggle ariaLabel="Settlement frequency toggle" id="togSettlement"
                            isOn={togSettlement}
                            onChange={() => togSettlementclick()}
                          />
                        </div>
                      </div>
                      {togSettlement && (
                        <fieldset className="mgt30">
                          <legend className="sr-only">Settlement frequency</legend>
                          <div className="inlineDiv">
                            <Radio
                              checked={periodicSettlement === "1"}
                              onChange={() => setPeriodicSettlement("1")}
                              name="periodicSettlement"
                              label="Monthly"
                            />
                          </div>
                          <div className="inlineDiv noRadio">
                            <Radio
                              checked={periodicSettlement === "2"}
                              onChange={() => setPeriodicSettlement("2")}
                              name="periodicSettlement"
                              label="Quarterly"
                            />
                          </div>
                        </fieldset>
                      )}
                      <div className="mgt40 flexDiv">
                        <div className="nomLbl">
                          <label className="fieldLbl" htmlFor="POAType">
                            Allow DDPI as an mode of operating Pledge and Payin
                            transaction
                          </label>
                          {/* <br></br>
                  <label className="sectionLbl">({POATypeMsg})</label> */}
                        </div>
                        <div className="nomToggle">
                          <Toggle ariaLabel="Allow DDPI as an mode of operating Pledge and Payin transaction" id="POAType"
                            name="POAType"
                            isOn={POAType}
                            disabled={GlobalStore.stageStatus.dpaccounttype === 2}
                            onChange={() => {
                              if (POAType == true) {
                                setPOAType(false);
                              } else {
                                setPOAType(true);
                              }
                            }}
                          />
                        </div>
                      </div>
                      {defaultSetting && (
                        <>
                          <div className="termList mrt41">
                            <Checkbox
                              id="poa-transfer-security"
                              checked={POAType}
                              name="defaultSetting"
                              onChange={() => { }}
                            >
                              Transfer of security is held in beneficial owner
                              accounts of client towards stock exchange related is
                              settlement obligations arising out of trade executed
                              by client on the stock exchange through stay schemes
                              stock broker.
                            </Checkbox>
                          </div>
                          <div className="termList mrt41">
                            <Checkbox
                              id="poa-pledging-security"
                              checked={POAType}
                              name="defaultSetting"
                              onChange={() => { }}
                            >
                              Pledging / replacing of security in favour of trading
                              member in (TM)/ clearing members (CM ) for the purpose
                              of meeting margin requirements of the clients in
                              connection with trades executed by clients on the
                              stock exchange.
                            </Checkbox>
                          </div>
                          <div className="termList mrt41">
                            <Checkbox
                              id="poa-mutual-fund"
                              checked={POAType}
                              name="defaultSetting"
                              onChange={() => { }}
                            >
                              Mutual Fund transaction being executed on stock
                              exchange order entry platform.
                            </Checkbox>
                          </div>
                          <div className="termList mrt41">
                            <Checkbox
                              id="poa-tendering-shares"
                              checked={POAType}
                              name="defaultSetting"
                              onChange={() => { }}
                            >
                              Tendering shares in open offers through stock exchange
                              platforms.
                            </Checkbox>
                          </div>
                        </>
                      )}
                      <button
                        type="button"
                        onClick={() => setDefaultSetting(!defaultSetting)}
                        aria-expanded={defaultSetting}
                        className="defaultHeading"
                      >
                        Read {defaultSetting ? "Less" : "More"}
                      </button>
                      <div className="mgt12">
                        <p className="sectionLbl greyish-two">
                          {POATypeMsg}
                        </p>
                      </div>
                      <div className="mgt40">
                        {/* Permanent Address Proof */}
                        <label className="bankDoc" htmlFor="defaultAccountType"> Type of Account</label>
                        <DropdownSearch id="defaultAccountType"
                          name="defaultAccountType"
                          defaultValue={
                            bankAccountType.find(
                              (item) => item.display === defaultAccountType
                            )?.display
                          }
                          onOptionSelect={(val) =>
                            setDefaultAccountType(val.display)
                          }
                          searchLength={0}
                          options={bankAccountType}
                          onBlur={(val) =>
                            handleAccountTypeBlur("defaultAccountType", val)
                          }
                          errorText={errors.defaultAccountType}
                          searchKey="display"
                          placeholder="Select Account Type"
                          isDownArrow={true}
                        />
                        <h2 className="prflFormHeading"> Additional default settings for Online Account </h2>
                        {defaultAccountType !== null &&
                          defaultAccountType !== undefined &&
                          defaultAccountType?.length > 0 &&
                          defaultAccountType ==
                          "BSDA Resident Demat and Trading Account" && (
                            <p className="fieldLbl-new">
                              You are eligible for BSDA only if this is your first
                              demat account across all depositories. To be eligible
                              under the scheme you should not have a demat asset
                              value should not be more than Rs. 10 Lakh at any
                              point. If you select this option and do not meet the
                              required criteria of BSDA you would be charged as per
                              ordinary resident demat account holder.
                            </p>
                          )}
                        <button
                          type="button"
                          onClick={() => setAccountTypeToggle(!accountTypeToggle)}
                          aria-expanded={accountTypeToggle}
                          className="defaultHeading"
                        >
                          {accountTypeToggle ? "Read Less" : "Read More"}
                        </button>
                      </div>
                      {accountTypeToggle && (
                        <>
                          <p className="linkLabel">
                            I understand that the services I am availing are for opening an Online Individual Resident Demat and Trading Account. In case if I wish to change any of the default settings provided by Nuvama as part of the digital onboarding journey, and such changes are not available through the digital process, I will contact the local branch for further assistance.
                          </p>
                          <div className="termList mrt41">
                            <Checkbox
                              id="acct-demat-statement"
                              checked={true}
                              name="accountType"
                              onChange={() => { }}
                            >
                              Mode of receiving demat account statement and annual
                              report: electronic
                            </Checkbox>
                          </div>
                          <div className="termList mrt41">
                            <Checkbox
                              id="acct-holding-statement"
                              checked={true}
                              name="accountType"
                              onChange={() => { }}
                            >
                              I am aware that all transaction cum holding statement
                              would be received on registered email ID.
                            </Checkbox>
                          </div>{" "}
                          <div className="termList mrt41">
                            <Checkbox
                              id="acct-share-email-rta"
                              checked={true}
                              name="accountType"
                              onChange={() => { }}
                            >
                              Share the email ID with RTA
                            </Checkbox>
                          </div>{" "}
                          <div className="termList mrt41">
                            <Checkbox
                              id="acct-no-dis-booklet"
                              checked={true}
                              name="accountType"
                              onChange={() => { }}
                            >
                              I confirm that I do not require DIS booklet at the
                              time of account opening.
                            </Checkbox>
                          </div>{" "}
                          <div className="termList mrt41">
                            <Checkbox
                              id="acct-credits-dividend"
                              checked={true}
                              name="accountType"
                              onChange={() => { }}
                            >
                              I agree to receive all my credits/dividend into my
                              linked  demat / bank account.
                            </Checkbox>
                          </div>{" "}
                          <div className="termList mrt41">
                            <Checkbox
                              id="acct-no-action-confirm"
                              checked={true}
                              name="accountType"
                              onChange={() => { }}
                            >
                              I hereby confirm that no action is taken / proceedings initiated / pending including but not limited to debarment / blacklisting / de-registering / name strike off from ROC records / declaring defaulter / monetary penalty / adverse arbitration award by SEBI / Stock exchange / Government Authority / Statutory Authority / MCA or any other authority against me for dealing in securities. If an identical name match appears, it is not me. I authorised NWIL to carry additional checks and take necessary actions if identified to be true.
                            </Checkbox>
                          </div>
                          <div className="termList mrt41">
                            <Checkbox
                              id="acct-acknowledgement"
                              checked={acknowledged}
                              name="acknowledgement"
                              onChange={(e: any) => setAcknowledged(e.target.checked)}
                            >
                              I acknowledge that I have read, understood, and agree to all the above
                              declarations and terms.
                            </Checkbox>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}

                  {/* Professional Details End */}
                  {/* {!isSeniorCitizen && ( */}
                  {!isMinor &&
                    <>
                      <div className="mgt40 flexDiv">
                        <div className="nomLbl">
                          <label className="fieldLbl" htmlFor="showNominee">
                            Would you like to add nominee details to your account?
                          </label>
                          <br></br>
                          <p className="sectionLbl">
                            (For senior citizen, nominee details are mandatory)
                          </p>
                        </div>
                        <div className="nomToggle">
                          <Toggle ariaLabel="Would you like to add nominee details to your account?" id="showNominee"
                            name="showNominee"
                            disabled={isSeniorCitizen}
                            isOn={showNominee}
                            onChange={() => {
                              const {
                                guardAnnualIncome,
                                guardEduQualification,
                                guardFullName,
                                guardOccupation,
                                guardPlaceOfBirth,
                                guardRelation,
                                guardTitle,
                                nomFullName,
                                nomRelation,
                                nomTitle,
                                numOfNominee,
                                ...newErrors
                              } = errors;
                              const existingNominee = showNominee;
                              if (existingNominee === true) {
                                setNomiDetails([]);
                                setNumOfNominee(0);
                              }
                              setErrors(newErrors);
                              setShowNominee(!existingNominee);
                              setGlobalError("");
                            }}
                          />
                        </div>
                      </div>
                      {!showNominee &&
                        <div className="mgt40">
                          <p className="sectionLbl" style={{ fontStyle: 'italic' }}>
                            A nominee helps ensure your investments are smoothly transferred to your loved ones in case of any unforeseen events, always opt for nominee while onboarding clients
                          </p>
                        </div>
                      }
                      {showNominee &&
                        <div className="mgt40 flexDiv">
                          <div className="nomLbl">
                            <label className="fieldLbl" htmlFor="togNomineeDetails">
                              Print nominee details in my/our Statement of Holding/Account
                            </label>
                          </div>
                          <div className="nomToggle">
                            <Toggle ariaLabel="Print nominee details in my/our Statement of Holding/Account" id="togNomineeDetails"
                              isOn={togNomineeDetails}
                              onChange={() => settogNomineeDetails(!togNomineeDetails)}
                            />
                          </div>
                        </div>
                      }
                    </>
                  }
                  {/* )} */}
                  {/* Below div is for temp purpose. We need to remove it once multiple nominee we implement it. */}
                  {/* <div className="mgt40 tempNomineeSection">
                                <label className="fieldLbl">
                                    Currently We do not cater Online Nomination Request. In case you intend to opt for
                                    nominee, please download and fill the attached form. You can courier the same along
                                    with physical form.
                                </label>
                                <p className="fieldLbl downloadNomineeForm">
                                    <a href={`${config.root}docs/EBL-Combine-Nomination-Form.pdf`} target="_blank">
                                        Click here
                                    </a>{' '}
                                    to Download Add Nomination form
                                </p>
                            </div> */}
                  {/* Nominee Details Start */}
                  {showNominee && (
                    <>
                      <div className="mgt40">
                        <label className="fieldLbl" htmlFor="numOfNominee">
                          How many Nominee do you want?
                        </label>
                        <DropdownSearch
                          id="numOfNominee"
                          name="numOfNominee"
                          // defaultValue={'1'}
                          onOptionSelect={(val) => {
                            const totalNomineeCount = Number(val["value"]);
                            const existingNomineeCount = Number(numOfNominee);
                            const countForNeedToAddBlankNomine =
                              totalNomineeCount - existingNomineeCount;

                            const existingNomineeDetails = JSON.parse(
                              JSON.stringify(nomiDetails)
                            );

                            const nomineeEquaPerSharing = (
                              100 / totalNomineeCount
                            ).toFixed(2);
                            console.log(
                              "nomineeEquaPerSharing",
                              nomineeEquaPerSharing
                            );

                            const nomineeSharePer: any = {
                              1:
                                totalNomineeCount === 3
                                  ? 33
                                  : Number(nomineeEquaPerSharing),
                              2:
                                totalNomineeCount === 3
                                  ? 33
                                  : Number(nomineeEquaPerSharing),
                              3:
                                totalNomineeCount === 3
                                  ? 34
                                  : Number(nomineeEquaPerSharing),
                            };

                            console.log("nomineeSharePer", nomineeSharePer);

                            for (let i = 0; i < countForNeedToAddBlankNomine; i++) {
                              existingNomineeDetails.push({
                                error: {},
                                nomineeAddress: initialAddressObj,
                              });
                            }

                            for (let i = 0; i < totalNomineeCount; i++) {
                              existingNomineeDetails[i]["nomPerSharing"] =
                                nomineeSharePer[i + 1];
                            }

                            // If there are 3 nominee and user is going to remove last one and new select for 2 nominee then we need to remove last nominee
                            let numOfNomineeRemove =
                              existingNomineeCount - totalNomineeCount;
                            console.log(
                              "numOfNomineeRemove ---->",
                              numOfNomineeRemove
                            );
                            if (numOfNomineeRemove > 0) {
                              for (let i = 0; i < numOfNomineeRemove; i++) {
                                console.log("Inside the while loop", i);
                                existingNomineeDetails.pop();
                              }
                            }

                            setNomiDetails(existingNomineeDetails);
                            setNumOfNominee(val["value"] as number);
                          }}
                          defaultValue={
                            nomineeList.find((d) => d.value === numOfNominee)
                              ?.display
                          }
                          options={nomineeList}
                          onBlur={(val) => dropDownBlur("numOfNominee", val)}
                          errorText={errors.numOfNominee}
                          searchKey="display"
                          searchLength={0}
                          isDownArrow
                          placeholder="One"
                          disableTick
                        />
                      </div>
                      {numOfNominee > 0 &&
                        nomineeList.slice(0, numOfNominee).map((data, index) => {
                          return (
                            <React.Fragment key={index}>
                              <div className="mgt80">
                                <h2 className="prflFormHeading">
                                  Nominee {index + 1} Details
                                </h2>
                              </div>
                              <div className="mgt40">
                                <label className="fieldLbl" htmlFor={`nomFullName-${index}`}>Full Name</label>
                                <div className="flexDiv">
                                  <div className="titleSelect">
                                    <DropdownSearch
                                      id={`nomTitle-${index}`}
                                      name="nomTitle"
                                      defaultValue={
                                        titlePrefixList.find(
                                          (item) =>
                                            item.value ===
                                            nomiDetails[index]?.nomTitle
                                        )?.display
                                      }
                                      onOptionSelect={(val) => {
                                        handleAddNomineeValue(
                                          "nomTitle",
                                          index,
                                          val["value"] as string
                                        );
                                      }}
                                      options={titlePrefixList}
                                      onBlur={(val) =>
                                        handleAddNomineeError(
                                          index,
                                          "nomTitle",
                                          typeof val !== "object"
                                            ? errorMsg(errorCode.FE20)
                                            : undefined
                                        )
                                      }
                                      errorText={
                                        nomiDetails[index]?.error?.nomTitle
                                      }
                                      searchKey="display"
                                      searchLength={0}
                                      isDownArrow
                                      placeholder="Mr."
                                      disableTick
                                    />
                                  </div>
                                  <div className="nomName">
                                    <InputField
                                      id={`nomFullName-${index}`}
                                      required
                                      alphabate
                                      onBlur={(error) =>
                                        handleAddNomineeError(
                                          index,
                                          "nomFullName",
                                          error.required
                                            ?
                                            errorMsg(errorCode.FE35)
                                            : undefined
                                        )
                                      }
                                      errorText={
                                        nomiDetails[index]?.error?.nomFullName
                                      }
                                      defaultValue={nomiDetails[index]?.nomFullName}
                                      onChange={(val) => {
                                        handleAddNomineeValue(
                                          "nomFullName",
                                          index,
                                          capitalizeWords(val)
                                        );
                                      }}
                                      type="text"
                                      placeholder="Eg. Name"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="mgt40">
                                <label className="fieldLbl" htmlFor={`nomEmail-${index}`}>Email (Optional)</label>
                                <div className="">
                                  <InputField id={`nomEmail-${index}`}
                                    errorText={
                                      nomiDetails[index]?.error?.nomEmail
                                    }
                                    defaultValue={nomiDetails[index]?.nomEmail}
                                    onBlur={() => {
                                      const value = nomiDetails[index]?.nomEmail;

                                      let errorMessage;
                                      if (value && !emailRegex.test(value)) {
                                        errorMessage = errorMsg(errorCode.FE50);
                                      }

                                      handleAddNomineeError(index, "nomEmail", errorMessage);
                                    }}
                                    onChange={(val) => {
                                      handleAddNomineeValue(
                                        "nomEmail",
                                        index,
                                        val
                                      );
                                    }}
                                    type="text"
                                    placeholder="Eg. test@gmail.com"
                                  />
                                </div>
                                <p className="sectionLbl" style={{ fontStyle: "italic" }}>
                                  Details are pre-filled; you can edit the details
                                </p>
                              </div>
                              <div className="mgt40">
                                <label className="fieldLbl" htmlFor={`nomMobile-${index}`}>Mobile (Optional)</label>
                                <div className="">
                                  <InputField id={`nomMobile-${index}`}
                                    onBlur={() => {
                                      const value = nomiDetails[index]?.nomMobile;
                                      const mobileRegex = /^[6-9]\d{9}$/;

                                      let errorMessage;
                                      if (value && !mobileRegex.test(value)) {
                                        errorMessage = errorMsg(errorCode.FE08);
                                      }

                                      handleAddNomineeError(index, "nomMobile", errorMessage);
                                    }}

                                    errorText={
                                      nomiDetails[index]?.error?.nomMobile
                                    }
                                    defaultValue={nomiDetails[index]?.nomMobile}
                                    onChange={(val) => {
                                      handleAddNomineeValue(
                                        "nomMobile",
                                        index,
                                        val
                                      );
                                    }}
                                    type="tel"
                                    placeholder="Eg. 99999999999"
                                    maxLength={10}
                                  />
                                </div>
                                <p className="sectionLbl" style={{ fontStyle: "italic" }}>
                                  Details are pre-filled; you can edit the details
                                </p>
                              </div>
                              <div className="mgt40">
                                <label className="fieldLbl" htmlFor={`nomRelation-${index}`}>Relation</label>
                                <DropdownSearch id={`nomRelation-${index}`}
                                  name="nomRelation"
                                  defaultValue={
                                    relationshipList.find(
                                      (item) =>
                                        item.value ===
                                        nomiDetails[index]?.nomRelation
                                    )?.display
                                  }
                                  onOptionSelect={(val) => {
                                    handleAddNomineeValue(
                                      "nomRelation",
                                      index,
                                      val["value"] as string
                                    );
                                  }}
                                  searchLength={0}
                                  options={relationshipList}
                                  onBlur={(val) =>
                                    handleAddNomineeError(
                                      index,
                                      "nomRelation",
                                      typeof val !== "object"
                                        ? // ? 'Please select from dropdown'
                                        errorMsg(errorCode.FE24)
                                        : undefined
                                    )
                                  }
                                  errorText={nomiDetails[index]?.error?.nomRelation}
                                  searchKey="display"
                                  placeholder="Eg. Father"
                                  noDataMsg="Relation with similar name not found"
                                  isDownArrow={true}
                                />
                              </div>
                              {nomRelation === "13" && (
                                <div className="mgt40">
                                  <label className="fieldLbl" htmlFor={`nomOtherRelation-${index}`}>Other</label>
                                  <InputField id={`nomOtherRelation-${index}`}
                                    required
                                    onBlur={(error) =>
                                      handleAddNomineeError(
                                        index,
                                        "nomOtherRelation",
                                        error.required
                                          ? errorMsg(errorCode.FE37)
                                          : ""
                                      )
                                    }
                                    errorText={
                                      nomiDetails[index]?.error?.nomOtherRelation
                                    }
                                    onChange={(value) =>
                                      handleAddNomineeValue(
                                        "nomOtherRelation",
                                        index,
                                        value
                                      )
                                    }
                                    type="text"
                                    placeholder="Eg. Niece"
                                  />
                                </div>
                              )}
                              {/* Nominee Address Start */}
                              <AddressField
                                forNomineeAddress={true}
                                addressObj={nomiDetails[index]?.nomineeAddress}
                                isDisable={false}
                                sectionLabel="Nominee Addr. (Optional)"
                                addressType="nominee"
                                setErrCode={setErrCode}
                                onAddressChange={(value) =>
                                  handleAddNomineeValue(
                                    "nomineeAddress",
                                    index,
                                    value
                                  )
                                }
                                onAddressBlur={() => { }}
                                handleSameAsAbove={() => { }}
                              />
                              {/* Nominee Address End */}

                              {/* Nominee sharing per start */}
                              <div className="mgt40">
                                <label className="fieldLbl" htmlFor={`nomPerSharing-${index}`}>
                                  Nominee % sharing
                                </label>
                                <InputField id={`nomPerSharing-${index}`}
                                  integer
                                  maxLength={3}
                                  min={0}
                                  max={100}
                                  onBlur={(error) => {
                                    const value = nomiDetails[index]?.nomPerSharing;
                                    const isEmpty =
                                      value === undefined ||
                                      value === null ||
                                      String(value).trim() === "";
                                    handleAddNomineeError(
                                      index,
                                      "nomPerSharing",
                                      isEmpty
                                        ? errorMsg(errorCode.FE20)
                                        : (error.min || error.max)
                                          ? errorMsg(errorCode.FE26)
                                          : ""
                                    );
                                  }}
                                  errorText={
                                    nomiDetails[index]?.error?.nomPerSharing || ""
                                  }
                                  onChange={(value) => {
                                    setGlobalError("");
                                    handleAddNomineeValue(
                                      "nomPerSharing",
                                      index,
                                      value
                                    );
                                  }}
                                  type="text"
                                  placeholder="100"
                                  defaultValue={nomiDetails[index]?.nomPerSharing}
                                />
                              </div>
                              {/* Nominee sharing per end */}

                              {/* start nominee upload photo */}
                              <div className="mgt40">
                                <label className="fieldLbl" htmlFor={`identificationDetail-${index}`}>
                                  Additional identification Details (Optional)
                                </label>
                                <DropdownSearch id={`identificationDetail-${index}`}
                                  name="identificationDetail"
                                  defaultValue={
                                    nomineeIdentificationList.find(
                                      (item) =>
                                        item.display ===
                                        nomiDetails[index]?.identificationDetail
                                          ?.name
                                    )?.display
                                  }
                                  onOptionSelect={
                                    (val) =>
                                      handleAddNomineeValue(
                                        "identificationDetail",
                                        index,
                                        val as number
                                      )

                                    // setNomIdentification(val['value'] as number)
                                  }
                                  searchLength={0}
                                  options={nomineeIdentificationList}
                                  onBlur={() =>
                                    handleAddNomineeError(
                                      index,
                                      "identificationDetail",
                                      undefined
                                    )
                                  }
                                  errorText={
                                    nomiDetails[index]?.error?.identificationDetail
                                  }
                                  searchKey="display"
                                  placeholder="Eg. Adhar"
                                  isDownArrow={true}
                                />
                              </div>

                              {/* {nomiDetails[index]?.identificationDetail?.name ===
                            "Photo and Signature of the Nominee/guardian" && (
                            <div className="mgt40">
                              <p>Photo</p>
                            
                              {!isEditMode && (
                                <DocumentBrowse
                                  id="nomPhotoId"
                                  docObj={nomPhotoId}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onPanDocUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index,
                                      false
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "nomPhotoId",
                                      removeDocObj
                                    )
                                  }
                                />
                              )}
                              {(nomineeDocumentsArray[index]?.photo
                                ?.uploadPer == 100 ||
                                nomineeDocumentsArray[index]?.photo
                                  ?.uploadPer == 0) &&
                                isEditMode && (
                                  <DocumentBrowse
                                    id="nomPhotoId"
                                    docObj={nomineeDocumentsArray[index].photo}
                                    onDocUploadComplete={(
                                      val,
                                      fileName,
                                      id,
                                      type
                                    ) =>
                                      onPanDocUploadComplete(
                                        val,
                                        fileName,
                                        id,
                                        type,
                                        index,
                                        false
                                      )
                                    }
                                    isRemove={(removeDocObj) =>
                                      handleRemoveDoc(
                                        index,
                                        "nomPhotoId",
                                        removeDocObj
                                      )
                                    }
                                  />
                                )}
                              <p>Signature</p>
                              {!isEditMode && (
                                <DocumentBrowse
                                  id="nomSignature"
                                  docObj={nomPhotoId}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onPanDocUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index,
                                      false
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "nomSignature",
                                      removeDocObj
                                    )
                                  }
                                />
                              )}
                              {(nomineeDocumentsArray[index]?.signature
                                ?.uploadPer == 100 ||
                                nomineeDocumentsArray[index]?.signature
                                  ?.uploadPer == 0) &&
                                isEditMode && (
                                  <DocumentBrowse
                                    id="nomSignature"
                                    docObj={
                                      nomineeDocumentsArray[index].signature
                                    }
                                    onDocUploadComplete={(
                                      val,
                                      fileName,
                                      id,
                                      type
                                    ) =>
                                      onPanDocUploadComplete(
                                        val,
                                        fileName,
                                        id,
                                        type,
                                        index,
                                        false
                                      )
                                    }
                                    isRemove={(removeDocObj) =>
                                      handleRemoveDoc(
                                        index,
                                        "nomSignature",
                                        removeDocObj
                                      )
                                    }
                                  />
                                )}
                            </div>
                          )} */}

                              {nomiDetails[index]?.identificationDetail?.name ===
                                "Aadhar Card no" && (
                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`identificationDetailValue-${index}`}>
                                      Enter the last four digit of Adhar Number
                                    </label>
                                    <InputField id={`identificationDetailValue-${index}`}
                                      integer
                                      required
                                      maxLength={4}
                                      pattern={/^\d{4}$/}
                                      type="text"
                                      placeholder="Eg. 1234"
                                      onBlur={(error) =>
                                        handleAddNomineeError(
                                          index,
                                          "identificationDetailValue",
                                          error.required ||
                                            nomiDetails[index]?.identificationDetail
                                              ?.value?.length < 4
                                            ? // ? 'Please Enter last four digit of Adhar number'
                                            errorMsg(errorCode.FE25)
                                            : undefined
                                        )
                                      }
                                      errorText={
                                        nomiDetails[index]?.error
                                          ?.identificationDetailValue
                                      }
                                      defaultValue={
                                        nomiDetails[index]?.identificationDetail
                                          ?.value
                                      }
                                      onChange={(val) =>
                                        handleAddNomineeValue(
                                          "identificationDetailValue",
                                          index,
                                          val
                                        )
                                      }
                                    />
                                  </div>
                                )}
                              {nomiDetails[index]?.identificationDetail?.name ===
                                "Saving Bank account no." && (
                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`identificationDetailValue-${index}`}>
                                      Enter the Bank account Number
                                    </label>
                                    <InputField id={`identificationDetailValue-${index}`}
                                      integer
                                      required
                                      type="text"
                                      maxLength={18}
                                      onBlur={(error) =>
                                        handleAddNomineeError(
                                          index,
                                          "identificationDetailValue",
                                          error.required ||
                                            nomiDetails[index]?.identificationDetail
                                              ?.value?.length < 8
                                            ? // ? 'Please enter minimum 8 or maximum 18'
                                            errorMsg(errorCode.FE25)
                                            : ""
                                        )
                                      }
                                      errorText={
                                        nomiDetails[index]?.error
                                          ?.identificationDetailValue
                                      }
                                      defaultValue={
                                        nomiDetails[index]?.identificationDetail
                                          ?.value
                                      }
                                      onChange={(val) =>
                                        handleAddNomineeValue(
                                          "identificationDetailValue",
                                          index,
                                          val
                                        )
                                      }
                                      placeholder="Eg. 18273946573849"
                                    />
                                  </div>
                                )}
                              {nomiDetails[index]?.identificationDetail?.name ===
                                "Demat Account ID" && (
                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`identificationDetailValue-${index}`}>
                                      Enter the demat account Number
                                    </label>
                                    <InputField id={`identificationDetailValue-${index}`}
                                      integer
                                      required
                                      type="text"
                                      maxLength={18}
                                      onBlur={(error) =>
                                        handleAddNomineeError(
                                          index,
                                          "identificationDetailValue",
                                          error.required ||
                                            nomiDetails[index]?.identificationDetail
                                              ?.value?.length < 8
                                            ? // ? 'Please enter minimum 8 or maximum 18'
                                            errorMsg(errorCode.FE25)
                                            : ""
                                        )
                                      }
                                      errorText={
                                        nomiDetails[index]?.error
                                          ?.identificationDetailValue
                                      }
                                      defaultValue={
                                        nomiDetails[index]?.identificationDetail
                                          ?.value
                                      }
                                      onChange={(val) =>
                                        handleAddNomineeValue(
                                          "identificationDetailValue",
                                          index,
                                          val
                                        )
                                      }
                                      placeholder="Eg. 18273946573849"
                                    />
                                  </div>
                                )}
                              {nomiDetails[index]?.identificationDetail?.name ===
                                "PAN Card no" && (
                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`identificationDetailValue-${index}`}>Enter PAN</label>
                                    <InputField id={`identificationDetailValue-${index}`}
                                      className="nomPanNum"
                                      required
                                      pattern={pan}
                                      maxLength={10}
                                      suffix={
                                        validPan[index] &&
                                          nomiDetails[index]?.identificationDetail
                                            ?.value !== null &&
                                          nomiDetails[index]?.identificationDetail
                                            ?.value !== undefined ? (
                                          <i className="edel-icon-tick" aria-hidden="true" />
                                        ) : (
                                          <></>
                                        )
                                      }
                                      defaultValue={
                                        nomiDetails[index]?.identificationDetail
                                          ?.value
                                      }
                                      onChange={(val) =>
                                        handleAddNomineeValue(
                                          "identificationDetailValue",
                                          index,
                                          val.toUpperCase()
                                        )
                                      }
                                      onBlur={(error) =>
                                        onBlurPan(
                                          error,
                                          index,
                                          "identificationDetailValue"
                                        )
                                      }
                                      type="text"
                                      placeholder="Eg. ABCDE1234F"
                                      errorText={
                                        nomiDetails[index]?.error
                                          ?.identificationDetailValue
                                      }
                                    />
                                  </div>
                                )}
                              {/* nominee upload photo end */}

                              <div className="mgt40">
                                <label className="fieldLbl" id={`nominee-dob-label-${index}`} htmlFor={`nominee-dob-${index}`}>
                                  Nominee Date Of Birth
                                </label>
                                {/* DOB start */}

                                <Calender
                                  id={`nominee-dob-${index}`}
                                  ariaLabel="Nominee Date Of Birth"
                                  ariaLabelledBy={`nominee-dob-label-${index}`}
                                  ariaDescribedBy={nomiDetails[index]?.error?.nomDob ? `nominee-dob-error-${index}` : undefined}
                                  errorText={nomiDetails[index]?.error?.nomDob}
                                  onDateSelect={(date) => {
                                    console.log("on select called", date);
                                    handleAddNomineeValue("nomDob", index, date);
                                  }}
                                  defaultDate={
                                    nomiDetails[index]?.nomDob
                                      ? new Date(nomiDetails[index]?.nomDob)
                                      : undefined
                                  }
                                  placeholderText={"Select Date of Birth"}
                                  maxDate={new Date()}
                                  minDate={
                                    new Date(
                                      new Date().setFullYear(
                                        new Date().getFullYear() - 100
                                      )
                                    )
                                  }
                                  onBlur={(e) => {
                                    console.log("on blur called", e);
                                    handleAddNomineeError(
                                      index,
                                      "nomDob",
                                      errorMsg(errorCode.FE27)
                                    );
                                  }}
                                  isError={
                                    nomiDetails[index]?.error?.nomDob ? true : false
                                  }
                                />
                                {nomiDetails[index]?.error?.nomDob && (
                                  <p id={`nominee-dob-error-${index}`} className="errorMsg" role="alert" aria-live="assertive">
                                    {nomiDetails[index]?.error?.nomDob}
                                  </p>
                                )}
                                {/* DOB end */}
                              </div>

                              {/* Guardian Details Start */}
                              {nomiDetails[index]?.isNomineeMinor && (
                                <>
                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`guardFullName-${index}`}>
                                      Guardian Full Name
                                    </label>
                                    <div className="flexDiv">
                                      <div className="titleSelect">
                                        <DropdownSearch id={`guardTitle-${index}`}
                                          name="guardTitle"
                                          defaultValue={
                                            titlePrefixList.find(
                                              (item) =>
                                                item.value ===
                                                nomiDetails[index][
                                                  "guardianDetails"
                                                ]?.guardTitle
                                            )?.display
                                          }
                                          onOptionSelect={(val) =>
                                            handleAddNomineeGuardianValue(
                                              "guardTitle",
                                              index,
                                              val["value"] as string
                                            )
                                          }
                                          options={titlePrefixList}
                                          onBlur={() =>
                                            handleAddNomineeError(
                                              index,
                                              "guardTitle",
                                              undefined
                                            )
                                          }
                                          errorText={
                                            nomiDetails[index]?.error?.guardTitle
                                          }
                                          searchKey="display"
                                          searchLength={0}
                                          isDownArrow
                                          placeholder="Mr."
                                          disableTick
                                        />
                                      </div>
                                      <div className="nomName">
                                        <InputField
                                          id={`guardFullName-${index}`}
                                          alphabate
                                          onBlur={() => {
                                            const value =
                                              nomiDetails[index]?.guardianDetails
                                                ?.guardFullName;
                                            handleAddNomineeError(
                                              index,
                                              "guardFullName",
                                              !value || String(value).trim() === ""
                                                ? errorMsg(errorCode.FE20)
                                                : ""
                                            );
                                          }}
                                          errorText={
                                            nomiDetails[index]?.error?.guardFullName
                                          }
                                          defaultValue={
                                            nomiDetails[index]?.guardianDetails
                                              ?.guardFullName
                                          }
                                          onChange={(val) =>
                                            handleAddNomineeGuardianValue(
                                              "guardFullName",
                                              index,
                                              capitalizeWords(val)
                                            )
                                          }
                                          type="text"
                                          placeholder="Eg. Rajesh Agarwal"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`guardRelation-${index}`}>
                                      Guardian’s Relation
                                    </label>
                                    <DropdownSearch id={`guardRelation-${index}`}
                                      name="guardRelation"
                                      defaultValue={
                                        relationshipList.find(
                                          (item) =>
                                            item.value ===
                                            nomiDetails[index]["guardianDetails"]
                                              ?.guardRelation
                                        )?.display
                                      }
                                      onOptionSelect={(val) =>
                                        // setGuardRelation(val['value'] as string)
                                        handleAddNomineeGuardianValue(
                                          "guardRelation",
                                          index,
                                          val["value"] as string
                                        )
                                      }
                                      searchLength={0}
                                      options={relationshipList}
                                      onBlur={(val) =>
                                        // dropDownBlur('guardRelation', val)
                                        handleAddNomineeError(
                                          index,
                                          "guardRelation",
                                          typeof val !== "object"
                                            ? // ? 'Please select from dropdown'
                                            errorMsg(errorCode.FE24)
                                            : undefined
                                        )
                                      }
                                      errorText={
                                        nomiDetails[index]?.error?.guardRelation
                                      }
                                      searchKey="display"
                                      placeholder="Eg. Father"
                                      noDataMsg="Relation with similar name not found"
                                      isDownArrow={true}
                                    />
                                  </div>
                                  {guardRelation === "13" && (
                                    <div className="mgt40">
                                      <label className="fieldLbl" htmlFor={`guardOtherRelation-${index}`}>Other</label>
                                      <InputField id={`guardOtherRelation-${index}`}
                                        required
                                        onBlur={(error) => {
                                          handleAddNomineeError(
                                            index,
                                            "guardOtherRelation",
                                            error.required
                                              ? errorMsg(errorCode.FE42)
                                              : ""
                                          );
                                        }}
                                        errorText={
                                          nomiDetails[index]?.error
                                            ?.guardOtherRelation
                                        }
                                        onChange={(val) =>
                                          handleAddNomineeGuardianValue(
                                            "guardOtherRelation",
                                            index,
                                            val
                                          )
                                        }
                                        type="text"
                                        placeholder="Eg. Niece"
                                      />
                                    </div>
                                  )}
                                  {/* Guardian’s Address Start */}
                                  <AddressField
                                    forNomineeAddress={true}
                                    addressObj={
                                      nomiDetails[index]?.guardianDetails
                                        ?.guardianAddress
                                    }
                                    isDisable={false}
                                    sectionLabel="Guardian Addr."
                                    addressType="guardian"
                                    setErrCode={setErrCode}
                                    onAddressChange={(val) =>
                                      handleAddNomineeGuardianValue(
                                        "guardianAddress",
                                        index,
                                        val
                                      )
                                    }
                                    onAddressBlur={setGuardErrorObj}
                                    showSameAsAbove
                                    sameAsAbove={
                                      nomiDetails[index]?.guardianDetails
                                        ?.sameAsNominee
                                    }
                                    handleSameAsAbove={(event) =>
                                      handleSameAsAboveForGaurdian(event, index)
                                    }
                                  />
                                  {/* Guardian’s Address End */}

                                  {/* start nominee upload photo */}
                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`guardidentificationDetail-${index}`}>
                                      Additional identification Details
                                    </label>
                                    <DropdownSearch id={`guardidentificationDetail-${index}`}
                                      name="guardidentificationDetail"
                                      defaultValue={
                                        tempNom.find(
                                          (item) =>
                                            item.display ===
                                            nomiDetails[index]["guardianDetails"]
                                              ?.identificationDetail?.name
                                        )?.display
                                      }
                                      onOptionSelect={(val) =>
                                        handleAddNomineeGuardianValue(
                                          "identificationDetail",
                                          index,
                                          val as number
                                        )
                                      }
                                      searchLength={0}
                                      options={tempNom}
                                      onBlur={() =>
                                        handleAddNomineeError(
                                          index,
                                          "guardidentificationDetail",
                                          undefined
                                        )
                                      }
                                      errorText={
                                        nomiDetails[index]?.error
                                          ?.guardidentificationDetail
                                      }
                                      searchKey="display"
                                      placeholder="Eg. Adhar"
                                      isDownArrow={true}
                                    />
                                  </div>

                                  {/* {nomiDetails[index]["guardianDetails"]
                                ?.identificationDetail?.name ===
                                "Photo and Signature of the Nominee/guardian" && (
                                <div className="mgt40">
                                  <p>Photo</p>
                                  {!isEditMode && (
                                    <DocumentBrowse
                                      id="guardianPhotoId"
                                      docObj={nomPhotoId}
                                      onDocUploadComplete={(
                                        val,
                                        fileName,
                                        id,
                                        type
                                      ) =>
                                        onPanDocUploadComplete(
                                          val,
                                          fileName,
                                          id,
                                          type,
                                          index,
                                          true
                                        )
                                      }
                                      isRemove={(removeDocObj) =>
                                        handleRemoveDoc(
                                          index,
                                          "guardianPhotoId",
                                          removeDocObj
                                        )
                                      }
                                    />
                                  )}{" "}
                                  {(nomineeDocumentsArray[index]
                                    ?.guardianDetails?.photo?.uploadPer ==
                                    100 ||
                                    nomineeDocumentsArray[index]
                                      ?.guardianDetails?.photo?.uploadPer ==
                                      0) &&
                                    isEditMode && (
                                      <DocumentBrowse
                                        id="guardianPhotoId"
                                        docObj={
                                          nomineeDocumentsArray[index]
                                            ?.guardianDetails?.photo
                                        }
                                        onDocUploadComplete={(
                                          val,
                                          fileName,
                                          id,
                                          type
                                        ) =>
                                          onPanDocUploadComplete(
                                            val,
                                            fileName,
                                            id,
                                            type,
                                            index,
                                            true
                                          )
                                        }
                                        isRemove={(removeDocObj) =>
                                          handleRemoveDoc(
                                            index,
                                            "guardianPhotoId",
                                            removeDocObj
                                          )
                                        }
                                      />
                                    )}
                                  <p>Signature</p>
                                  {!isEditMode && (
                                    <DocumentBrowse
                                      id="guardianSignature"
                                      docObj={nomPhotoId}
                                      onDocUploadComplete={(
                                        val,
                                        fileName,
                                        id,
                                        type
                                      ) =>
                                        onPanDocUploadComplete(
                                          val,
                                          fileName,
                                          id,
                                          type,
                                          index,
                                          true
                                        )
                                      }
                                      isRemove={(removeDocObj) =>
                                        handleRemoveDoc(
                                          index,
                                          "guardianSignature",
                                          removeDocObj
                                        )
                                      }
                                    />
                                  )}{" "}
                                  {(nomineeDocumentsArray[index]
                                    ?.guardianDetails?.signature?.uploadPer ==
                                    100 ||
                                    nomineeDocumentsArray[index]
                                      ?.guardianDetails?.signature?.uploadPer ==
                                      0) &&
                                    isEditMode && (
                                      <DocumentBrowse
                                        id="guardianSignature"
                                        docObj={
                                          nomineeDocumentsArray[index]
                                            ?.guardianDetails?.signature
                                        }
                                        onDocUploadComplete={(
                                          val,
                                          fileName,
                                          id,
                                          type
                                        ) =>
                                          onPanDocUploadComplete(
                                            val,
                                            fileName,
                                            id,
                                            type,
                                            index,
                                            true
                                          )
                                        }
                                        isRemove={(removeDocObj) =>
                                          handleRemoveDoc(
                                            index,
                                            "guardianSignature",
                                            removeDocObj
                                          )
                                        }
                                      />
                                    )}
                                </div>
                              )} */}
                                  {nomiDetails[index]["guardianDetails"]
                                    ?.identificationDetail?.name ===
                                    "Aadhar Card no" && (
                                      <div className="mgt40">
                                        <label className="fieldLbl" htmlFor={`identificationDetailValue-${index}`}>
                                          Enter the last four digit of Adhar Number
                                        </label>
                                        <InputField id={`identificationDetailValue-${index}`}
                                          integer
                                          maxLength={4}
                                          pattern={/^\d{4}$/}
                                          type="text"
                                          placeholder="Eg. 1234"
                                          onBlur={(val) =>
                                            handleAddNomineeError(
                                              index,
                                              "guardIdentificationDetailValue",
                                              !val.pattern
                                                ? errorMsg(errorCode.FE41)
                                                : undefined
                                            )
                                          }
                                          errorText={
                                            nomiDetails[index]?.error
                                              ?.guardIdentificationDetailValue
                                          }
                                          defaultValue={
                                            nomiDetails[index]["guardianDetails"]
                                              ?.identificationDetail?.value
                                          }
                                          onChange={(val) =>
                                            handleAddNomineeGuardianValue(
                                              "guardIdentificationDetailValue",
                                              index,
                                              val
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                  {nomiDetails[index]["guardianDetails"]
                                    ?.identificationDetail?.name ===
                                    "Saving Bank account no." && (
                                      <div className="mgt40">
                                        <label className="fieldLbl" htmlFor={`identificationDetailValue-${index}`}>
                                          Enter the Bank account Number
                                        </label>
                                        <InputField id={`identificationDetailValue-${index}`}
                                          integer
                                          required
                                          type="text"
                                          maxLength={18}
                                          onBlur={(error) =>
                                            setErrors({
                                              ...errors,
                                              guardIdentificationDetailValue:
                                                error.required ||
                                                  nomiDetails[index]["guardianDetails"]
                                                    ?.identificationDetail?.value
                                                    ?.length < 8
                                                  ? errorMsg(errorCode.FE40)
                                                  : "",
                                            })
                                          }
                                          errorText={
                                            errors.guardIdentificationDetailValue
                                          }
                                          defaultValue={
                                            nomiDetails[index]["guardianDetails"]
                                              ?.identificationDetail?.value
                                          }
                                          onChange={(val) =>
                                            handleAddNomineeGuardianValue(
                                              "guardIdentificationDetailValue",
                                              index,
                                              val
                                            )
                                          }
                                          placeholder="Eg. 18273946573849"
                                        />
                                      </div>
                                    )}
                                  {nomiDetails[index]["guardianDetails"]
                                    ?.identificationDetail?.name ===
                                    "Demat Account ID" && (
                                      <div className="mgt40">
                                        <label className="fieldLbl" htmlFor={`identificationDetailValue-${index}`}>
                                          Enter the demat account Number
                                        </label>
                                        <InputField id={`identificationDetailValue-${index}`}
                                          integer
                                          required
                                          type="text"
                                          maxLength={18}
                                          onBlur={(error, event) => {
                                            if (
                                              event?.target?.value !== undefined &&
                                              event?.target?.value !== null &&
                                              event?.target?.value !== "" &&
                                              event?.target?.value?.length > 8 &&
                                              event?.target?.value?.length < 18
                                            ) {
                                              setErrors({
                                                ...errors,
                                                guardIdentificationDetailValue: "",
                                              });
                                            } else {
                                              if (error.required) {
                                                setErrors({
                                                  ...errors,
                                                  guardIdentificationDetailValue:
                                                    errorMsg(errorCode.FE40),
                                                });
                                              } else if (
                                                event?.target?.value !== undefined &&
                                                event?.target?.value !== null &&
                                                event?.target?.value !== "" &&
                                                event?.target?.value?.length < 8
                                              ) {
                                                setErrors({
                                                  ...errors,
                                                  guardIdentificationDetailValue:
                                                    errorMsg(errorCode.FE40),
                                                });
                                              } else {
                                                setErrors({
                                                  ...errors,
                                                  guardIdentificationDetailValue: "",
                                                });
                                              }
                                            }
                                          }}
                                          errorText={
                                            errors.guardIdentificationDetailValue
                                          }
                                          defaultValue={
                                            nomiDetails[index]["guardianDetails"]
                                              ?.identificationDetail?.value
                                          }
                                          onChange={(val) =>
                                            handleAddNomineeGuardianValue(
                                              "guardIdentificationDetailValue",
                                              index,
                                              val
                                            )
                                          }
                                          placeholder="Eg. 18273946573849"
                                        />
                                      </div>
                                    )}
                                  {nomiDetails[index]["guardianDetails"]
                                    ?.identificationDetail?.name ===
                                    "PAN Card no" && (
                                      <div className="mgt40">
                                        <label className="fieldLbl" htmlFor={`identificationDetailValue-${index}`}>Enter PAN</label>
                                        <InputField id={`identificationDetailValue-${index}`}
                                          className="nomPanNum"
                                          required
                                          pattern={pan}
                                          maxLength={10}
                                          suffix={
                                            validPan[index] &&
                                              nomiDetails[index]["guardianDetails"]
                                                ?.identificationDetail?.value !==
                                              null &&
                                              nomiDetails[index]["guardianDetails"]
                                                ?.identificationDetail?.value !==
                                              undefined ? (
                                              <i className="edel-icon-tick" aria-hidden="true" />
                                            ) : (
                                              <></>
                                            )
                                          }
                                          defaultValue={
                                            nomiDetails[index]["guardianDetails"]
                                              ?.identificationDetail?.value
                                          }
                                          onChange={(val) =>
                                            handleAddNomineeGuardianValue(
                                              "guardIdentificationDetailValue",
                                              index,
                                              val.toUpperCase()
                                            )
                                          }
                                          onBlur={(error) =>
                                            onBlurPan(
                                              error,
                                              index,
                                              "guardIdentificationDetailValue"
                                            )
                                          }
                                          type="text"
                                          placeholder="Eg. ABCDE1234F"
                                          errorText={
                                            nomiDetails[index]?.error
                                              ?.guardIdentificationDetailValue
                                          }
                                        />
                                      </div>
                                    )}

                                  <div className="mgt40">
                                    <label className="fieldLbl" id={`guardian-dob-label-${index}`} htmlFor={`guardian-dob-${index}`}>
                                      Guardian Date Of Birth
                                    </label>
                                    {/* DOB start */}

                                    <Calender
                                      id={`guardian-dob-${index}`}
                                      ariaLabel="Guardian Date Of Birth"
                                      ariaLabelledBy={`guardian-dob-label-${index}`}
                                      ariaDescribedBy={
                                        nomiDetails[index]?.error?.guardianDetails?.dob || isGuardianMinor
                                          ? `guardian-dob-error-${index}`
                                          : undefined
                                      }
                                      errorText={nomiDetails[index]?.error?.guardianDetails?.dob}
                                      onDateSelect={(date) => {
                                        console.log("on select called", date);
                                        if (guardianMinororMajor(date)) {
                                          setIsGuardiaMinor(false);
                                          handleAddNomineeGuardianValue(
                                            "dob",
                                            index,
                                            date
                                          );
                                        } else setIsGuardiaMinor(true);
                                      }}
                                      defaultDate={
                                        nomiDetails[index]?.guardianDetails?.dob
                                          ? new Date(
                                            nomiDetails[
                                              index
                                            ]?.guardianDetails?.dob
                                          )
                                          : undefined
                                      }
                                      placeholderText={"Select Date of Birth"}
                                      maxDate={new Date()}
                                      minDate={
                                        new Date(
                                          new Date().setFullYear(
                                            new Date().getFullYear() - 100
                                          )
                                        )
                                      }
                                      onBlur={(e) => {
                                        console.log("on blur called", e);
                                        if (!nomiDetails[index]?.guardianDetails?.dob) {
                                          handleAddNomineeError(
                                            index,
                                            "dob",
                                            errorMsg(errorCode.FE27)
                                          );
                                        }
                                      }}
                                      isError={
                                        isGuardianMinor
                                          ? true
                                          : nomiDetails[index]?.error
                                            ?.guardianDetails?.dob
                                            ? true
                                            : false
                                      }
                                    />
                                    {nomiDetails[index]?.error?.guardianDetails
                                      ?.dob && (
                                        <p id={`guardian-dob-error-${index}`} className="errorMsg" role="alert" aria-live="assertive">
                                          {
                                            nomiDetails[index]?.error?.guardianDetails
                                              ?.dob
                                          }
                                        </p>
                                      )}
                                    {isGuardianMinor && (
                                      <p id={`guardian-dob-error-${index}`} className="errorMsg" role="alert" aria-live="assertive">
                                        Guardian should be major
                                      </p>
                                    )}
                                    {/* DOB end */}
                                  </div>
                                  {/* nominee upload photo end */}

                                  {/* Guardian Professional Details Start */}
                                  <div className="mgt80">
                                    <h2 className="prflFormHeading">
                                      Guardian’s Professional Details
                                    </h2>
                                  </div>

                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`guardEduQualification-${index}`}>
                                      Guardian’s Educational Qualification
                                    </label>
                                    <DropdownSearch id={`guardEduQualification-${index}`}
                                      name="guardEduQualification"
                                      defaultValue={
                                        educationList.find(
                                          (item) =>
                                            item.value ===
                                            nomiDetails[index]["guardianDetails"]
                                              ?.guardEduQualification
                                        )?.display
                                      }
                                      onOptionSelect={(val) =>
                                        // setGuardEduQulification(val['value'] as string)
                                        handleAddNomineeGuardianValue(
                                          "guardEduQualification",
                                          index,
                                          val["value"] as string
                                        )
                                      }
                                      searchLength={0}
                                      options={educationList}
                                      onBlur={(val) =>
                                        // dropDownBlur('guardRelation', val)
                                        handleAddNomineeError(
                                          index,
                                          "guardEduQualification",
                                          typeof val !== "object"
                                            ? errorMsg(errorCode.FE20)
                                            : undefined
                                        )
                                      }
                                      errorText={
                                        nomiDetails[index]?.error
                                          ?.guardEduQualification
                                      }
                                      searchKey="display"
                                      placeholder="Select Guardian’s Education Qualification"
                                      noDataMsg="Qualification with similar name not found"
                                      isDownArrow={true}
                                    />
                                  </div>

                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`guardOccupation-${index}`}>
                                      Guardian’s Occupation
                                    </label>
                                    <DropdownSearch id={`guardOccupation-${index}`}
                                      name="guardOccupation"
                                      defaultValue={
                                        occupationList.find(
                                          (item) =>
                                            item.value ===
                                            nomiDetails[index]["guardianDetails"]
                                              ?.guardOccupation
                                        )?.display
                                      }
                                      onOptionSelect={(val) =>
                                        // setGuardOccupation(val['value'] as string)
                                        handleAddNomineeGuardianValue(
                                          "guardOccupation",
                                          index,
                                          val["value"] as string
                                        )
                                      }
                                      searchLength={0}
                                      options={occupationList}
                                      onBlur={(val) =>
                                        // dropDownBlur('guardRelation', val)
                                        handleAddNomineeError(
                                          index,
                                          "guardOccupation",
                                          typeof val !== "object"
                                            ? errorMsg(errorCode.FE20)
                                            : undefined
                                        )
                                      }
                                      errorText={
                                        nomiDetails[index]?.error?.guardOccupation
                                      }
                                      searchKey="display"
                                      placeholder="Select Guardian’s Occupation"
                                      noDataMsg="Occupation with similar name not found"
                                      isDownArrow={true}
                                    />
                                  </div>

                                  <fieldset>
                                    <div className="mgt40">
                                      <legend className="fieldLbl">
                                        Politically Exposed Person
                                      </legend>
                                      <div className="fieldLblRight">
                                        <div className="explain">
                                          <button
                                            type="button"
                                            className="explainLbl"
                                            onMouseOver={() => setShowExplain(true)}
                                            onMouseLeave={() => setShowExplain(false)}
                                            onFocus={() => setShowExplain(true)}
                                            onBlur={() => setShowExplain(false)}
                                            aria-expanded={showExplain}
                                            aria-label="Explain Politically Exposed Person"
                                          >
                                            Explain
                                          </button>
                                          {showExplain && (
                                            <InfoModal
                                              width={
                                                DeviceContext().isMobile
                                                  ? "328px"
                                                  : "354px"
                                              }
                                            >
                                              <div className="explainInfo">
                                                <p>
                                                  A Politically Exposed Person or PEP
                                                  is someone who is either involved
                                                  with or closely associated to any
                                                  prominent public function or are
                                                  involved with political parties or
                                                  entities related to political
                                                  parties.
                                                </p>
                                              </div>
                                            </InfoModal>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="mgt20">
                                      <Radio
                                        checked={
                                          nomiDetails[index]["guardianDetails"]
                                            ?.guardPoliticalVal === "1"
                                        }
                                        onChange={() =>
                                          // setGuardPoliticalVal('1')
                                          handleAddNomineeGuardianValue(
                                            "guardPoliticalVal",
                                            index,
                                            "1"
                                          )
                                        }
                                        name={"guardPoliticalParty" + index}
                                        label="I am a Politically Exposed Person"
                                      />
                                      <Radio
                                        className="mgt14"
                                        checked={
                                          nomiDetails[index]["guardianDetails"]
                                            ?.guardPoliticalVal === "2"
                                        }
                                        onChange={() =>
                                          // setGuardPoliticalVal('2')
                                          handleAddNomineeGuardianValue(
                                            "guardPoliticalVal",
                                            index,
                                            "2"
                                          )
                                        }
                                        name={"guardPoliticalParty" + index}
                                        label="I am Related to Politically Exposed Person"
                                      />
                                      <Radio
                                        className="mgt14"
                                        checked={
                                          nomiDetails[index]["guardianDetails"]
                                            ?.guardPoliticalVal === "0"
                                        }
                                        onChange={() =>
                                          //  setGuardPoliticalVal('0')
                                          handleAddNomineeGuardianValue(
                                            "guardPoliticalVal",
                                            index,
                                            "0"
                                          )
                                        }
                                        name={"guardPoliticalParty" + index}
                                        label="None"
                                      />
                                    </div>
                                  </fieldset>

                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`guardAnnualIncome-${index}`}>
                                      Guardian’s Annual Income
                                    </label>
                                    <DropdownSearch id={`guardAnnualIncome-${index}`}
                                      name="guardAnnualIncome"
                                      defaultValue={
                                        incomeList.find(
                                          (item) =>
                                            item.value ===
                                            nomiDetails[index]["guardianDetails"]
                                              ?.guardAnnualIncome
                                        )?.display
                                      }
                                      onOptionSelect={(val) =>
                                        handleAddNomineeGuardianValue(
                                          "guardAnnualIncome",
                                          index,
                                          val["value"] as string
                                        )
                                      }
                                      onBlur={(val) =>
                                        handleAddNomineeError(
                                          index,
                                          "guardAnnualIncome",
                                          typeof val !== "object"
                                            ? errorMsg(errorCode.FE20)
                                            : undefined
                                        )
                                      }
                                      errorText={
                                        nomiDetails[index]?.error?.guardAnnualIncome
                                      }
                                      searchLength={0}
                                      options={incomeList}
                                      searchKey="display"
                                      placeholder="Select Guardian’s Annual Income Bracket"
                                      noDataMsg="Annual Income with similar name not found"
                                      isDownArrow={true}
                                    />
                                  </div>

                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`guardNetWorth-${index}`}>
                                      Guardian’s Net Worth
                                    </label>
                                    <InputField id={`guardNetWorth-${index}`}
                                      integer
                                      required
                                      maxLength={9}
                                      min={1001}
                                      defaultValue={
                                        nomiDetails[index]["guardianDetails"]
                                          ?.guardNetWorth
                                      }
                                      errorText={
                                        nomiDetails[index]?.error?.guardNetWorth
                                      }
                                      onChange={(val) =>
                                        handleAddNomineeGuardianValue(
                                          "guardNetWorth",
                                          index,
                                          val
                                        )
                                      }
                                      onBlur={(error) => {
                                        handleAddNomineeError(
                                          index,
                                          "guardNetWorth",
                                          error.required || error.min
                                            ? errorMsg(errorCode.FE28)
                                            : ""
                                        );
                                      }}
                                      placeholder="Eg. 30,00,000"
                                    />
                                  </div>

                                  <div className="mgt40">
                                    <label className="fieldLbl" htmlFor={`guardPlaceOfBirth-${index}`}>
                                      Guardian’s Place of birth
                                    </label>
                                    <DropdownSearch id={`guardPlaceOfBirth-${index}`}
                                      name="city"
                                      onOptionSelect={(val) =>
                                        handleAddNomineeGuardianValue(
                                          "guardPlaceOfBirth",
                                          index,
                                          val["CityName"] as string
                                        )
                                      }
                                      searchLength={3}
                                      options={cities}
                                      // onBlur={handleCityBlur}
                                      onBlur={(value) =>
                                        handleAddNomineeError(
                                          index,
                                          "guardPlaceOfBirth",
                                          typeof value !== "object"
                                            ? errorMsg(errorCode.FE29)
                                            : undefined
                                        )
                                      }
                                      errorText={
                                        nomiDetails[index]?.error?.guardPlaceOfBirth
                                      }
                                      searchKey="CityName"
                                      placeholder="Eg. Mumbai"
                                      noDataMsg="City with similar name not found"
                                      // errorText={errors.placeOfBirth}
                                      isDownArrow={false}
                                      autoSelectOff={true}
                                      defaultValue={
                                        nomiDetails[index]["guardianDetails"]
                                          ?.guardPlaceOfBirth
                                      }
                                    />
                                    {/* <InputField
                                                                    required
                                                                    defaultValue={guardPlaceOfBirth}
                                                                    onChange={(val) =>
                                                                        handleAddNomineeGuardianValue(
                                                                            'guardPlaceOfBirth',
                                                                            index,
                                                                            val
                                                                        )
                                                                    }
                                                                    onBlur={(error) =>
                                                                        handleAddNomineeError(
                                                                            index,
                                                                            'guardPlaceOfBirth',
                                                                            error.required
                                                                                ? 'Please Enter Place of Birth'
                                                                                : ''
                                                                        )
                                                                    }
                                                                    errorText={
                                                                        nomiDetails[index]?.error?.guardPlaceOfBirth
                                                                    }
                                                                    placeholder="Eg. Mumbai, Maharashtra"
                                                                    type="text"
                                                                /> */}
                                  </div>
                                  {/*Guardian Professional Details End */}
                                </>
                              )}
                              {/* Guardian Details End */}
                            </React.Fragment>
                          );
                        })}
                    </>
                  )}
                </>
              }
              <br></br>
              {/* Nominee Details End */}
              {/* Error Msg Start*/}
              {errCode && politicalVal == "0" && (
                <div className="errMsgBlck">
                  {/* {{ errCode }} */}
                  <ErrMsg>
                    <p>{errCode}</p>
                    {/* <label>We are facing some technical issue.</label>
                    <label>
                      Please try after sometime (error code:{errCode})
                    </label> */}
                  </ErrMsg>
                </div>
              )}
              {errCode && politicalVal != "0" && (
                <div className="errMsgBlck">
                  <ErrMsg>
                    <p>{errCode}</p>
                  </ErrMsg>
                </div>
              )}
              {globalError && (
                <div className="errMsgBlck">
                  <ErrMsg>{globalError}</ErrMsg>
                </div>
              )}
              {errorMatchDetails && (
                <div className="errMsgBlck">
                  <ErrMsg>{errorMatchDetails}</ErrMsg>
                </div>
              )}
              {genderError && (
                <div className="errMsgBlck" id="gender-error" role="alert" aria-live="assertive">
                  <ErrMsg>{genderError}</ErrMsg>
                </div>
              )}
              {SettlementError && (
                <div className="errMsgBlck">
                  <ErrMsg>{SettlementError}</ErrMsg>
                </div>
              )}
              {validationErrors && (
                <div className="errMsgBlck">
                  <ErrMsg>{validationErrors}</ErrMsg>
                </div>
              )}

              {/* Error Msg End*/}
              <div className="mgt40">
                <Button
                  type="submit"
                  btnName="Submit"
                  isLoading={isLoading}
                  onClick={(e) => handleSubmit(e)}
                  disabled={isOTCFlow
                    ? false :
                    shouldDisable() ||
                    !togSettlement ||
                    (errCode && politicalVal != "0") ||
                    SettlementError ||
                    errorMatchDetails ||
                    genderError !== "" ||
                    (!!showNominee &&
                      showNominee == true &&
                      !!globalError &&
                      globalError !== "" &&
                      globalError?.length > 0) ||
                    isGuardianMinor
                  }
                />
              </div>
            </>
          )}
        </fieldset>
      </form>
    </div>
  );
};

export default ProfileForm;
